msgid ""
msgstr ""
"POT-Creation-Date: 2023-11-10 13:15+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: fr\n"
"Project-Id-Version: izicvs-web-app\n"
"Report-Msgid-Bugs-To: \n"
"Plural-Forms: nplurals=2; plural=(n > 1);\n"
"X-Crowdin-Project: izicvs-web-app\n"
"X-Crowdin-Project-ID: 791214\n"
"X-Crowdin-Language: fr\n"
"X-Crowdin-File: /apps/client/src/locales/en-US/messages.po\n"
"X-Crowdin-File-ID: 72\n"
"Language-Team: French\n"
"PO-Revision-Date: 2025-06-13 10:41\n"
"Last-Translator: \n"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:171
msgid "You have enabled two-factor authentication successfully."
msgstr "Vous avez activé l'authentification à deux facteurs avec succès."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:105
msgid "\"{keyword}\" is already in your skills."
msgstr "« {keyword} » est déjà dans vos compétences."

#: apps/client/src/pages/home/sections/features/index.tsx:28
#: apps/client/src/pages/marketing/pricing/page.tsx:55
msgid "\"For You\" ranked feed"
msgstr "Feed « Pour vous » classé"

#: apps/client/src/pages/dashboard/applications/page.tsx:187
msgid "(no resume linked)"
msgstr "(aucun CV lié)"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:347
msgid "{0} new"
msgstr "{0} nouvelles"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:56
msgid "{0} of {1} AI tokens used this month."
msgstr "{0} sur {1} tokens IA utilisés ce mois-ci."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:352
msgid "{0} offers"
msgstr "{0} offres"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:108
msgid "{0} offers found across {1} sources."
msgstr "{0} offres trouvées sur {1} sources."

#: apps/client/src/pages/dashboard/organizations/page.tsx:528
msgid "{0} resumes"
msgstr "{0} CV"

#: apps/client/src/pages/dashboard/organizations/page.tsx:386
#: apps/client/src/pages/dashboard/organizations/page.tsx:943
msgid "{0} seats"
msgstr "{0} sièges"

#: apps/client/src/pages/dashboard/organizations/page.tsx:609
msgid "{0} seats on the {1} plan"
msgstr "{0} sièges sur le plan {1}"

#: apps/client/src/pages/dashboard/applications/page.tsx:189
#: apps/client/src/pages/dashboard/organizations/page.tsx:528
msgid "{0} sent"
msgstr "{0} envoyées"

#: apps/client/src/pages/dashboard/organizations/page.tsx:529
msgid "{0} tokens"
msgstr "{0} tokens"

#: apps/client/src/pages/dashboard/opportunities/_components/job-card.tsx:47
#: apps/client/src/pages/dashboard/opportunities/page.tsx:253
msgid "{fit}% match"
msgstr "{fit}% de match"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:395
msgid "{total} offers"
msgstr "{total} offres"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:395
msgid "{total} offers · ranked for you"
msgstr "{total} offres · classées pour vous"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:40
#~ msgid "{used} of {quota} AI actions used this month."
#~ msgstr "{used} sur {quota} actions IA utilisées ce mois-ci."

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:142
msgid "{value, plural, one {Column} other {Columns}}"
msgstr "{value, plural, one {Colonne} other {Colonnes}}"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:45
msgid "@alex_d"
msgstr "@alex_d"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:53
msgid "@emma_p"
msgstr "@emma_p"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:13
msgid "@jackwilson"
msgstr "@jackwilson"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:21
msgid "@marie_d"
msgstr "@marie_d"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:37
msgid "@sophia_r"
msgstr "@sophia_r"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:29
msgid "@thomas_c"
msgstr "@thomas_c"

#: apps/client/src/pages/marketing/pricing/page.tsx:261
msgid "/ seat"
msgstr "/ siège"

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:54
msgid "/ week"
msgstr "/ semaine"

#: apps/client/src/pages/home/components/footer.tsx:248
#~ msgid "©"
#~ msgstr "©"

#: apps/client/src/components/copyright.tsx:16
msgid "© 2025 <0>Nextilabs</0>"
msgstr "© 2025 <0>Nextilabs</0>"

#: apps/client/src/pages/home/sections/hero/index.tsx:130
#~ msgid "+35% response rate"
#~ msgstr "Taux de réponse +35%"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:221
msgid "+5K"
msgstr "+5K"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:20
msgid "<0>I built Izicvs mostly by myself during my spare time, with a lot of help from other great open-source contributors.</0><1>If you like the app and want to support keeping it free forever, please donate whatever you can afford to give.</1>"
msgstr "<0>J'ai construit My Live CV principalement par moi-même pendant mon temps libre, avec beaucoup d'aide de la part d'autres grands contributeurs open-source.</0><1>Si vous aimez l'application et que vous voulez contribuer à ce qu'elle reste gratuite pour toujours, donnez ce que vous pouvez vous permettre de donner.</1>"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:51
msgid "<0>I'm sure the app is not perfect, but I'd like for it to be.</0><1>If you faced any issues while creating your resume, or have an idea that would help you and other users in creating your resume more easily, drop an issue on the repository or send me an email about it.</1>"
msgstr "<0>Je suis sûre que l'application n'est pas parfaite, mais j'aimerais qu'elle le soit.</0><1>Si vous avez rencontré n'importe quel problème en créant votre CV, ou si vous avez une idée qui pourrait aider, vous ou les autres, à créer leurs Cv plus facilement, faite remonter l'idée sur le repository, ou envoyez moi un email.</1>"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:85
msgid "<0>The community has spent a lot of time writing the documentation for Izicvs, and I'm sure it will help you get started with the app.</0><1>There are also a lot of examples to help you get started, and features that you might not know about which could help you build your perfect resume.</1>"
msgstr "<0>La communauté a passé beaucoup de temps à écrire la documentation de My Live Cv, et je suis sûr qu'elle vous aidera à démarrer avec l'application.</0><1>Il y a aussi beaucoup d'exemples pour vous aider à démarrer, et des fonctionnalités que vous ne connaissez peut-être pas et qui pourraient vous aider à construire votre Cv parfait.</1>"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:140
msgid "<0>Two-factor authentication is currently disabled.</0> You can enable it by adding an authenticator app to your account."
msgstr "<0>L'authentification à deux facteurs est actuellement désactivée.</0> Vous pouvez l'activer en ajoutant une application d'authentification à votre compte."

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:133
msgid "<0>Two-factor authentication is enabled.</0> You will be asked to enter a code every time you sign in."
msgstr "<0>L'authentification à deux facteurs est activée.</0> Il vous sera demandé de saisir un code à chaque connexion."

#: apps/client/src/pages/home/sections/hero/index.tsx:122
#~ msgid "100% ATS Optimized"
#~ msgstr "100% ATS Optimisé"

#: apps/client/src/pages/marketing/pricing/page.tsx:38
#~ msgid "20 AI actions per month"
#~ msgstr "20 actions IA par mois"

#: apps/client/src/pages/home/sections/features/index.tsx:21
#~ msgid "360° Smart Customization"
#~ msgstr "Personnalisation intelligente à 360°"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:164
msgid "3x"
msgstr "3x"

#: apps/client/src/pages/home/sections/hero/index.tsx:68
#~ msgid "73% of applications are eliminated before being read - not yours."
#~ msgstr "73 % des demandes sont éliminées avant d'être lues - pas la vôtre."

#: apps/client/src/pages/home/sections/testimonials/index.tsx:165
msgid "86%"
msgstr "86%"

#: apps/client/src/pages/home/sections/features/index.tsx:51
msgid "90% of the work, done for you."
msgstr "90 % du travail, fait pour vous."

#: apps/client/src/pages/home/sections/testimonials/index.tsx:163
msgid "94%"
msgstr "94 %"

#: apps/client/src/pages/home/sections/faq/index.tsx:79
msgid "A \"For You\" feed that scores every job against your profile"
msgstr "Un fil « For You » qui évalue chaque offre par rapport à votre profil"

#: apps/client/src/pages/marketing/sitemap/page.tsx:18
msgid "A complete overview of our pages, all in one place."
msgstr "Un aperçu complet de nos pages, réunies en un seul endroit."

#: apps/client/src/pages/home/sections/features/index.tsx:64
msgid "A Kanban board of every application, from \"to apply\" to \"offer\"."
msgstr "Un tableau Kanban de chaque candidature, de « à postuler » à « offre »."

#: apps/client/src/pages/home/sections/faq/index.tsx:122
msgid "A Kanban tracker from \"to apply\" to \"offer\""
msgstr "Un suivi Kanban, de « à postuler » jusqu'à « offre »"

#: apps/client/src/pages/builder/_components/toolbar.tsx:54
#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:29
msgid "A link has been copied to your clipboard."
msgstr "Le lien a été copié dans votre presse-papiers."

#: apps/client/src/pages/home/page.tsx:22
#~ msgid "A modern and customizable resume builder"
#~ msgstr "Un générateur de CV moderne et personnalisable"

#: apps/client/src/pages/auth/forgot-password/page.tsx:57
msgid "A password reset link should have been sent to your inbox, if an account existed with the email you provided."
msgstr "Un lien de réinitialisation du mot de passe devrait être envoyé dans votre boîte de réception, si un compte existe avec l'adresse électronique que vous avez fournie."

#: apps/client/src/services/errors/translate-error.ts:43
msgid "A resume with this slug already exists, please pick a different unique identifier."
msgstr "Un CV avec ce slug existe déjà, veuillez choisir un identifiant unique différent."

#: apps/client/src/pages/home/sections/features/index.tsx:43
msgid "A rewritten resume and a bespoke cover letter for every job, never inventing anything."
msgstr "Un CV réécrit et une lettre sur mesure pour chaque offre, sans jamais rien inventer."

#: apps/client/src/pages/dashboard/jobs/page.tsx:392
msgid "A saved history of all your analyses"
msgstr "Un historique de toutes vos analyses"

#: apps/client/src/pages/home/sections/features/index.tsx:36
msgid "A strict ATS engine, a recruiter, a resume analyst and an interview coach review your fit for each job."
msgstr "Un moteur ATS strict, un recruteur, un analyste CV et un coach d'entretien évaluent votre adéquation à chaque offre."

#: apps/client/src/pages/home/sections/features/index.tsx:44
#~ msgid "A unique resume for each opportunity"
#~ msgstr "Un CV unique pour chaque opportunité"

#: apps/client/src/services/errors/translate-error.ts:10
msgid "A user with this email address and/or username already exists."
msgstr "Un compte avec cette adresse mail et/ou ce nom d'utilisateur existe déjà."

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:43
msgid "A4"
msgstr "A4"

#: apps/client/src/pages/home/components/footer.tsx:179
#: apps/client/src/pages/marketing/about/page.tsx:38
#: apps/client/src/pages/marketing/about/page.tsx:42
#: apps/client/src/pages/marketing/sitemap/page.tsx:78
msgid "About"
msgstr "À propos"

#: apps/client/src/pages/marketing/about/page.tsx:35
msgid "About Izicvs"
msgstr "À propos d'Izicvs"

#: apps/client/src/pages/marketing/terms/page.tsx:28
msgid "Acceptable use"
msgstr "Utilisation acceptable"

#: apps/client/src/pages/marketing/terms/page.tsx:16
msgid "Acceptance of terms"
msgstr "Acceptation des conditions"

#. Helper text to let the user know what filetypes are accepted. {accept} can be .pdf or .json.
#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:266
msgid "Accepts only {accept} files"
msgstr "Accepte uniquement les fichiers {accept}"

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:105
msgid "Account"
msgstr "Compte"

#: apps/client/src/pages/marketing/help/page.tsx:32
msgid "Account and billing"
msgstr "Compte et facturation"

#: apps/client/src/pages/marketing/privacy/page.tsx:22
msgid "Account information, such as your name, email address, and authentication details."
msgstr "Les informations de compte, telles que votre nom, votre adresse e-mail et vos données d'authentification."

#: apps/client/src/pages/marketing/contact/page.tsx:51
msgid "Account support"
msgstr "Assistance liée au compte"

#: apps/client/src/pages/marketing/terms/page.tsx:22
msgid "Accounts and eligibility"
msgstr "Comptes et éligibilité"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:76
#: apps/client/src/pages/dashboard/jobs/page.tsx:186
msgid "Action verbs"
msgstr "Verbes d'action"

#: apps/client/src/pages/dashboard/organizations/page.tsx:629
msgid "Activate billing"
msgstr "Activer la facturation"

#: apps/client/src/pages/dashboard/organizations/page.tsx:616
msgid "Activate per-seat billing so members keep their plan."
msgstr "Activez la facturation par siège pour que les membres gardent leur plan."

#: apps/client/src/pages/home/sections/features/index.tsx:43
#~ msgid "Adaptable resumes for different sectors and professional styles"
#~ msgstr "Reprises adaptables pour différents secteurs et styles professionnels"

#: apps/client/src/pages/home/sections/faq/index.tsx:93
#~ msgid "Adapting content to the target position"
#~ msgstr "Adaptation du contenu à la position cible"

#: apps/client/src/pages/dashboard/applications/page.tsx:311
msgid "Add"
msgstr "Ajouter"

#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:168
msgid "Add a custom field"
msgstr "Ajouter un champ personnalisé"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-base.tsx:122
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-base.tsx:173
msgctxt "For example, add a new work experience, or add a new profile."
msgid "Add a new item"
msgstr "Ajouter un nouvel élément"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:91
msgid "Add a new item"
msgstr "Ajouter un nouvel élément"

#: apps/client/src/pages/builder/sidebars/left/index.tsx:146
#: apps/client/src/pages/builder/sidebars/left/index.tsx:263
msgid "Add a new section"
msgstr "Ajouter une nouvelle section"

#: apps/client/src/pages/dashboard/organizations/page.tsx:833
msgid "Add each member's email as a seat."
msgstr "Ajoutez l'e-mail de chaque membre comme siège."

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:261
msgid "Add New Page"
msgstr "Ajouter une Nouvelle Page"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:159
msgid "Add numbers, % and $ to show impact."
msgstr "Ajoutez des nombres, % et $ pour montrer l'impact."

#: apps/client/src/pages/dashboard/organizations/page.tsx:404
msgid "Add seat"
msgstr "Ajouter un siège"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:49
msgid "Add the job"
msgstr "Ajouter l'offre"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:141
msgid "Add your email in Basics."
msgstr "Ajoutez votre e-mail dans Les bases."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:147
msgid "Add your phone in Basics."
msgstr "Ajoutez votre téléphone dans Les bases."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:113
msgid "Added \"{keyword}\" to your skills."
msgstr "« {keyword} » ajouté à vos compétences."

#: apps/client/src/pages/dashboard/jobs/page.tsx:330
#: apps/client/src/pages/dashboard/opportunities/page.tsx:191
msgid "Added to your applications"
msgstr "Ajouté à vos candidatures"

#: apps/client/src/pages/dashboard/organizations/page.tsx:216
#~ msgid "admin"
#~ msgstr "admin"

#: apps/client/src/pages/dashboard/organizations/page.tsx:317
msgid "Admin"
msgstr "Admin"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:38
msgid "After months of searching, I finally found my dream job thanks to a resume that truly represents me."
msgstr "Après des mois de recherche, j'ai finalement trouvé mon emploi de rêve grâce à un CV qui me représente vraiment."

#: apps/client/src/components/ai-actions.tsx:75
msgid "AI"
msgstr "IA"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:31
msgid "AI Assistant"
msgstr "Assistant IA"

#: apps/client/src/pages/dashboard/organizations/page.tsx:515
msgid "AI consumption this month"
msgstr "Consommation IA ce mois-ci"

#: apps/client/src/pages/marketing/privacy/page.tsx:30
msgid "AI processing"
msgstr "Traitement par l'IA"

#: apps/client/src/pages/home/sections/faq/index.tsx:138
msgid "AI providers process your content only to generate your results"
msgstr "Les fournisseurs d'IA traitent votre contenu uniquement pour générer vos résultats"

#: apps/client/src/pages/dashboard/organizations/page.tsx:664
msgid "AI token pool"
msgstr "Réserve de tokens IA"

#: apps/client/src/pages/home/components/header.tsx:75
#: apps/client/src/pages/home/components/header.tsx:186
msgid "AI Writing"
msgstr "Écriture IA"

#: apps/client/src/pages/home/sections/features/index.tsx:28
#~ msgid "AI Writing Assistant"
#~ msgstr "Logiciels d'écriture assistée par IA"

#: apps/client/src/pages/marketing/pricing/page.tsx:57
msgid "AI writing assistant, monthly allowance"
msgstr "Assistant d'écriture IA, quota mensuel"

#: apps/client/src/pages/home/sections/services/index.tsx:27
msgid "AI-assisted Writing"
msgstr "Écriture assistée par l'IA"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:44
msgid "Alexandre Dubois"
msgstr "Alexandre Dubois"

#: apps/client/src/pages/home/components/footer.tsx:258
msgid "All rights reserved."
msgstr "Tous droits réservés."

#: apps/client/src/pages/dashboard/resumes/page.tsx:111
msgid "Alphabetical"
msgstr "Alphabétique"

#: apps/client/src/pages/auth/register/page.tsx:74
msgid "Already have an account?"
msgstr "Vous avez déjà un compte ?"

#: apps/client/src/pages/marketing/about/page.tsx:27
msgid "An agent on your side"
msgstr "Un agent à vos côtés"

#: apps/client/src/pages/dashboard/jobs/page.tsx:390
msgid "An AI-tailored resume for each job, built from your original"
msgstr "Un CV adapté par l'IA pour chaque offre, à partir de votre original"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:144
msgid "An error occurred while validating the file."
msgstr "Une erreur s'est produite lors du chargement du fichier."

#: apps/client/src/pages/home/sections/faq/index.tsx:92
msgid "An expert panel scores your fit and flags gaps"
msgstr "Un panel d'experts évalue votre adéquation et signale les écarts"

#: apps/client/src/pages/public/error.tsx:23
msgid "An internal server error occurred."
msgstr "Une erreur interne du serveur s'est produite."

#: apps/client/src/pages/public/error.tsx:32
msgid "An unexpected error occurred."
msgstr "Une erreur inattendue est survenue."

#: apps/client/src/pages/dashboard/organizations/page.tsx:255
msgid "Analyses"
msgstr "Analyses"

#: apps/client/src/pages/dashboard/applications/page.tsx:129
msgid "Analysis"
msgstr "Analyse"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:95
msgid "Analysis failed"
msgstr "Échec de l'analyse"

#: apps/client/src/pages/dashboard/jobs/page.tsx:224
msgid "Analysis ready"
msgstr "Analyse terminée"

#: apps/client/src/pages/marketing/cookies/page.tsx:23
msgid "Analytics cookies, which help us understand how the product is used so we can improve performance and the overall experience."
msgstr "Les cookies analytiques, qui nous aident à comprendre comment le produit est utilisé afin d'améliorer les performances et l'expérience globale."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:276
msgid "Analyze"
msgstr "Analyser"

#: apps/client/src/pages/dashboard/opportunities/_components/job-card.tsx:91
msgid "Analyze with my resume"
msgstr "Analyser avec mon CV"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:247
msgid "Analyze your resume against any job description: ATS score, missing keywords, a recruiter's verdict and interview prep."
msgstr "Analysez votre CV face à n'importe quelle offre : score ATS, mots-clés manquants, verdict du recruteur et préparation à l'entretien."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:276
msgid "Analyzing..."
msgstr "Analyse en cours..."

#: apps/client/src/pages/marketing/faq/page.tsx:11
msgid "Answers about Izicvs: finding jobs, AI applications, the autonomous agent, application tracking, data security and pricing."
msgstr "Réponses sur Izicvs : recherche d'offres, candidatures par IA, agent autonome, suivi des candidatures, sécurité des données et tarifs."

#: apps/client/src/pages/marketing/guides/page.tsx:39
msgid "Anticipate the questions you will face, structure your answers, and walk into every interview with confidence."
msgstr "Anticipez les questions qui vous attendent, structurez vos réponses et abordez chaque entretien avec confiance."

#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:57
msgid "Anyone with the link can view and download the resume."
msgstr "Toute personne avec ce lien peut voir et télécharger le CV."

#: apps/client/src/pages/builder/_components/toolbar.tsx:55
#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:30
msgid "Anyone with this link can view and download the resume. Share it on your profile or with recruiters."
msgstr "Toute personne avec ce lien peut voir et télécharger le CV. Partagez le sur votre profil ou avec les recruteurs."

#: apps/client/src/pages/marketing/ats-checker/page.tsx:71
msgid "Applicant tracking systems filter resumes before a human ever sees them. Our checker helps you pass that first screen and reach a real recruiter."
msgstr "Les systèmes de suivi des candidatures (ATS) filtrent les CV avant même qu'un humain ne les voie. Notre outil vous aide à franchir ce premier filtre et à atteindre un vrai recruteur."

#: apps/client/src/pages/home/sections/features/index.tsx:35
#~ msgid "Application Analytics"
#~ msgstr "Données d'analyse de l'application"

#: apps/client/src/pages/dashboard/jobs/page.tsx:809
msgid "Application answers"
msgstr "Réponses de candidature"

#: apps/client/src/pages/home/sections/features/index.tsx:63
msgid "Application tracker"
msgstr "Suivi de candidatures"

#: apps/client/src/pages/marketing/pricing/page.tsx:56
msgid "Application tracker with outcome stats"
msgstr "Suivi de candidatures avec statistiques de résultats"

#: apps/client/src/pages/dashboard/_components/sidebar.tsx:128
#: apps/client/src/pages/dashboard/applications/page.tsx:257
#: apps/client/src/pages/dashboard/applications/page.tsx:271
#: apps/client/src/pages/dashboard/organizations/page.tsx:254
#: apps/client/src/pages/dashboard/organizations/page.tsx:507
msgid "Applications"
msgstr "Candidatures"

#: apps/client/src/pages/marketing/pricing/page.tsx:91
msgid "Applications prepared for you automatically"
msgstr "Des candidatures préparées automatiquement pour vous"

#: apps/client/src/pages/dashboard/applications/page.tsx:169
msgid "Applications sent"
msgstr "Candidatures envoyées"

#: apps/client/src/pages/home/sections/faq/index.tsx:124
msgid "Applications you already sent are marked so you avoid duplicates"
msgstr "Les candidatures déjà envoyées sont marquées pour éviter les doublons"

#: apps/client/src/pages/dashboard/applications/page.tsx:230
#: apps/client/src/pages/dashboard/organizations/page.tsx:143
msgid "Applied"
msgstr "Postulé"

#: apps/client/src/pages/builder/sidebars/right/sections/css.tsx:41
msgid "Apply Custom CSS"
msgstr "Appliquer une feuille de style CSS personnalisée"

#: apps/client/src/pages/home/sections/features/index.tsx:57
#~ msgid "Apply internationally without effort"
#~ msgstr "Appliquer au niveau international sans effort"

#: apps/client/src/pages/marketing/help/page.tsx:28
msgid "Apply with confidence and keep tabs on every application."
msgstr "Postulez en toute confiance et gardez un œil sur chaque candidature."

#: apps/client/src/pages/home/sections/features/index.tsx:58
msgid "Apply with confidence."
msgstr "Postulez en confiance."

#: apps/client/src/pages/home/sections/features/index.tsx:44
msgid "Apply with materials built for the role."
msgstr "Postulez avec des documents taillés pour le poste."

#: apps/client/src/pages/marketing/help/page.tsx:27
msgid "Applying and tracking"
msgstr "Candidature et suivi"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:128
msgid "Are you sure you want to delete this item?"
msgstr "Êtes-vous sûr de vouloir supprimer cet élément?"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:149
msgid "Are you sure you want to delete your resume?"
msgstr "Êtes-vous sûr de vouloir supprimer votre CV ?"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:125
msgid "Are you sure you want to disable two-factor authentication?"
msgstr "Êtes-vous sûr de vouloir désactiver l’authentification à deux facteurs ?"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:38
msgid "Are you sure you want to lock this resume?"
msgstr "Êtes-vous sûr de vouloir verrouiller ce CV ?"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:39
msgid "Are you sure you want to unlock this resume?"
msgstr "Êtes-vous sûr de vouloir verrouiller ce CV ?"

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:94
msgid "Are you sure?"
msgstr "Etes-vous sûr?"

#. For example, Computer Science or Business Administration
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:73
msgid "Area of Study"
msgstr "Domaine d'étude"

#: apps/client/src/pages/home/sections/faq/index.tsx:77
#~ msgid "Artificial intelligence to optimize content"
#~ msgstr "Intelligence artificielle pour optimiser le contenu"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:79
msgid "Aspect Ratio"
msgstr "Ratio d'aspect"

#: apps/client/src/pages/home/sections/faq/index.tsx:78
#~ msgid "ATS algorithms to maximize your chances"
#~ msgstr "Algorithmes ATS pour maximiser vos chances"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:123
#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:182
#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:183
msgid "ATS Analysis"
msgstr "Analyse ATS"

#: apps/client/src/pages/home/components/footer.tsx:157
#: apps/client/src/pages/marketing/ats-checker/page.tsx:64
#: apps/client/src/pages/marketing/ats-checker/page.tsx:68
#: apps/client/src/pages/marketing/sitemap/page.tsx:44
msgid "ATS Checker"
msgstr "Vérificateur ATS"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:287
#: apps/client/src/pages/dashboard/jobs/page.tsx:514
msgid "ATS match score"
msgstr "Score de correspondance ATS"

#: apps/client/src/pages/home/components/header.tsx:68
#: apps/client/src/pages/home/components/header.tsx:176
msgid "ATS Optimization"
msgstr "Optimisation ATS"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:194
msgid "ATS readiness"
msgstr "Lisibilité ATS"

#: apps/client/src/pages/dashboard/jobs/page.tsx:546
msgid "ATS Specialist"
msgstr "Spécialiste ATS"

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:94
msgid "Auto-fill isn't available for this source yet. Open the offer to apply."
msgstr "Le pré-remplissage n'est pas encore dispo pour cette source. Ouvrez l'offre pour postuler."

#: apps/client/src/pages/marketing/pricing/page.tsx:90
msgid "Autonomous 24/7 job search"
msgstr "Recherche d'emploi autonome 24h/24 et 7j/7"

#: apps/client/src/pages/home/sections/features/index.tsx:70
msgid "Autonomous 24/7 search"
msgstr "Recherche autonome 24/7"

#: apps/client/src/pages/dashboard/organizations/page.tsx:463
#: apps/client/src/pages/dashboard/organizations/page.tsx:903
#: apps/client/src/pages/dashboard/organizations/page.tsx:972
#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:22
#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:98
#: apps/client/src/pages/marketing/pricing/page.tsx:81
msgid "Autopilot"
msgstr "Autopilot"

#: apps/client/src/pages/home/sections/faq/index.tsx:154
msgid "Autopilot at 19 € per month: the autonomous agent"
msgstr "Autopilot à 19 € par mois : l'agent autonome"

#: apps/client/src/pages/dashboard/organizations/page.tsx:147
#~ msgid "Autopilot seats"
#~ msgstr "Sièges Autopilot"

#: apps/client/src/pages/home/sections/faq/index.tsx:122
#~ msgid "Available in 15+ languages"
#~ msgstr "Disponible dans plus de 20 langues"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:244
msgid "Available on the Pro plan"
msgstr "Disponible avec le plan Pro"

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:53
msgid "Awarder"
msgstr "Entreprise"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:30
msgid "Awards"
msgstr "Récompenses"

#: apps/client/src/pages/auth/backup-otp/page.tsx:99
#: apps/client/src/pages/auth/forgot-password/page.tsx:100
#: apps/client/src/pages/dashboard/create/page.tsx:155
#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:243
msgid "Back"
msgstr "Retour"

#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:73
msgid "Background Color"
msgstr "Couleur de fond"

#: apps/client/src/pages/auth/backup-otp/page.tsx:75
msgid "Backup Code"
msgstr "Code de récupération"

#: apps/client/src/pages/auth/backup-otp/page.tsx:81
msgid "Backup Codes may contain only lowercase letters or numbers, and must be exactly 10 characters."
msgstr "Les codes de sauvegarde ne peuvent contenir que des lettres minuscules ou des chiffres et doivent comporter exactement 10 caractères."

#: apps/client/src/pages/builder/sidebars/left/index.tsx:55
msgctxt "The basics section of a resume consists of User's Picture, Full Name, Location etc."
msgid "Basics"
msgstr "Les bases"

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:21
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:9
msgid "Basics"
msgstr "Les bases"

#: apps/client/src/pages/marketing/pricing/page.tsx:93
msgid "Batch review and approve"
msgstr "Vérifiez et approuvez par lot"

#: apps/client/src/pages/marketing/guides/page.tsx:18
msgid "Beat the ATS: format your resume right"
msgstr "Déjouez l'ATS : mettez en forme votre CV correctement"

#: apps/client/src/pages/home/sections/features/index.tsx:97
#~ msgid ""
#~ "Beyond a simple resume generator, we offer an intelligent solution that\n"
#~ "transforms your applications. With cutting-edge technology and an approach centered on\n"
#~ "your professional success."
#~ msgstr ""
#~ "Au-delà d'un simple générateur de résumé, nous proposons une solution intelligente que\n"
#~ "transforme vos applications. Avec une technologie de pointe et une approche centrée sur\n"
#~ "votre succès professionnel."

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:77
msgid "Billed weekly. Pro and Autopilot plans already include every template."
msgstr "Facturé chaque semaine. Les plans Pro et Autopilot incluent déjà tous les templates."

#: apps/client/src/pages/dashboard/organizations/page.tsx:597
#: apps/client/src/pages/dashboard/organizations/page.tsx:724
msgid "Billing"
msgstr "Facturation"

#: apps/client/src/pages/dashboard/organizations/page.tsx:740
msgid "Billing active"
msgstr "Facturation active"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:49
msgid "Billing is not enabled on this instance, so all features are available."
msgstr "La facturation n'est pas activée sur cette instance, toutes les fonctionnalités sont accessibles."

#: apps/client/src/pages/dashboard/organizations/page.tsx:709
msgid "Billing is off, so AI usage is unlimited on this instance."
msgstr "La facturation est désactivée, l'usage de l'IA est donc illimité sur cette instance."

#: apps/client/src/pages/dashboard/resumes/_components/new-resume.tsx:39
msgid "Blank resume"
msgstr "CV vierge"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:191
msgid "Border"
msgstr "Bordure"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:124
msgid "Border Radius"
msgstr "Rayon de la bordure"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:296
msgid "Breakdown"
msgstr "Détail"

#: apps/client/src/pages/marketing/help/page.tsx:54
msgid "Browse common topics or reach out to our team when you need a hand."
msgstr "Parcourez les sujets courants ou contactez notre équipe lorsque vous avez besoin d'aide."

#: apps/client/src/pages/marketing/help/page.tsx:46
msgid "Browse common topics or reach the Izicvs team when you need a hand."
msgstr "Parcourez les sujets courants ou contactez l'équipe Izicvs quand vous avez besoin d'aide."

#: apps/client/src/pages/marketing/contact/page.tsx:71
msgid "Browse guides and answers to common questions. It is the fastest way to get unstuck on your own."
msgstr "Parcourez les guides et les réponses aux questions fréquentes. C'est le moyen le plus rapide de vous débloquer par vous-même."

#: apps/client/src/pages/marketing/guides/page.tsx:34
msgid "Build a focused, personal cover letter that complements your resume and speaks directly to the company you want to join."
msgstr "Rédigez une lettre de motivation ciblée et personnelle qui complète votre CV et s'adresse directement à l'entreprise que vous souhaitez rejoindre."

#: apps/client/src/pages/marketing/help/page.tsx:17
msgid "Building your resume"
msgstr "Créer votre CV"

#: apps/client/src/pages/public/page.tsx:141
msgid "Built with"
msgstr "Construit avec"

#: apps/client/src/pages/dashboard/organizations/page.tsx:674
#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:44
msgid "Buy tokens"
msgstr "Acheter des tokens"

#: apps/client/src/pages/home/components/footer.tsx:249
msgid "by"
msgstr "par"

#: apps/client/src/pages/marketing/terms/page.tsx:17
msgid "By accessing or using Izicvs, you agree to be bound by these Terms of Use. If you do not agree, please do not use the service."
msgstr "En accédant à Izicvs ou en l'utilisant, vous acceptez d'être lié par les présentes Conditions d'utilisation. Si vous n'êtes pas d'accord, veuillez ne pas utiliser le service."

#: apps/client/src/pages/dashboard/applications/page.tsx:171
#: apps/client/src/pages/dashboard/organizations/page.tsx:508
msgid "Callback rate"
msgstr "Taux de rappel"

#: apps/client/src/pages/dashboard/applications/page.tsx:178
msgid "Callback rate by resume"
msgstr "Taux de rappel par CV"

#: apps/client/src/pages/dashboard/applications/page.tsx:170
msgid "Callbacks"
msgstr "Retours"

#: apps/client/src/pages/dashboard/applications/page.tsx:171
msgid "callbacks / sent"
msgstr "retours / envoyées"

#: apps/client/src/pages/home/page.tsx:49
#: apps/client/src/pages/home/sections/faq/index.tsx:117
msgid "Can I track my applications?"
msgstr "Puis-je suivre mes candidatures ?"

#: apps/client/src/pages/home/sections/faq/index.tsx:117
#~ msgid "Can I use the service internationally?"
#~ msgstr "Puis-je utiliser le service à l'international ?"

#: apps/client/src/components/confirm-delete.tsx:34
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:135
#: apps/client/src/pages/dashboard/create/page.tsx:155
#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:49
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:156
#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:137
msgid "Cancel"
msgstr "Annuler"

#: apps/client/src/pages/home/sections/faq/index.tsx:140
#~ msgid "Cancel anytime"
#~ msgstr "Annulez à tout moment"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:113
msgid "Cancel anytime from the portal; you keep access until the end of the paid period."
msgstr "Annulez à tout moment depuis le portail ; vous gardez l'accès jusqu'à la fin de la période payée."

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:36
msgid "Cancel anytime, in one click"
msgstr "Résiliable à tout moment, en un clic"

#: apps/client/src/pages/home/sections/faq/index.tsx:155
msgid "Cancel anytime, no commitment"
msgstr "Annulez à tout moment, sans engagement"

#: apps/client/src/pages/dashboard/jobs/page.tsx:461
msgid "Cancel anytime."
msgstr "Annulable à tout moment."

#: apps/client/src/pages/home/components/footer.tsx:149
#: apps/client/src/pages/marketing/guides/page.tsx:54
#: apps/client/src/pages/marketing/guides/page.tsx:58
#: apps/client/src/pages/marketing/sitemap/page.tsx:56
msgid "Career Guides"
msgstr "Guides de carrière"

#: apps/client/src/pages/marketing/guides/page.tsx:51
msgid "Career guides for your job search"
msgstr "Guides carrière pour votre recherche d'emploi"

#: apps/client/src/components/ai-actions.tsx:99
#: apps/client/src/components/ai-actions.tsx:102
msgid "Casual"
msgstr "Décontracté"

#: apps/client/src/pages/builder/_components/toolbar.tsx:126
msgid "Center Artboard"
msgstr "Plan de travail central"

#: apps/client/src/pages/marketing/pricing/page.tsx:244
msgid "Central seat management"
msgstr "Gestion centralisée des sièges"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:33
msgid "Certifications"
msgstr "Certifications"

#: apps/client/src/pages/auth/reset-password/page.tsx:99
#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:115
msgid "Change Password"
msgstr "Changer le mot de passe"

#: apps/client/src/components/ai-actions.tsx:93
msgid "Change Tone"
msgstr "Changer de ton"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:186
msgid "Changed your mind about the name? Give it a new one."
msgstr "Vous avez changé d'avis sur le nom ? Donnez-en un nouveau."

#: apps/client/src/pages/marketing/cookies/page.tsx:32
msgid "Changes"
msgstr "Modifications"

#: apps/client/src/pages/marketing/terms/page.tsx:43
msgid "Changes to the terms"
msgstr "Modifications des conditions"

#: apps/client/src/pages/dashboard/jobs/page.tsx:904
msgid "Check legitimacy"
msgstr "Vérifier la légitimité"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:113
msgid "Check my resume"
msgstr "Vérifier mon CV"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:62
msgid "Check whether your resume passes applicant tracking systems: keyword match, quantified impact, action verbs and format, so you reach a real recruiter."
msgstr "Vérifiez si votre CV passe les logiciels de recrutement (ATS) : correspondance des mots-clés, impact chiffré, verbes d'action et format, pour atteindre un vrai recruteur."

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:70
msgid "Check your email for the confirmation link to update your email address."
msgstr "Vérifiez votre courrier électronique pour le lien de confirmation permettant de mettre à jour votre adresse e-mail."

#: apps/client/src/pages/dashboard/jobs/page.tsx:904
msgid "Checking..."
msgstr "Vérification..."

#: apps/client/src/pages/dashboard/create/page.tsx:333
msgid "Choose a template"
msgstr "Choisir un template"

#: apps/client/src/pages/dashboard/create/page.tsx:351
msgid "Choose a template. You can change it anytime in the editor."
msgstr "Choisissez un template. Vous pourrez en changer à tout moment dans l'éditeur."

#: apps/client/src/pages/dashboard/create/page.tsx:181
msgid "Choose how you want to start."
msgstr "Choisissez comment démarrer."

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:144
msgid "Circle"
msgstr "Cercle"

#: apps/client/src/pages/home/sections/templates/index.tsx:146
msgid "Classic and structured, ideal for traditional sectors."
msgstr "Classique et structurée, idéale pour les secteurs traditionnels."

#: apps/client/src/pages/home/sections/templates/index.tsx:143
msgid "Clean and efficient, perfect for experienced profiles."
msgstr "Propre et efficace, parfait pour les profils expérimentés."

#: apps/client/src/pages/home/sections/features/index.tsx:23
#~ msgid "Clean, structured listings — no fragile scraping."
#~ msgstr "Des offres propres et structurées — sans scraping fragile."

#: apps/client/src/pages/home/sections/features/index.tsx:23
msgid "Clean, structured listings, no fragile scraping."
msgstr "Des offres propres et structurées, sans scraping fragile."

#: apps/client/src/pages/home/sections/faq/index.tsx:80
msgid "Clear match reasons so you know why a job fits"
msgstr "Des raisons de correspondance claires pour comprendre pourquoi une offre vous convient"

#: apps/client/src/pages/dashboard/resumes/_components/empty-state.tsx:37
msgid "Clear search"
msgstr "Effacer la recherche"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:312
msgid "Click a keyword to add it to your Skills section (visible and ATS-readable)."
msgstr "Cliquez sur un mot-clé pour l'ajouter à vos compétences (visible et lisible par les ATS)."

#: apps/client/src/pages/dashboard/create/page.tsx:159
#: apps/client/src/pages/dashboard/organizations/page.tsx:314
#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:249
msgid "Close"
msgstr "Fermer"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:201
msgid "Code"
msgstr "Code"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:52
msgid "Code must be exactly 6 digits long."
msgstr "Le code doit comporter exactement 6 chiffres."

#: apps/client/src/pages/dashboard/organizations/page.tsx:723
msgid "Cohort & members"
msgstr "Cohorte & membres"

#: apps/client/src/pages/dashboard/organizations/page.tsx:743
msgid "Cohort billing"
msgstr "Facturation par cohorte"

#: apps/client/src/pages/dashboard/organizations/page.tsx:502
msgid "Cohort progress"
msgstr "Progression de la cohorte"

#: apps/client/src/pages/marketing/pricing/page.tsx:242
msgid "Cohort progress dashboard"
msgstr "Tableau de bord de progression de cohorte"

#: apps/client/src/pages/dashboard/jobs/page.tsx:958
msgid "Cold email"
msgstr "E-mail à froid"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:136
msgid "Columns"
msgstr "Colonnes"

#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:39
#: apps/client/src/pages/dashboard/applications/page.tsx:302
#: apps/client/src/pages/home/components/footer.tsx:172
#: apps/client/src/pages/marketing/sitemap/page.tsx:74
msgid "Company"
msgstr "Société"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:29
msgid "Compare your resume against the job description and see which skills and terms you are missing."
msgstr "Comparez votre CV à la description du poste et découvrez quelles compétences et quels termes vous manquent."

#: apps/client/src/pages/home/sections/faq/index.tsx:80
#~ msgid "Complete customization in just a few clicks"
#~ msgstr "Personnalisation complète en quelques clics"

#: apps/client/src/pages/home/sections/faq/index.tsx:137
#~ msgid "Completely free basic version"
#~ msgstr "Version de base entièrement gratuite"

#: apps/client/src/pages/home/sections/features/index.tsx:36
#~ msgid "Comprehensive dashboard of your application performance"
#~ msgstr "Tableau de bord complet des performances de votre application"

#: apps/client/src/pages/dashboard/jobs/page.tsx:603
msgid "Concerns"
msgstr "Réserves"

#: apps/client/src/components/ai-actions.tsx:111
#: apps/client/src/components/ai-actions.tsx:114
msgid "Confident"
msgstr "Confiant"

#: apps/client/src/pages/dashboard/jobs/page.tsx:493
msgid "Consulting the experts..."
msgstr "Consultation des experts..."

#: apps/client/src/pages/home/components/footer.tsx:187
#: apps/client/src/pages/marketing/contact/page.tsx:20
#: apps/client/src/pages/marketing/contact/page.tsx:24
#: apps/client/src/pages/marketing/cookies/page.tsx:35
#: apps/client/src/pages/marketing/privacy/page.tsx:45
#: apps/client/src/pages/marketing/sitemap/page.tsx:83
#: apps/client/src/pages/marketing/terms/page.tsx:46
msgid "Contact"
msgstr "Contact"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:73
msgid "Contact details"
msgstr "Coordonnées"

#: apps/client/src/pages/dashboard/jobs/page.tsx:183
msgid "Contact info"
msgstr "Coordonnées"

#: apps/client/src/pages/marketing/contact/page.tsx:17
msgid "Contact Izicvs"
msgstr "Contacter Izicvs"

#: apps/client/src/pages/marketing/pricing/page.tsx:271
msgid "Contact sales"
msgstr "Contacter le commercial"

#: apps/client/src/pages/marketing/feedback/page.tsx:67
#: apps/client/src/pages/marketing/help/page.tsx:74
msgid "Contact us"
msgstr "Contactez-nous"

#: apps/client/src/pages/home/components/footer.tsx:225
msgid "Contact Us"
msgstr "Contactez-nous"

#: apps/client/src/pages/dashboard/jobs/page.tsx:914
msgid "Contacts & outreach"
msgstr "Contacts & approche"

#: apps/client/src/pages/builder/_components/header.tsx:59
msgid "Content"
msgstr "Contenu"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:234
#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:246
msgid "Continue"
msgstr "Continuer"

#: apps/client/src/pages/home/components/footer.tsx:264
#: apps/client/src/pages/marketing/cookies/page.tsx:10
#: apps/client/src/pages/marketing/sitemap/page.tsx:110
msgid "Cookie Policy"
msgstr "Politique des cookies"

#: apps/client/src/pages/marketing/cookies/page.tsx:17
msgid "Cookies are small text files that a website stores on your device. They help the site remember your actions and preferences, keep you signed in, and understand how the product is used."
msgstr "Les cookies sont de petits fichiers texte qu'un site web enregistre sur votre appareil. Ils aident le site à mémoriser vos actions et vos préférences, à vous maintenir connecté et à comprendre comment le produit est utilisé."

#: apps/client/src/pages/dashboard/jobs/page.tsx:771
#: apps/client/src/pages/dashboard/jobs/page.tsx:947
#: apps/client/src/pages/dashboard/jobs/page.tsx:972
#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:51
msgid "Copied to clipboard"
msgstr "Copié dans le presse-papiers"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-list-item.tsx:96
#: apps/client/src/pages/dashboard/jobs/page.tsx:775
#: apps/client/src/pages/dashboard/jobs/page.tsx:951
#: apps/client/src/pages/dashboard/jobs/page.tsx:976
msgid "Copy"
msgstr "Copier"

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:144
msgid "Copy answers"
msgstr "Copier les réponses"

#: apps/client/src/pages/builder/_components/toolbar.tsx:160
msgid "Copy Link to Resume"
msgstr "Copier le lien vers le CV"

#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:78
msgid "Copy to Clipboard"
msgstr "Copier dans le Presse-Papier"

#: apps/client/src/pages/dashboard/organizations/page.tsx:374
msgid "Could not add member"
msgstr "Impossible d'ajouter le membre"

#: apps/client/src/pages/dashboard/organizations/page.tsx:825
msgid "Could not create"
msgstr "Impossible de créer"

#: apps/client/src/pages/dashboard/create/page.tsx:124
msgid "Could not create your resume"
msgstr "Impossible de créer votre CV"

#: apps/client/src/pages/dashboard/create/page.tsx:102
#: apps/client/src/pages/dashboard/resumes/_dialogs/ai-generate.tsx:45
msgid "Could not generate your resume"
msgstr "Impossible de générer votre CV"

#: apps/client/src/pages/dashboard/organizations/page.tsx:587
msgid "Could not open billing"
msgstr "Impossible d'ouvrir la facturation"

#: apps/client/src/pages/dashboard/organizations/page.tsx:436
msgid "Could not save"
msgstr "Impossible d'enregistrer"

#: apps/client/src/pages/dashboard/organizations/page.tsx:575
#: apps/client/src/pages/dashboard/organizations/page.tsx:654
msgid "Could not start checkout"
msgstr "Impossible de démarrer le paiement"

#: apps/client/src/pages/dashboard/jobs/page.tsx:753
msgid "Cover letter"
msgstr "Lettre de motivation"

#: apps/client/src/pages/marketing/guides/page.tsx:33
msgid "Craft a cover letter in minutes"
msgstr "Rédigez une lettre de motivation en quelques minutes"

#: apps/client/src/pages/home/sections/features/index.tsx:23
#~ msgid "Craft a unique resume that perfectly reflects your journey and captures recruiter attention"
#~ msgstr "Rédiger un CV unique qui reflète parfaitement votre parcours et attire l'attention des recruteurs"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:179
#: apps/client/src/pages/dashboard/organizations/page.tsx:908
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:244
msgid "Create"
msgstr "Créer"

#: apps/client/src/pages/auth/register/page.tsx:67
#: apps/client/src/pages/auth/register/page.tsx:72
msgid "Create a new account"
msgstr "Créer un nouveau compte"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:163
msgid "Create a new item"
msgstr "Créer un nouvel élément"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:178
msgid "Create a new resume"
msgstr "Créer un nouveau CV"

#: apps/client/src/pages/dashboard/jobs/page.tsx:695
msgid "Create a new resume optimized for this job, based on your original. Your original stays untouched, and nothing is invented."
msgstr "Créez un nouveau CV optimisé pour cette offre, à partir de votre original. Votre original reste intact, et rien n'est inventé."

#: apps/client/src/pages/dashboard/create/page.tsx:147
msgid "Create a resume"
msgstr "Créer un CV"

#: apps/client/src/pages/home/components/header.tsx:141
#: apps/client/src/pages/home/components/header.tsx:231
msgid "Create a Resume"
msgstr "Créer un CV"

#: apps/client/src/pages/dashboard/jobs/page.tsx:497
msgid "Create a resume first to use Job Match."
msgstr "Créez d'abord un CV pour utiliser la correspondance d'offres."

#: apps/client/src/pages/home/components/footer.tsx:36
msgid "Create a resume that makes a difference and maximize your interview chances."
msgstr "Créez un curriculum vitae qui fait la différence et maximisez vos chances d'entrevue."

#: apps/client/src/pages/dashboard/resumes/_dialogs/ai-generate.tsx:62
msgid "Create a resume with AI"
msgstr "Créer un CV avec l'IA"

#: apps/client/src/pages/dashboard/organizations/page.tsx:832
msgid "Create an organization"
msgstr "Créer une organisation"

#: apps/client/src/pages/dashboard/create/page.tsx:393
#: apps/client/src/pages/home/sections/templates/index.tsx:263
msgid "Create my resume"
msgstr "Créer un nouveau CV"

#: apps/client/src/pages/home/components/footer.tsx:42
msgid "Create my resume for free"
msgstr "Créer mon CV gratuitement"

#: apps/client/src/pages/home/sections/hero/index.tsx:96
#~ msgid "Create my unbeatable resume"
#~ msgstr "Créer mon CV imbattable"

#: apps/client/src/pages/dashboard/organizations/page.tsx:192
#~ msgid "Create one above. You will then invite members by email, and each seat gets the plan you chose."
#~ msgstr "Créez-en une ci-dessus. Vous inviterez ensuite des membres par e-mail, et chaque siège reçoit le plan choisi."

#: apps/client/src/pages/auth/login/page.tsx:65
msgctxt "This is a link to create a new account"
msgid "Create one now"
msgstr "Créez-en un maintenant"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:259
msgid "Create Sample Resume"
msgstr "Créer un exemple de CV"

#: apps/client/src/pages/dashboard/create/page.tsx:187
#: apps/client/src/pages/dashboard/resumes/_components/new-resume.tsx:43
msgid "Create with AI"
msgstr "Créer avec l'IA"

#: apps/client/src/pages/dashboard/organizations/page.tsx:886
msgid "Create your first organization"
msgstr "Créez votre première organisation"

#: apps/client/src/pages/dashboard/resumes/_components/empty-state.tsx:14
msgid "Create your first resume"
msgstr "Créez votre premier CV"

#: apps/client/src/pages/marketing/guides/page.tsx:80
msgid "Create your free Izicvs account and build a resume that gets you interviews."
msgstr "Créez votre compte Izicvs gratuit et construisez un CV qui vous décroche des entretiens."

#: apps/client/src/pages/marketing/help/page.tsx:18
msgid "Create, edit, and polish resumes that stand out."
msgstr "Créez, modifiez et peaufinez des CV qui se démarquent."

#: apps/client/src/pages/dashboard/create/page.tsx:393
msgid "Creating your resume..."
msgstr "Création de votre CV..."

#: apps/client/src/pages/home/sections/templates/index.tsx:166
msgid "Creative"
msgstr "Créatif"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:82
msgid "Current Password"
msgstr "Mot de passe actuel"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:58
msgid "Current plan"
msgstr "Formule actuelle"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:95
#: apps/client/src/pages/builder/sidebars/right/sections/css.tsx:27
#: apps/client/src/pages/builder/sidebars/right/sections/css.tsx:28
msgid "Custom CSS"
msgstr "CSS personnalisé"

#: apps/client/src/stores/resume.ts:47
msgid "Custom Section"
msgstr "Section personnalisée"

#: apps/client/src/pages/home/sections/services/index.tsx:35
msgid "Customize your resume with one click for each job offer - our system automatically extracts relevant keywords."
msgstr "Personnalisez votre CV en un seul clic pour chaque offre d'emploi - notre système extrait automatiquement les mots-clés pertinents."

#: apps/client/src/pages/marketing/pricing/page.tsx:92
msgid "Daily digest of your best new matches"
msgstr "Un résumé quotidien de vos meilleures nouvelles correspondances"

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:62
msgid "Danger Zone"
msgstr "Zone dangereuse"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:87
msgid "Dark"
msgstr "Sombre"

#: apps/client/src/pages/home/components/header.tsx:137
#: apps/client/src/pages/home/sections/hero/index.tsx:89
msgid "Dashboard"
msgstr "Tableau de bord"

#: apps/client/src/pages/home/sections/features/index.tsx:69
#~ msgid "Data encryption and complete control of your information"
#~ msgstr "Chiffrement des données et contrôle complet de vos informations"

#: apps/client/src/pages/marketing/privacy/page.tsx:36
msgid "Data retention"
msgstr "Conservation des données"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:48
msgid "Data Scientist"
msgstr "Data Scientist"

#: apps/client/src/pages/marketing/privacy/page.tsx:33
msgid "Data sharing"
msgstr "Partage des données"

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:67
#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:67
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:67
msgid "Date"
msgstr "Date"

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:87
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:110
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:72
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:101
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:67
msgid "Date or Date Range"
msgstr "Période ou date"

#: apps/client/src/components/confirm-delete.tsx:36
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:137
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:158
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:138
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:137
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:183
msgid "Delete"
msgstr "Supprimer"

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:79
#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:94
msgid "Delete Account"
msgstr "Supprimer le compte"

#: apps/client/src/pages/dashboard/jobs/page.tsx:1032
msgid "Delete this analysis?"
msgstr "Supprimer cette analyse ?"

#: apps/client/src/pages/dashboard/applications/page.tsx:79
msgid "Delete this application?"
msgstr "Supprimer cette candidature ?"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:371
msgid "Delete this followed search?"
msgstr "Supprimer cette recherche suivie ?"

#: apps/client/src/components/confirm-delete.tsx:28
msgid "Delete this item?"
msgstr "Supprimer cet élément ?"

#: apps/client/src/pages/marketing/privacy/page.tsx:40
msgid "Depending on your location, you may have the right to access, correct, export, or delete your personal data, and to object to or restrict certain processing. If you are in the European Union, you benefit from the protections of the GDPR. You can exercise these rights at any time by contacting us."
msgstr "Selon votre lieu de résidence, vous pouvez avoir le droit d'accéder à vos données personnelles, de les corriger, de les exporter ou de les supprimer, ainsi que de vous opposer à certains traitements ou de les limiter. Si vous êtes dans l'Union européenne, vous bénéficiez des protections du RGPD. Vous pouvez exercer ces droits à tout moment en nous contactant."

#: apps/client/src/pages/dashboard/create/page.tsx:238
msgid "Describe your background, or paste an old resume or your LinkedIn profile. The AI never invents facts."
msgstr "Décrivez votre parcours, ou collez un ancien CV ou votre profil LinkedIn. L'IA n'invente jamais de faits."

#: apps/client/src/pages/dashboard/resumes/_dialogs/ai-generate.tsx:65
msgid "Describe your background, or paste an old resume or your LinkedIn profile. The AI structures it into a resume. It never invents facts."
msgstr "Décrivez votre parcours, ou collez un ancien CV ou votre profil LinkedIn. L'IA le structure en CV. Elle n'invente jamais de faits."

#: apps/client/src/pages/dashboard/create/page.tsx:188
msgid "Describe yourself and let the AI draft a full resume."
msgstr "Décrivez-vous et laissez l'IA rédiger un CV complet."

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:73
#: apps/client/src/pages/builder/sidebars/left/dialogs/languages.tsx:50
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:87
#: apps/client/src/pages/builder/sidebars/left/dialogs/references.tsx:53
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:63
msgid "Description"
msgstr "Description"

#: apps/client/src/pages/marketing/terms/page.tsx:19
msgid "Description of the service"
msgstr "Description du service"

#: apps/client/src/pages/builder/_components/header.tsx:70
msgid "Design"
msgstr "Design"

#: apps/client/src/pages/home/sections/faq/index.tsx:94
#~ msgid "Detecting and correcting errors"
#~ msgstr "Détection et correction des erreurs"

#: apps/client/src/pages/home/sections/services/index.tsx:21
msgid "Developed in collaboration with HR professionals, our templates are designed to make a strong first impression."
msgstr "Développés en collaboration avec des professionnels RH, nos modèles sont conçus pour faire forte impression dès le premier regard."

#: apps/client/src/pages/home/sections/features/index.tsx:49
#~ msgid "Direct import and synchronization with LinkedIn"
#~ msgstr "Importation et synchronisation directes avec LinkedIn"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:139
msgid "Disable"
msgstr "Désactiver"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:154
msgid "Disable 2FA"
msgstr "Désactiver la 2FA"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:298
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:220
#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:134
#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:118
msgid "Discard"
msgstr "Abandonner"

#: apps/client/src/pages/marketing/terms/page.tsx:34
msgid "Disclaimers"
msgstr "Avertissements"

#: apps/client/src/pages/home/sections/templates/index.tsx:241
msgid "Discover more"
msgstr "En savoir plus"

#: apps/client/src/pages/marketing/help/page.tsx:23
msgid "Discover roles and find the ones that fit you best."
msgstr "Découvrez des postes et trouvez ceux qui vous correspondent le mieux."

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:105
msgid "Documentation"
msgstr "Documentation"

#: apps/client/src/pages/auth/login/page.tsx:62
msgid "Don't have an account?"
msgstr "Pas encore de compte ?"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:83
msgid "Don't know where to begin? Hit the docs!"
msgstr "Vous ne savez pas par où commencer ? La doc !"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:107
msgid "Don't see your language? <0>Help translate the app.</0>"
msgstr "Vous ne voyez pas votre langue ? <0>Aidez à traduire l'application.</0>"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:40
msgid "Donate to Izicvs"
msgstr "Faire un don à Izicvs"

#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:52
msgid "Download a JSON snapshot of your resume. This file can be used to import your resume in the future, or can even be shared with others to collaborate."
msgstr "Téléchargez un instantané JSON de votre CV. Ce fichier peut être utilisé pour importer votre CV à l'avenir, ou peut même être partagé avec d'autres pour collaborer."

#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:70
msgid "Download a PDF of your resume. This file can be used to print your resume, send it to recruiters, or upload on job portals."
msgstr "Téléchargez un PDF de votre CV. Ce fichier peut être utilisé pour imprimer votre CV, l'envoyer aux recruteurs ou le télécharger sur des portails d'emploi."

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:149
msgid "Download CV (PDF)"
msgstr "Télécharger le CV (PDF)"

#: apps/client/src/pages/builder/_components/toolbar.tsx:172
msgid "Download PDF"
msgstr "Télécharger au format PDF"

#: apps/client/src/services/resume/print.tsx:28
msgid "Downloading PDF"
msgstr "Téléchargement du PDF"

#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:58
msgid "Downloads"
msgstr "Télécharger"

#: apps/client/src/pages/dashboard/jobs/page.tsx:812
msgid "Draft answers to the common application questions, ready to paste."
msgstr "Rédigez les réponses aux questions courantes de candidature, prêtes à coller."

#: apps/client/src/pages/dashboard/jobs/page.tsx:850
msgid "Draft application answers"
msgstr "Rédiger les réponses"

#: apps/client/src/pages/dashboard/jobs/page.tsx:850
msgid "Drafting..."
msgstr "Rédaction..."

#: apps/client/src/pages/home/sections/faq/index.tsx:123
msgid "Drag and drop to update a status in seconds"
msgstr "Glissez-déposez pour mettre à jour un statut en quelques secondes"

#: apps/client/src/pages/dashboard/applications/page.tsx:350
msgid "Drop cards here"
msgstr "Déposez les cartes ici"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:181
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:246
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:124
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:105
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:167
msgid "Duplicate"
msgstr "Dupliquer"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:165
msgid "Duplicate an existing item"
msgstr "Dupliquer un élément existant"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:180
msgid "Duplicate an existing resume"
msgstr "Dupliquer un CV existant"

#: apps/client/src/pages/dashboard/organizations/page.tsx:890
msgid "e.g. Acme Bootcamp, Cohort 12"
msgstr "ex. Acme Bootcamp, Promo 12"

#: apps/client/src/pages/dashboard/resumes/_dialogs/ai-generate.tsx:74
msgid "e.g. I'm Marie, a frontend developer with 4 years of experience at Acme and Globex. I build React apps, led a redesign that lifted conversion by 30%, and I studied computer science at Paris-Saclay..."
msgstr "ex. Je m'appelle Marie, développeuse frontend avec 4 ans d'expérience chez Acme et Globex. Je crée des applis React, j'ai mené une refonte qui a augmenté la conversion de 30 %, et j'ai étudié l'informatique à Paris-Saclay..."

#: apps/client/src/pages/dashboard/create/page.tsx:246
msgid "e.g. I'm Marie, a frontend developer with 4 years of experience at Acme and Globex. I led a redesign that lifted conversion by 30%, and I studied computer science at Paris-Saclay..."
msgstr "ex. Je m'appelle Marie, développeuse frontend avec 4 ans d'expérience chez Acme et Globex. J'ai mené une refonte qui a augmenté la conversion de 30 %, et j'ai étudié l'informatique à Paris-Saclay..."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:284
msgid "e.g. Paris"
msgstr "ex. Paris"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:273
msgid "e.g. React developer"
msgstr "ex. Développeur React"

#: apps/client/src/pages/home/sections/faq/index.tsx:125
msgid "Each application links back to its job and analysis"
msgstr "Chaque candidature renvoie à son offre et à son analyse"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-list-item.tsx:92
msgid "Edit"
msgstr "Editer"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:21
msgid "Education"
msgstr "Formation"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:169
msgid "Effects"
msgstr "Effets"

#: apps/client/src/pages/auth/forgot-password/page.tsx:82
#: apps/client/src/pages/auth/login/page.tsx:90
#: apps/client/src/pages/auth/register/page.tsx:144
#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:54
#: apps/client/src/pages/dashboard/create/page.tsx:322
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:181
msgid "Email"
msgstr "E-mail"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:140
msgid "Email address detected"
msgstr "Adresse e-mail détectée"

#: apps/client/src/pages/marketing/feedback/page.tsx:64
msgid "Email your feedback"
msgstr "Envoyez vos commentaires par e-mail"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:52
msgid "Emma Parker"
msgstr "Emma Parker"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:163
msgid "Enable 2FA"
msgstr "Activer l'A2F"

#: apps/client/src/pages/home/sections/faq/index.tsx:107
#~ msgid "End-to-end encryption"
#~ msgstr "Chiffrement de bout en bout"

#: apps/client/src/pages/home/sections/features/index.tsx:68
#~ msgid "Enhanced Privacy"
#~ msgstr "Confidentialité Améliorée"

#: apps/client/src/pages/dashboard/create/page.tsx:204
msgid "Enter a few details and pick a template."
msgstr "Saisissez quelques informations et choisissez un template."

#: apps/client/src/pages/auth/reset-password/page.tsx:67
msgid "Enter a new password below, and make sure it's secure."
msgstr "Entrez un nouveau mot de passe ci-dessous, et assurez-vous qu'il est sûr."

#: apps/client/src/pages/auth/backup-otp/page.tsx:59
msgid "Enter one of the 10 backup codes you saved when you enabled two-factor authentication."
msgstr "Saisissez l'un des 10 codes de sauvegarde que vous avez enregistrés lorsque vous avez activé l'authentification à deux facteurs."

#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:56
msgid "Enter Phosphor Icon"
msgstr "Entrer le nom d'une icône Phosphor"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:170
msgid "Enter the 6-digit code from your authenticator app to verify that 2FA has been setup correctly."
msgstr "Entrez le code à 6 chiffres de votre application d'authentification pour vérifier que l'A2F a été correctement configurée."

#: apps/client/src/pages/auth/verify-otp/page.tsx:60
msgid "Enter the one-time password provided by your authenticator app below."
msgstr "Saisissez ci-dessous le mot de passe à usage unique fourni par votre application d'authentification."

#: apps/client/src/pages/auth/forgot-password/page.tsx:70
msgid "Enter your email address and we will send you a link to reset your password if the account exists."
msgstr "Entrez votre adresse e-mail pour recevoir un lien afin de réinitialiser votre mot de passe si le compte existe."

#: apps/client/src/pages/dashboard/organizations/page.tsx:129
#~ msgid "Equip your coaching clients, bootcamp cohort or students. Members inherit your plan."
#~ msgstr "Équipez vos clients coachés, votre promo de bootcamp ou vos étudiants. Les membres héritent de votre plan."

#: apps/client/src/pages/public/error.tsx:46
msgid "Error {statusCode}"
msgstr "Erreur {statusCode}"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:279
msgid "Errors"
msgstr "Erreurs"

#: apps/client/src/pages/marketing/cookies/page.tsx:22
msgid "Essential cookies, which are required for authentication, security, and remembering your preferences. Without them, core features such as signing in would not work."
msgstr "Les cookies essentiels, nécessaires à l'authentification, à la sécurité et à la mémorisation de vos préférences. Sans eux, des fonctionnalités clés comme la connexion ne fonctionneraient pas."

#: apps/client/src/pages/home/sections/features/index.tsx:29
msgid "Every job scored for fit against your resume and sorted best-match first."
msgstr "Chaque offre notée selon sa compatibilité avec votre CV, triée du meilleur au moins bon match."

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:34
msgid "Every premium template"
msgstr "Tous les templates premium"

#: apps/client/src/pages/marketing/pricing/page.tsx:70
msgid "Everything in Free"
msgstr "Tout ce qui est inclus dans Gratuit"

#: apps/client/src/pages/marketing/pricing/page.tsx:89
msgid "Everything in Pro"
msgstr "Tout ce qui est inclus dans Pro"

#: apps/client/src/pages/marketing/sitemap/page.tsx:17
msgid "Everything on Izicvs"
msgstr "Tout sur Izicvs"

#: apps/client/src/pages/home/sections/features/index.tsx:97
msgid "Everything to land the job, in one place."
msgstr "Tout pour décrocher le poste, au même endroit."

#: apps/client/src/pages/marketing/pricing/page.tsx:47
msgid "Everything you need to build a resume and start your search."
msgstr "Tout ce dont vous avez besoin pour créer un CV et démarrer votre recherche."

#: apps/client/src/pages/home/sections/faq/index.tsx:185
msgid "Everything you need to know about our resume creation service. Clear and precise answers to guide you."
msgstr "Tout ce que vous avez besoin de savoir sur notre service de création de CV. Des réponses claires et précises pour vous guider."

#: apps/client/src/pages/dashboard/create/page.tsx:255
msgid "Example"
msgstr "Exemple"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/url-input.tsx:57
msgid "example.com or https://site.com"
msgstr "exemple.com ou https://site.fr"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:54
msgid "Exceptional customer service and concrete results. I tripled my salary thanks to this platform!"
msgstr "Un service à la clientèle exceptionnel et des résultats concrets, j'ai triplé mon salaire grâce à cette plateforme !"

#: apps/client/src/pages/dashboard/_components/impersonation-banner.tsx:42
msgid "Exit"
msgstr "Quitter"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:18
msgid "Experience"
msgstr "Expérience"

#: apps/client/src/pages/home/sections/features/index.tsx:35
msgid "Expert AI panel"
msgstr "Panel d'experts IA"

#: apps/client/src/pages/marketing/pricing/page.tsx:72
msgid "Expert AI panel job match"
msgstr "Correspondance d'emploi par un panel d'experts IA"

#: apps/client/src/pages/dashboard/jobs/page.tsx:389
msgid "Expert panel: ATS engine, recruiter, resume analyst and interview coach"
msgstr "Panel d'experts : moteur ATS, recruteur, analyste CV et coach d'entretien"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:130
#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:35
#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:36
msgid "Export"
msgstr "Exporter"

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:35
msgid "Export and share without limits"
msgstr "Exportez et partagez sans limite"

#: apps/client/src/pages/home/components/footer.tsx:165
#: apps/client/src/pages/home/components/header.tsx:123
#: apps/client/src/pages/marketing/sitemap/page.tsx:61
msgid "FAQ"
msgstr "FAQ"

#: apps/client/src/pages/dashboard/create/page.tsx:189
msgid "Fastest"
msgstr "Le plus rapide"

#: apps/client/src/pages/home/components/footer.tsx:101
#: apps/client/src/pages/home/components/header.tsx:56
#: apps/client/src/pages/home/components/header.tsx:168
#: apps/client/src/pages/marketing/sitemap/page.tsx:34
msgid "Features"
msgstr "Fonctionnalités "

#: apps/client/src/pages/marketing/feedback/page.tsx:37
msgid "Feedback drives our roadmap. Every suggestion, bug report, and kind word helps us decide what to work on next."
msgstr "Vos retours guident notre feuille de route. Chaque suggestion, chaque signalement de bug et chaque mot gentil nous aide à décider de nos prochaines priorités."

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:251
msgid "File"
msgstr "Fichier"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:221
msgid "Filetype"
msgstr "Type de fichier"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:56
msgid "Finance Manager"
msgstr "Gestionnaire des finances"

#: apps/client/src/pages/dashboard/jobs/page.tsx:992
msgid "Find contacts"
msgstr "Trouver des contacts"

#: apps/client/src/pages/dashboard/jobs/page.tsx:917
msgid "Find who to reach at the company and get ready-to-send messages."
msgstr "Identifiez qui contacter dans l'entreprise et obtenez des messages prêts à envoyer."

#: apps/client/src/pages/dashboard/jobs/page.tsx:992
msgid "Finding contacts..."
msgstr "Recherche de contacts..."

#: apps/client/src/pages/home/sections/faq/index.tsx:139
#~ msgid "First month free"
#~ msgstr "Premier mois gratuit"

#: apps/client/src/components/ai-actions.tsx:86
msgid "Fix Spelling & Grammar"
msgstr "Correcteur orthographique"

#: apps/client/src/pages/home/sections/features/index.tsx:57
msgid "Flags fraudulent and ghost postings before you waste your time."
msgstr "Repère les annonces frauduleuses et fantômes avant que vous perdiez du temps."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:316
msgid "Follow this search"
msgstr "Suivre cette recherche"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:325
msgid "Followed searches"
msgstr "Recherches suivies"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:107
msgid "Font Family"
msgstr "Famille de police"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:148
msgid "Font Size"
msgstr "Taille de la police"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:122
msgid "Font Subset"
msgstr "Sous-ensemble de polices"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:134
msgid "Font Variants"
msgstr "Variantes de polices"

#: apps/client/src/pages/dashboard/organizations/page.tsx:858
msgid "For coaches, bootcamps and universities: equip your people and let them inherit your plan."
msgstr "Pour les coachs, bootcamps et universités : équipez vos membres et laissez-les hériter de votre plan."

#: apps/client/src/pages/marketing/pricing/page.tsx:237
msgid "For coaches, bootcamps and universities. Equip your people per seat and track your whole cohort's results from one dashboard."
msgstr "Pour les coachs, bootcamps et universités. Équipez vos membres par siège et suivez les résultats de toute votre cohorte depuis un seul tableau de bord."

#: apps/client/src/pages/home/page.tsx:36
msgid "For each job the AI scores your fit, tailors your resume and writes a cover letter without inventing anything, pre-fills the application form, and flags scam or ghost postings."
msgstr "Pour chaque offre, l'IA évalue votre adéquation, adapte votre CV et rédige une lettre de motivation sans rien inventer, pré-remplit le formulaire de candidature et repère les offres frauduleuses ou fantômes."

#: apps/client/src/pages/home/sections/faq/index.tsx:90
msgid "For each job, the AI does the heavy lifting:"
msgstr "Pour chaque offre, l'IA se charge du plus gros du travail :"

#: apps/client/src/pages/marketing/about/page.tsx:18
msgid "For every role, Izicvs adapts your CV and drafts a matching cover letter, keeping your voice while highlighting what each employer is looking for."
msgstr "Pour chaque poste, Izicvs adapte votre CV et rédige une lettre de motivation adaptée, en préservant votre ton tout en mettant en avant ce que chaque employeur recherche."

#: apps/client/src/pages/builder/sidebars/right/sections/notes.tsx:35
msgid "For example, information regarding which companies you sent this resume to or the links to the job descriptions can be noted down here."
msgstr "Par exemple, des informations sur les entreprises auxquelles vous avez envoyé ce CV ou les liens vers les descriptions de poste peuvent être notées ici."

#: apps/client/src/pages/marketing/pricing/page.tsx:46
msgid "forever"
msgstr "pour toujours"

#: apps/client/src/pages/auth/login/page.tsx:131
msgid "Forgot Password?"
msgstr "Mot de passe oublié ?"

#: apps/client/src/pages/auth/forgot-password/page.tsx:68
msgid "Forgot your password?"
msgstr "Vous avez oublié votre mot de passe ?"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:32
#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:40
msgid "Format"
msgstr "Format"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:23
msgid "Formatting scan"
msgstr "Analyse de la mise en forme"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:49
msgid "Found a bug, or have an idea for a new feature?"
msgstr "Vous avez trouvé un bug, ou avez une idée pour une nouvelle fonctionnalité?"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:20
#: apps/client/src/pages/marketing/pricing/page.tsx:43
msgid "Free"
msgstr "Gratuit"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:61
msgid "Free ATS checker for your resume"
msgstr "Vérificateur ATS gratuit pour votre CV"

#: apps/client/src/pages/home/sections/faq/index.tsx:152
msgid "Free: resume builder, job search and tracker"
msgstr "Gratuit : créateur de CV, recherche d'emploi et suivi"

#: apps/client/src/pages/marketing/faq/page.tsx:10
#: apps/client/src/pages/marketing/faq/page.tsx:13
msgid "Frequently asked questions"
msgstr "Questions fréquentes"

#: apps/client/src/pages/home/sections/faq/index.tsx:182
msgid "Frequently Asked Questions"
msgstr "Foire aux questions"

#: apps/client/src/components/ai-actions.tsx:117
#: apps/client/src/components/ai-actions.tsx:120
msgid "Friendly"
msgstr "Amical"

#: apps/client/src/pages/marketing/pricing/page.tsx:257
msgid "from"
msgstr "à partir de"

#: apps/client/src/pages/dashboard/_components/notifications.tsx:34
msgid "From your followed searches."
msgstr "Depuis vos recherches suivies."

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/ai-card.tsx:28
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/ai-item.tsx:15
#~ msgid "From your notes or an old resume"
#~ msgstr "À partir de vos notes ou d'un ancien CV"

#: apps/client/src/pages/dashboard/create/page.tsx:316
msgid "Frontend Developer"
msgstr "Développeuse frontend"

#: apps/client/src/pages/marketing/pricing/page.tsx:71
msgid "Full AI suite, generous fair-use limit"
msgstr "Suite IA complète, limite d'usage loyal généreuse"

#: apps/client/src/pages/dashboard/create/page.tsx:303
msgid "Full name"
msgstr "Nom complet"

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:31
msgid "Full Name"
msgstr "Prénom et Nom"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:16
msgid "Full Stack Developer"
msgstr "Développeur principal"

#: apps/client/src/pages/home/sections/faq/index.tsx:109
#~ msgid "GDPR compliance"
#~ msgstr "Conformité RGPD"

#: apps/client/src/pages/home/sections/faq/index.tsx:139
msgid "GDPR compliance with export and deletion on request"
msgstr "Conformité au RGPD avec export et suppression sur demande"

#: apps/client/src/pages/marketing/contact/page.tsx:34
msgid "General inquiries"
msgstr "Demandes générales"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:202
msgid "Generate a random title for your resume"
msgstr "Générer un titre aléatoire pour votre CV"

#: apps/client/src/pages/dashboard/jobs/page.tsx:756
msgid "Generate a tailored cover letter for this job, based on your resume."
msgstr "Générez une lettre de motivation adaptée à cette offre, à partir de votre CV."

#: apps/client/src/pages/dashboard/jobs/page.tsx:692
msgid "Generate a tailored resume"
msgstr "Générer un CV adapté"

#: apps/client/src/pages/dashboard/jobs/page.tsx:799
msgid "Generate cover letter"
msgstr "Générer la lettre de motivation"

#: apps/client/src/pages/dashboard/create/page.tsx:277
#: apps/client/src/pages/dashboard/resumes/_dialogs/ai-generate.tsx:87
msgid "Generate my resume"
msgstr "Générer mon CV"

#: apps/client/src/pages/dashboard/jobs/page.tsx:743
msgid "Generate tailored resume"
msgstr "Générer le CV adapté"

#: apps/client/src/pages/dashboard/create/page.tsx:277
msgid "Generating your resume..."
msgstr "Génération de votre CV..."

#: apps/client/src/pages/dashboard/resumes/_dialogs/ai-generate.tsx:87
msgid "Generating..."
msgstr "Génération..."

#: apps/client/src/pages/marketing/ats-checker/page.tsx:53
msgid "Get a score with fixes"
msgstr "Obtenez un score assorti de correctifs"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:34
msgid "Get alerted when key sections like contact details, experience, or skills are absent or incomplete."
msgstr "Soyez alerté lorsque des sections clés comme les coordonnées, l'expérience ou les compétences sont absentes ou incomplètes."

#: apps/client/src/pages/dashboard/jobs/page.tsx:417
msgid "Get an expert panel to review your resume against a job: a strict ATS engine, a recruiter, a resume analyst and an interview coach."
msgstr "Obtenez un panel d'experts pour évaluer votre CV face à une offre : un moteur ATS strict, un recruteur, un analyste CV et un coach d'entretien."

#: apps/client/src/pages/marketing/contact/page.tsx:25
msgid "Get in touch"
msgstr "Prenez contact"

#: apps/client/src/pages/marketing/pricing/page.tsx:341
msgid "Get started"
msgstr "Commencer"

#: apps/client/src/pages/home/sections/hero/call-to-action.tsx:32
msgid "Get Started"
msgstr "Démarrer"

#: apps/client/src/pages/marketing/guides/page.tsx:81
msgid "Get started for free"
msgstr "Commencez gratuitement"

#: apps/client/src/pages/marketing/help/page.tsx:12
msgid "Getting started"
msgstr "Premiers pas"

#: apps/client/src/pages/auth/_components/social-auth.tsx:18
msgid "GitHub"
msgstr "GitHub"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:187
msgid "Give your old resume a new name."
msgstr "Donnez un nouveau nom à votre ancien CV."

#: apps/client/src/pages/marketing/pricing/page.tsx:86
msgid "Go Autopilot"
msgstr "Passer à Autopilot"

#: apps/client/src/pages/marketing/pricing/page.tsx:66
msgid "Go Pro"
msgstr "Passer au Pro"

#: apps/client/src/pages/dashboard/jobs/page.tsx:435
#~ msgid "Go Pro — €9/month"
#~ msgstr "Passer au Pro — 9 €/mois"

#: apps/client/src/pages/dashboard/jobs/page.tsx:459
msgid "Go Pro, €9/month"
msgstr "Passer au Pro, 9 €/mois"

#: apps/client/src/pages/auth/verify-email/page.tsx:67
#: apps/client/src/pages/home/sections/hero/call-to-action.tsx:18
msgid "Go to Dashboard"
msgstr "Accéder au tableau de bord"

#: apps/client/src/pages/public/error.tsx:55
msgid "Go to home"
msgstr "Retourner à la page d'accueil"

#: apps/client/src/pages/home/sections/templates/index.tsx:361
msgid "Go to page"
msgstr "À la page"

#: apps/client/src/pages/auth/_components/social-auth.tsx:31
msgid "Google"
msgstr "Google"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:202
msgid "Grayscale"
msgstr "Niveaux de gris"

#: apps/client/src/pages/dashboard/resumes/page.tsx:118
msgid "Grid"
msgstr "Grille"

#: apps/client/src/pages/home/sections/services/index.tsx:13
msgid "Guaranteed ATS Optimization"
msgstr "Optimisation garantie de l'ATS"

#: apps/client/src/pages/marketing/guides/page.tsx:60
msgid "Guides to move your job search forward"
msgstr "Des guides pour faire avancer votre recherche d'emploi"

#: apps/client/src/pages/marketing/contact/page.tsx:86
msgid "Have an idea that would make Izicvs better? We build with our users, so we would love to hear it."
msgstr "Vous avez une idée qui rendrait Izicvs meilleur ? Nous construisons avec nos utilisateurs, alors nous serions ravis de vous entendre."

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:43
msgid "Headline"
msgstr "Titre"

#: apps/client/src/pages/marketing/help/page.tsx:45
msgid "Help center"
msgstr "Centre d'aide"

#: apps/client/src/pages/home/components/footer.tsx:217
#: apps/client/src/pages/marketing/contact/page.tsx:68
#: apps/client/src/pages/marketing/help/page.tsx:48
#: apps/client/src/pages/marketing/help/page.tsx:52
#: apps/client/src/pages/marketing/sitemap/page.tsx:66
msgid "Help Center"
msgstr "Centre d'assistance"

#: apps/client/src/pages/marketing/feedback/page.tsx:31
msgid "Help shape Izicvs"
msgstr "Aidez à façonner Izicvs"

#: apps/client/src/pages/dashboard/jobs/page.tsx:225
msgid "Here is your expert review below."
msgstr "Votre analyse d'expert est ci-dessous."

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:107
msgid "Here, you can update your account information such as your profile picture, name and username."
msgstr "Ici, vous pouvez mettre à jour les informations de votre compte telles que votre photo de profil, votre nom et votre nom d'utilisateur."

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:68
msgid "Here, you can update your profile to customize and personalize your experience."
msgstr "Ici, vous pouvez mettre à jour votre profil pour personnaliser et personnaliser votre expérience."

#: apps/client/src/pages/builder/sidebars/left/dialogs/languages.tsx:80
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:94
#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:180
msgid "Hidden"
msgstr "Masqué"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:106
msgid "Hide"
msgstr "Masquer"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:192
msgid "Hide Icons"
msgstr "Masquer les icônes"

#: apps/client/src/pages/dashboard/jobs/page.tsx:198
msgid "High risk"
msgstr "Risque élevé"

#: apps/client/src/pages/auth/login/page.tsx:115
#: apps/client/src/pages/auth/register/page.tsx:171
#: apps/client/src/pages/auth/reset-password/page.tsx:88
msgid "Hold <0>Ctrl</0> to display your password temporarily."
msgstr "Maintenez <0>Ctrl</0> pour afficher temporairement votre mot de passe."

#: apps/client/src/pages/dashboard/jobs/page.tsx:391
msgid "Honest attention points before you apply"
msgstr "Des points d'attention honnêtes avant de postuler"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:93
msgid "Horizontal"
msgstr "Horizontal"

#: apps/client/src/pages/marketing/cookies/page.tsx:11
msgid "How and why Izicvs uses cookies."
msgstr "Comment et pourquoi Izicvs utilise des cookies."

#: apps/client/src/pages/marketing/help/page.tsx:53
msgid "How can we help?"
msgstr "Comment pouvons-nous vous aider ?"

#: apps/client/src/pages/home/page.tsx:25
#: apps/client/src/pages/home/sections/faq/index.tsx:70
msgid "How does Izicvs find jobs for me?"
msgstr "Comment Izicvs trouve-t-il des offres pour moi ?"

#: apps/client/src/pages/home/sections/faq/index.tsx:70
#~ msgid "How does our resume generator work?"
#~ msgstr "Comment fonctionne notre générateur de CV ?"

#: apps/client/src/pages/home/page.tsx:33
#: apps/client/src/pages/home/sections/faq/index.tsx:87
msgid "How does the AI help me apply?"
msgstr "Comment l'IA m'aide-t-elle à postuler ?"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:89
msgid "How it works"
msgstr "Comment ça marche"

#: apps/client/src/pages/home/components/header.tsx:116
msgid "How it works?"
msgstr "Comment ça marche ?"

#: apps/client/src/pages/marketing/privacy/page.tsx:11
msgid "How Izicvs collects, uses and protects your data."
msgstr "Comment Izicvs collecte, utilise et protège vos données."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:196
msgid "How machine-readable your resume is. Updates as you edit."
msgstr "À quel point votre CV est lisible par une machine. Se met à jour à la modification."

#: apps/client/src/pages/builder/sidebars/right/sections/interview-practice.tsx:117
msgid "How to improve"
msgstr "Comment améliorer"

#: apps/client/src/pages/marketing/privacy/page.tsx:27
msgid "How we use your information"
msgstr "Comment nous utilisons vos informations"

#: apps/client/src/pages/home/components/header.tsx:195
msgid "HR-approved design"
msgstr "Conception approuvée par HR"

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:162
msgid "I applied"
msgstr "J'ai postulé"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:30
msgid "I tripled my response rate after using this service. The customization is exceptional."
msgstr "J'ai triplé mon taux de réponse après avoir utilisé ce service. La personnalisation est exceptionnelle."

#: apps/client/src/pages/dashboard/create/page.tsx:76
msgid "I'm Karim Benali, a DevOps engineer in Lyon (karim.benali@example.com, 06 12 34 56 78). 6 years of experience. At OVHcloud (2020 to today) I automate Kubernetes deployments and cut release time by 40%. Before that, at Capgemini (2018-2020), I set up GitLab CI/CD pipelines. Skills: AWS, Terraform, Docker, Kubernetes, Python, Ansible. Engineering degree from INSA Lyon, 2018. Languages: French (native), English (fluent)."
msgstr "Je m'appelle Karim Benali, ingénieur DevOps à Lyon (karim.benali@example.com, 06 12 34 56 78). 6 ans d'expérience. Chez OVHcloud (2020 à aujourd'hui), j'automatise des déploiements Kubernetes et j'ai réduit le temps de mise en production de 40 %. Avant, chez Capgemini (2018-2020), j'ai mis en place des pipelines CI/CD GitLab. Compétences : AWS, Terraform, Docker, Kubernetes, Python, Ansible. Diplôme d'ingénieur INSA Lyon, 2018. Langues : français (natif), anglais (courant)."

#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:83
#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:46
msgid "Icon"
msgstr "Icône"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:128
msgid "If you disable two-factor authentication, you will no longer be required to enter a verification code when logging in."
msgstr "Si vous désactivez l'authentification à deux facteurs, il ne vous sera plus demandé de saisir un code de vérification lors de la connexion."

#: apps/client/src/pages/marketing/cookies/page.tsx:36
msgid "If you have questions about our use of cookies, please contact us at privacy@izicvs.com."
msgstr "Si vous avez des questions sur notre utilisation des cookies, veuillez nous contacter à privacy@izicvs.com."

#: apps/client/src/pages/marketing/terms/page.tsx:47
msgid "If you have questions about these terms, please contact us at legal@izicvs.com."
msgstr "Si vous avez des questions sur ces conditions, veuillez nous contacter à legal@izicvs.com."

#: apps/client/src/pages/marketing/privacy/page.tsx:46
msgid "If you have questions about this Privacy Policy or how we handle your data, please contact us at privacy@izicvs.com."
msgstr "Si vous avez des questions sur cette Politique de confidentialité ou sur la façon dont nous traitons vos données, veuillez nous contacter à privacy@izicvs.com."

#: apps/client/src/pages/home/components/header.tsx:187
msgid "Impact phrasing"
msgstr "Expression d'impact"

#: apps/client/src/pages/home/sections/features/index.tsx:30
#~ msgid "Impactful and contextualized job descriptions"
#~ msgstr "Descriptions de poste impactées et contextualisées"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:305
msgid "Import"
msgstr "Importer"

#: apps/client/src/pages/dashboard/resumes/_components/new-resume.tsx:47
msgid "Import a resume"
msgstr "Importer un CV"

#: apps/client/src/pages/dashboard/create/page.tsx:197
#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:208
msgid "Import an existing resume"
msgstr "Importer un CV existant"

#: apps/client/src/components/ai-actions.tsx:81
msgid "Improve Writing"
msgstr "Améliorer l'écriture"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:34
msgid "Improve your writing, fix spelling and grammar, and change the tone of your text with AI while composing your resume. It runs on our servers, so there is nothing to set up."
msgstr "Améliorez votre rédaction, corrigez l'orthographe et la grammaire, et changez le ton de votre texte grâce à l'IA pendant la rédaction de votre CV. Tout se passe sur nos serveurs, rien à configurer."

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:188
msgid "In case you are unable to scan this QR Code, you can also copy-paste this link into your authenticator app."
msgstr "Si vous ne parvenez pas à scanner ce code QR, vous pouvez également copier-coller ce lien dans votre application d'authentification."

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:67
msgid "In this section, you can change your password and enable/disable two-factor authentication."
msgstr "Dans cette section, vous pouvez modifier votre mot de passe et activer/désactiver l'authentification à deux facteurs."

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:64
msgid "In this section, you can delete your account and all the data associated to your user, but please keep in mind that <0>this action is irreversible</0>."
msgstr "Dans cette section, vous pouvez supprimer votre compte et toutes les données associées à votre utilisateur, mais gardez à l'esprit que <0>cette action est irréversible</0>."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:153
msgid "Include experience, education and skills sections."
msgstr "Incluez les sections expérience, formation et compétences."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:144
#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:116
#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:117
msgid "Information"
msgstr "Informations"

#: apps/client/src/pages/marketing/privacy/page.tsx:19
msgid "Information we collect"
msgstr "Informations que nous collectons"

#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:39
msgid "Institution"
msgstr "Établissement"

#: apps/client/src/pages/home/sections/faq/index.tsx:125
#~ msgid "Integrated professional translation"
#~ msgstr "Traduction professionnelle intégrée"

#: apps/client/src/pages/marketing/terms/page.tsx:31
msgid "Intellectual property"
msgstr "Propriété intellectuelle"

#: apps/client/src/pages/home/sections/features/index.tsx:62
#~ msgid "Intelligent Version Management"
#~ msgstr "Gestion intelligente des versions"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:36
msgid "Interests"
msgstr "Centres d'intérêt"

#: apps/client/src/pages/dashboard/applications/page.tsx:231
#: apps/client/src/pages/dashboard/organizations/page.tsx:144
msgid "Interview"
msgstr "Entretien"

#: apps/client/src/pages/dashboard/jobs/page.tsx:659
msgid "Interview Coach"
msgstr "Coach d'entretien"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:396
msgid "Interview practice"
msgstr "Entraînement à l'entretien"

#: apps/client/src/pages/marketing/pricing/page.tsx:73
msgid "Interview simulator with scored feedback"
msgstr "Simulateur d'entretien avec feedback noté"

#: apps/client/src/pages/dashboard/applications/page.tsx:170
msgid "interviews and offers"
msgstr "entretiens et offres"

#: apps/client/src/pages/marketing/privacy/page.tsx:16
msgid "Introduction"
msgstr "Introduction"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:22
msgid "Intuitive interface and professional templates. My resume caught the attention of a recruiter at Google!"
msgstr "Interface intuitive et modèles professionnels. Mon CV a attiré l'attention d'un recruteur chez Google !"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/url-input.tsx:32
msgid "Invalid URL. Examples: google.com, www.example.com, https://site.com"
msgstr "URL invalide. Exemples : google.com, www.exemple.fr, https://site.com"

#: apps/client/src/pages/dashboard/organizations/page.tsx:833
msgid "Invite by email"
msgstr "Inviter par e-mail"

#: apps/client/src/pages/home/page.tsx:57
#: apps/client/src/pages/home/sections/faq/index.tsx:132
msgid "Is my data secure?"
msgstr "Mes données sont-elles en sécurité ?"

#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:53
msgid "Issuer"
msgstr "Émetteur"

#: apps/client/src/services/errors/translate-error.ts:7
msgid "It doesn't look like a user exists with the credentials you provided."
msgstr "Il ne semble pas qu'un utilisateur existe avec les identifiants que vous avez fournis."

#: apps/client/src/pages/home/sections/faq/index.tsx:95
msgid "It flags scam and ghost postings before you waste time"
msgstr "Il signale les offres frauduleuses et fantômes avant que vous ne perdiez du temps"

#: apps/client/src/services/errors/translate-error.ts:37
msgid "It looks like the backup code you provided is invalid or used. Please try again."
msgstr "Il semble que le code de sauvegarde que vous avez fourni soit invalide ou utilisé. Veuillez réessayer."

#: apps/client/src/services/errors/translate-error.ts:19
msgid "It looks like the reset token you provided is invalid. Please try restarting the password reset process again."
msgstr "Il semble que le jeton de réinitialisation que vous avez fourni ne soit pas valide. Veuillez essayer de relancer la procédure de réinitialisation du mot de passe."

#: apps/client/src/services/errors/translate-error.ts:46
msgid "It looks like the resume you're looking for doesn't exist."
msgstr "Il semble que le CV que vous recherchez n'existe pas."

#: apps/client/src/services/errors/translate-error.ts:34
msgid "It looks like the two-factor authentication code you provided is invalid. Please try again."
msgstr "Il semble que le code d'authentification à deux facteurs que vous avez fourni ne soit pas valide. Veuillez réessayer."

#: apps/client/src/services/errors/translate-error.ts:22
msgid "It looks like the verification token you provided is invalid. Please try restarting the verification process again."
msgstr "Il semble que le jeton de vérification que vous avez fourni ne soit pas valide. Veuillez réessayer de redémarrer le processus de vérification."

#: apps/client/src/services/errors/translate-error.ts:25
msgid "It looks like your email address has already been verified."
msgstr "Il semble que votre adresse e-mail a déjà été vérifiée."

#: apps/client/src/pages/home/sections/faq/index.tsx:94
msgid "It pre-fills the application form so you apply in one click"
msgstr "Il pré-remplit le formulaire de candidature pour que vous postuliez en un clic"

#: apps/client/src/pages/home/sections/faq/index.tsx:108
msgid "It prepares matching applications for you automatically"
msgstr "Il prépare automatiquement pour vous des candidatures adaptées"

#: apps/client/src/pages/home/sections/faq/index.tsx:107
msgid "It re-scans your saved searches around the clock"
msgstr "Il réexamine vos recherches enregistrées en continu"

#: apps/client/src/pages/home/sections/faq/index.tsx:109
msgid "It sends a daily digest of your best new matches"
msgstr "Il envoie un résumé quotidien de vos meilleures nouvelles correspondances"

#: apps/client/src/pages/home/sections/faq/index.tsx:93
msgid "It tailors your resume and writes a cover letter, without inventing anything"
msgstr "Il adapte votre CV et rédige une lettre de motivation, sans rien inventer"

#: apps/client/src/pages/auth/backup-otp/page.tsx:52
#: apps/client/src/pages/auth/forgot-password/page.tsx:49
#: apps/client/src/pages/auth/login/page.tsx:55
#: apps/client/src/pages/auth/register/page.tsx:67
#: apps/client/src/pages/auth/reset-password/page.tsx:60
#: apps/client/src/pages/auth/verify-email/page.tsx:43
#: apps/client/src/pages/auth/verify-otp/page.tsx:52
#: apps/client/src/pages/builder/page.tsx:61
#: apps/client/src/pages/dashboard/applications/page.tsx:257
#: apps/client/src/pages/dashboard/create/page.tsx:147
#: apps/client/src/pages/dashboard/jobs/page.tsx:399
#: apps/client/src/pages/dashboard/opportunities/page.tsx:205
#: apps/client/src/pages/dashboard/organizations/page.tsx:841
#: apps/client/src/pages/dashboard/resumes/page.tsx:44
#: apps/client/src/pages/dashboard/settings/page.tsx:17
#: apps/client/src/pages/public/page.tsx:110
#: apps/client/src/pages/public/page.tsx:143
msgid "Izicvs"
msgstr "Izicvs"

#: apps/client/src/pages/home/components/footer.tsx:248
#~ msgid "Izicvs by Nextilabs. All rights reserved."
#~ msgstr ""

#: apps/client/src/pages/marketing/about/page.tsx:13
msgid "Izicvs finds openings from official sources and ranks them against your resume, so you focus on the jobs where you have a real chance."
msgstr "Izicvs trouve des offres à partir de sources officielles et les classe en fonction de votre CV, afin que vous vous concentriez sur les emplois où vous avez une réelle chance."

#: apps/client/src/pages/home/sections/hero/index.tsx:66
#~ msgid "Izicvs finds the jobs, ranks them for your resume, tailors your CV and cover letter, prepares each application and tracks it all — from search to interview."
#~ msgstr "Izicvs trouve les offres, les classe pour votre CV, adapte votre CV et votre lettre, prépare chaque candidature et suit tout — de la recherche à l'entretien."

#: apps/client/src/pages/home/sections/hero/index.tsx:66
msgid "Izicvs finds the jobs, ranks them for your resume, tailors your CV and cover letter, prepares each application and tracks it all, from search to interview."
msgstr "Izicvs trouve les offres, les classe pour votre CV, adapte votre CV et votre lettre de motivation, prépare chaque candidature et suit tout, de la recherche à l'entretien."

#: apps/client/src/pages/home/page.tsx:79
msgid "Izicvs is a modern resume builder that simplifies creating, updating, and sharing professional resumes online."
msgstr "Izicvs est un générateur de CV moderne qui simplifie la création, la mise à jour et le partage de CV professionnels en ligne."

#: apps/client/src/pages/marketing/privacy/page.tsx:17
msgid "Izicvs is an AI powered job search and resume platform operated by Nextilabs. This Privacy Policy explains what information we collect, how we use it, and the choices you have. By using Izicvs, you agree to the practices described here."
msgstr "Izicvs est une plateforme de recherche d'emploi et de création de CV propulsée par l'IA, exploitée par Nextilabs. Cette Politique de confidentialité explique quelles informations nous collectons, comment nous les utilisons et les choix dont vous disposez. En utilisant Izicvs, vous acceptez les pratiques décrites ici."

#: apps/client/src/pages/marketing/about/page.tsx:36
msgid "Izicvs is an AI powered job search platform by Nextilabs, turning the scattered job hunt into one guided flow from finding roles to sending standout applications."
msgstr "Izicvs est une plateforme de recherche d'emploi propulsée par l'IA, signée Nextilabs, qui transforme une recherche dispersée en un parcours guidé, de la découverte des offres à l'envoi de candidatures qui se démarquent."

#: apps/client/src/pages/marketing/about/page.tsx:44
msgid "Izicvs is an AI powered job search platform by Nextilabs. We turn the slow, scattered job hunt into one guided flow, from finding the right roles to sending applications that stand out."
msgstr "Izicvs est une plateforme de recherche d'emploi propulsée par l'IA, développée par Nextilabs. Nous transformons la recherche d'emploi lente et dispersée en un parcours guidé, de la découverte des bons postes à l'envoi de candidatures qui se démarquent."

#: apps/client/src/pages/marketing/terms/page.tsx:20
msgid "Izicvs is an AI powered platform, operated by Nextilabs, that helps you build resumes, analyze your documents, and search for jobs. Features may evolve over time as we improve the product."
msgstr "Izicvs est une plateforme propulsée par l'IA, exploitée par Nextilabs, qui vous aide à créer des CV, à analyser vos documents et à rechercher des emplois. Les fonctionnalités peuvent évoluer au fil du temps à mesure que nous améliorons le produit."

#: apps/client/src/pages/home/sections/logo-cloud/index.tsx:45
msgid "Izicvs is inspired by the resumes of candidates hired at leading French companies."
msgstr "Izicvs s'inspire des CV de candidats recrutés dans de grandes entreprises françaises."

#: apps/client/src/pages/home/sections/logo-cloud/index.tsx:81
#~ msgid "Izicvs is inspired by the resumes of candidates who have been hired by some of the top companies in the world."
#~ msgstr "Izicvs s’appuie sur des modèles de CV qui ont fait leurs preuves auprès de recruteurs de grandes entreprises internationales."

#: apps/client/src/pages/marketing/terms/page.tsx:35
msgid "Izicvs is provided on an as is and as available basis. We do not guarantee employment, interviews, or any specific outcome from using the platform. Results depend on many factors outside our control."
msgstr "Izicvs est fourni « en l'état » et « selon disponibilité ». Nous ne garantissons ni emploi, ni entretien, ni aucun résultat spécifique lié à l'utilisation de la plateforme. Les résultats dépendent de nombreux facteurs indépendants de notre volonté."

#: apps/client/src/pages/marketing/terms/page.tsx:26
msgid "Izicvs offers a Free plan as well as paid Pro and Autopilot plans. Paid plans are billed in advance on a recurring basis. You can cancel at any time, and your plan will remain active until the end of the current billing period. Applicable taxes are included in the prices shown."
msgstr "Izicvs propose une formule Gratuite ainsi que des formules payantes Pro et Autopilot. Les formules payantes sont facturées à l'avance de façon récurrente. Vous pouvez annuler à tout moment, et votre formule restera active jusqu'à la fin de la période de facturation en cours. Les taxes applicables sont incluses dans les prix indiqués."

#: apps/client/src/pages/home/sections/templates/index.tsx:213
msgid "Izicvs offers a library of professional templates optimized for ATS. Each template is designed to highlight your background and increase your chances of landing an interview."
msgstr "Izicvs offre une bibliothèque de modèles professionnels optimisés pour ATS. Chaque modèle est conçu pour mettre en valeur votre arrière-plan et augmenter vos chances de lancer une entrevue."

#: apps/client/src/pages/home/page.tsx:28
msgid "Izicvs pulls real openings from company boards such as Greenhouse, Lever and Ashby and from aggregators like Adzuna and Remotive, then ranks each one against your resume with clear match reasons."
msgstr "Izicvs récupère de vraies offres depuis les sites carrière comme Greenhouse, Lever et Ashby et les agrégateurs comme Adzuna et Remotive, puis classe chacune selon votre CV avec des raisons de correspondance claires."

#: apps/client/src/pages/home/sections/faq/index.tsx:74
msgid "Izicvs pulls real openings from several sources and ranks them for your resume:"
msgstr "Izicvs récupère de vraies offres à partir de plusieurs sources et les classe en fonction de votre CV :"

#: apps/client/src/pages/marketing/cookies/page.tsx:20
msgid "Izicvs uses a limited set of cookies, grouped into the following categories:"
msgstr "Izicvs utilise un ensemble limité de cookies, regroupés dans les catégories suivantes :"

#: apps/client/src/components/copyright.tsx:27
msgid "Izicvs v{appVersion}"
msgstr "Izicvs v{appVersion}"

#: apps/client/src/pages/home/page.tsx:78
msgid "Izicvs, the AI resume and cover letter builder"
msgstr "Izicvs, le créateur de CV et lettres de motivation par IA"

#: apps/client/src/pages/home/components/footer.tsx:248
#~ msgid "Izicvs. All rights reserved."
#~ msgstr "Izicvs. Tous droits réservés."

#: apps/client/src/pages/home/sections/testimonials/index.tsx:12
msgid "Jack Wilson"
msgstr "Jack Wilson"

#: apps/client/src/pages/home/sections/faq/index.tsx:78
msgid "Job aggregators such as Adzuna and Remotive"
msgstr "Des agrégateurs d'offres tels qu'Adzuna et Remotive"

#: apps/client/src/pages/dashboard/organizations/page.tsx:232
msgid "Job analysis"
msgstr "Analyse d'offre"

#: apps/client/src/pages/dashboard/jobs/page.tsx:483
msgid "Job description"
msgstr "Offre d'emploi"

#: apps/client/src/pages/dashboard/_components/sidebar.tsx:116
#: apps/client/src/pages/dashboard/jobs/page.tsx:399
#: apps/client/src/pages/dashboard/jobs/page.tsx:414
msgid "Job Match"
msgstr "Correspondance d'offres"

#: apps/client/src/pages/dashboard/jobs/page.tsx:439
msgid "Job Match is a Pro feature"
msgstr "La Correspondance d'offres est une fonctionnalité Pro"

#: apps/client/src/pages/marketing/pricing/page.tsx:54
msgid "Job search across every source"
msgstr "Recherche d'emploi sur toutes les sources"

#: apps/client/src/pages/marketing/help/page.tsx:22
msgid "Job search and matching"
msgstr "Recherche d'emploi et correspondance"

#: apps/client/src/pages/dashboard/applications/page.tsx:293
msgid "Job title"
msgstr "Intitulé du poste"

#: apps/client/src/pages/home/sections/hero/index.tsx:122
msgid "Jobs ranked for you"
msgstr "Offres classées pour vous"

#: apps/client/src/pages/auth/register/page.tsx:104
msgctxt "Localized version of a placeholder name. For example, Max Mustermann in German or Jan Kowalski in Polish."
msgid "John Doe"
msgstr "Jean Dupont"

#: apps/client/src/pages/auth/register/page.tsx:126
msgctxt "Localized version of a placeholder username. For example, max.mustermann in German or jan.kowalski in Polish."
msgid "john.doe"
msgstr "jean.dupont"

#: apps/client/src/pages/auth/register/page.tsx:148
msgctxt "Localized version of a placeholder email. For example, max.mustermann@example.de in German or jan.kowalski@example.pl in Polish."
msgid "john.doe@example.com"
msgstr "jean.dupont@exemple.com"

#: apps/client/src/pages/marketing/about/page.tsx:71
msgid "Join the candidates who let Izicvs do the heavy lifting. It takes a minute to get started, and you can explore everything for free."
msgstr "Rejoignez les candidats qui laissent Izicvs se charger du plus gros du travail. Il suffit d'une minute pour commencer, et vous pouvez tout explorer gratuitement."

#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:50
msgid "JSON"
msgstr "JSON"

#: apps/client/src/pages/dashboard/create/page.tsx:298
msgid "Just enough to get going. You can complete everything in the editor."
msgstr "Juste ce qu'il faut pour démarrer. Vous compléterez tout dans l'éditeur."

#: apps/client/src/pages/home/sections/features/index.tsx:64
#~ msgid "Keep track of all your applications"
#~ msgstr "Garder une trace de toutes vos applications"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:28
msgid "Keyword match"
msgstr "Correspondance de mots-clés"

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:159
#: apps/client/src/pages/builder/sidebars/left/dialogs/interests.tsx:63
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:159
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:109
#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:71
#: apps/client/src/pages/dashboard/opportunities/page.tsx:270
msgid "Keywords"
msgstr "Mots-clés"

#: apps/client/src/pages/home/sections/features/index.tsx:37
#~ msgid "Know exactly why you'd be shortlisted — or not."
#~ msgstr "Sachez exactement pourquoi vous seriez retenu — ou non."

#: apps/client/src/pages/home/sections/features/index.tsx:37
msgid "Know exactly why you'd be shortlisted, or not."
msgstr "Sachez exactement pourquoi vous seriez retenu, ou non."

#: apps/client/src/pages/builder/sidebars/left/sections/shared/url-input.tsx:70
#: apps/client/src/pages/builder/sidebars/left/sections/shared/url-input.tsx:80
msgid "Label"
msgstr "Étiquette"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:165
msgid "Land an interview"
msgstr "Atteindre un entretien"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:101
msgid "Language"
msgstr "Langue"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:27
msgid "Languages"
msgstr "Langues"

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:95
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:150
msgid "Last updated {lastUpdated}"
msgstr "Dernière mise à jour {lastUpdated}"

#: apps/client/src/pages/marketing/terms/page.tsx:14
msgid "Last updated: these terms may be updated from time to time. Continued use of Izicvs after changes take effect means you accept the revised terms."
msgstr "Dernière mise à jour : ces conditions peuvent être mises à jour de temps à autre. La poursuite de l'utilisation d'Izicvs après l'entrée en vigueur des modifications signifie que vous acceptez les conditions révisées."

#: apps/client/src/pages/marketing/cookies/page.tsx:14
msgid "Last updated: this policy may be updated from time to time to reflect changes in the cookies we use or in applicable law."
msgstr "Dernière mise à jour : cette politique peut être mise à jour de temps à autre pour refléter les changements dans les cookies que nous utilisons ou dans la législation applicable."

#: apps/client/src/pages/marketing/privacy/page.tsx:14
msgid "Last updated: this policy may be updated from time to time. When we make material changes, we will update this page and, where appropriate, notify you."
msgstr "Dernière mise à jour : cette politique peut être mise à jour de temps à autre. Lorsque nous apportons des modifications importantes, nous mettons à jour cette page et, le cas échéant, nous vous en informons."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:74
#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:197
#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:198
msgid "Layout"
msgstr "Mise en page"

#: apps/client/src/pages/home/sections/hero/call-to-action.tsx:38
msgid "Learn more"
msgstr "En savoir plus"

#: apps/client/src/pages/marketing/guides/page.tsx:19
msgid "Learn the formatting rules that keep applicant tracking systems from rejecting your resume before a recruiter ever sees it."
msgstr "Apprenez les règles de mise en forme qui empêchent les systèmes de suivi des candidatures de rejeter votre CV avant même qu'un recruteur ne le voie."

#: apps/client/src/pages/marketing/cookies/page.tsx:9
#: apps/client/src/pages/marketing/privacy/page.tsx:9
#: apps/client/src/pages/marketing/sitemap/page.tsx:96
#: apps/client/src/pages/marketing/terms/page.tsx:9
msgid "Legal"
msgstr "Mentions légales"

#: apps/client/src/pages/dashboard/jobs/page.tsx:860
msgid "Legitimacy check"
msgstr "Vérification de légitimité"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:75
#: apps/client/src/pages/dashboard/jobs/page.tsx:185
msgid "Length"
msgstr "Longueur"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:170
msgid "Length: {0} words"
msgstr "Longueur : {0} mots"

#: apps/client/src/pages/marketing/pricing/page.tsx:85
msgid "Let the agent run your search around the clock."
msgstr "Laissez l'agent mener votre recherche en continu."

#: apps/client/src/pages/dashboard/create/page.tsx:180
msgid "Let's build your resume"
msgstr "Créons votre CV"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:44
msgid "Letter"
msgstr "Lettre"

#: apps/client/src/pages/builder/sidebars/left/dialogs/languages.tsx:64
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:77
msgid "Level"
msgstr "Niveau"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:86
msgid "Light"
msgstr "Clair"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:378
#~ msgid "Likely interview questions"
#~ msgstr "Questions d'entretien probables"

#: apps/client/src/pages/marketing/terms/page.tsx:37
msgid "Limitation of liability"
msgstr "Limitation de responsabilité"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:165
msgid "Line Height"
msgstr "Interligne"

#: apps/client/src/pages/dashboard/organizations/page.tsx:209
msgid "Link"
msgstr "Lien"

#: apps/client/src/pages/dashboard/jobs/page.tsx:936
msgid "LinkedIn message"
msgstr "Message LinkedIn"

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/import-card.tsx:33
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/import-item.tsx:22
#~ msgid "LinkedIn, JSON Resume, etc."
#~ msgstr "LinkedIn, CV JSON, etc."

#: apps/client/src/pages/dashboard/create/page.tsx:198
msgid "LinkedIn, JSON Resume, or an Izicvs file."
msgstr "LinkedIn, JSON Resume, ou un fichier Izicvs."

#: apps/client/src/pages/dashboard/resumes/page.tsx:122
msgid "List"
msgstr "Liste"

#: apps/client/src/pages/marketing/pricing/page.tsx:53
msgid "Live ATS readiness check"
msgstr "Contrôle de lisibilité ATS en direct"

#: apps/client/src/pages/dashboard/organizations/page.tsx:222
msgid "Loading analyses..."
msgstr "Chargement des analyses..."

#: apps/client/src/pages/dashboard/organizations/page.tsx:186
msgid "Loading applications..."
msgstr "Chargement des candidatures..."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:482
#~ msgid "Loading offers..."
#~ msgstr "Chargement des offres..."

#: apps/client/src/pages/dashboard/organizations/page.tsx:160
msgid "Loading resumes..."
msgstr "Chargement des CV..."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:50
#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:44
msgid "Loading..."
msgstr "Chargement..."

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:101
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:86
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:81
#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:93
msgid "Location"
msgstr "Emplacement"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:281
msgid "Location (optional)"
msgstr "Lieu (optionnel)"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:51
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:133
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:125
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:177
msgid "Lock"
msgstr "Verrouiller"

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:83
msgid "Locked"
msgstr "Verrouillé"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:43
msgid "Locking a resume will prevent any further changes to it. This is useful when you have already shared your resume with someone and you don't want to accidentally make any changes to it."
msgstr "Le verrouillage d'un CV empêche toute modification ultérieure. Cette fonction est utile lorsque vous avez déjà partagé votre CV avec quelqu'un et que vous ne voulez pas le modifier accidentellement."

#: apps/client/src/pages/home/components/header.tsx:227
msgid "Login"
msgstr "Connexion"

#: apps/client/src/components/user-options.tsx:38
#: apps/client/src/pages/home/sections/hero/call-to-action.tsx:23
msgid "Logout"
msgstr "Déconnexion"

#: apps/client/src/pages/dashboard/jobs/page.tsx:196
msgid "Looks legit"
msgstr "Semble fiable"

#: apps/client/src/pages/auth/verify-otp/page.tsx:64
msgid "Lost your device?"
msgstr "Vous avez perdu votre appareil ?"

#: apps/client/src/components/copyright.tsx:24
#~ msgid "Made with love, built with care."
#~ msgstr "Fabriqué avec amour, construit avec soin."

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:247
msgid "Main"
msgstr "Principal"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:70
msgid "Make sure your resume gets read"
msgstr "Assurez-vous que votre CV soit lu"

#: apps/client/src/pages/dashboard/organizations/page.tsx:271
#~ msgid "Manage"
#~ msgstr "Gérer"

#: apps/client/src/pages/dashboard/organizations/page.tsx:303
msgid "Manage account"
msgstr "Gérer le compte"

#: apps/client/src/pages/dashboard/organizations/page.tsx:624
msgid "Manage billing"
msgstr "Gérer la facturation"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:83
msgid "Manage subscription"
msgstr "Gérer mon abonnement"

#: apps/client/src/pages/marketing/help/page.tsx:33
msgid "Manage your plan, invoices, and payment details."
msgstr "Gérez votre formule, vos factures et vos informations de paiement."

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:39
msgid "Manage your plan, payment method and invoices."
msgstr "Gérez votre formule, votre moyen de paiement et vos factures."

#: apps/client/src/pages/marketing/cookies/page.tsx:29
msgid "Managing cookies"
msgstr "Gestion des cookies"

#. The month and year should be uniform across all languages.
#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:71
#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:69
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:69
msgid "March 2023"
msgstr "Mars 2023"

#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:112
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:74
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:103
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:69
msgid "March 2023 - Present"
msgstr "Mars 2023 - Aujourd'hui"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:50
msgid "Margin"
msgstr "Marge"

#: apps/client/src/pages/dashboard/create/page.tsx:307
msgid "Marie Dupont"
msgstr "Marie Dupont"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:20
msgid "Marie Durant"
msgstr "Marie Durant"

#: apps/client/src/pages/dashboard/create/page.tsx:326
msgid "marie@email.com"
msgstr "marie@email.com"

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:75
msgid "Marked as applied"
msgstr "Marquée comme postulée"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:40
msgid "Marketing Specialist"
msgstr "Spécialiste Marketing"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:399
msgid "Match against"
msgstr "Comparer à"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:238
msgid "Match against a job"
msgstr "Comparer à une offre"

#: apps/client/src/pages/marketing/guides/page.tsx:29
msgid "Match your experience to every posting by mirroring the right keywords and highlighting the skills each role needs."
msgstr "Faites correspondre votre expérience à chaque offre en reprenant les bons mots-clés et en mettant en avant les compétences requises par chaque poste."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:334
msgid "Matched keywords"
msgstr "Mots-clés trouvés"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:366
msgid "Maybe"
msgstr "Peut-être"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:39
msgid "Measure clarity, length, and structure so both software and recruiters can read your resume with ease."
msgstr "Mesurez la clarté, la longueur et la structure pour que les logiciels comme les recruteurs puissent lire votre CV avec aisance."

#: apps/client/src/pages/dashboard/organizations/page.tsx:216
#~ msgid "member"
#~ msgstr "membre"

#: apps/client/src/pages/dashboard/organizations/page.tsx:370
msgid "Member added."
msgstr "Membre ajouté."

#: apps/client/src/pages/dashboard/organizations/page.tsx:395
msgid "member@email.com"
msgstr "membre@email.com"

#: apps/client/src/pages/dashboard/organizations/page.tsx:384
#: apps/client/src/pages/dashboard/organizations/page.tsx:506
msgid "Members"
msgstr "Membres"

#: apps/client/src/pages/dashboard/organizations/page.tsx:708
msgid "Members draw from this shared pool. Overage uses the purchased balance, which never expires."
msgstr "Les membres puisent dans cette réserve partagée. Le dépassement utilise le solde acheté, qui n'expire jamais."

#: apps/client/src/pages/dashboard/organizations/page.tsx:834
msgid "Members instantly get Pro or Autopilot."
msgstr "Les membres passent aussitôt en Pro ou Autopilot."

#: apps/client/src/pages/dashboard/organizations/page.tsx:456
msgid "Members' plan"
msgstr "Plan des membres"

#: apps/client/src/pages/home/sections/templates/index.tsx:160
msgid "Minimalist"
msgstr "Minimaliste"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:310
#: apps/client/src/pages/dashboard/jobs/page.tsx:572
msgid "Missing keywords"
msgstr "Mots-clés manquants"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:33
msgid "Missing sections"
msgstr "Sections manquantes"

#: apps/client/src/pages/dashboard/organizations/page.tsx:682
msgid "Monthly allowance"
msgstr "Allocation mensuelle"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:40
msgid "Monthly usage"
msgstr "Usage mensuel"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:164
msgid "More responses"
msgstr "Plus de réponses"

#: apps/client/src/pages/marketing/pricing/page.tsx:146
msgid "Most popular"
msgstr "Le plus populaire"

#: apps/client/src/pages/home/sections/features/index.tsx:42
#~ msgid "Multi-format Generation"
#~ msgstr "Génération de formats multiples"

#: apps/client/src/pages/home/sections/features/index.tsx:21
msgid "Multi-source sourcing"
msgstr "Sourcing multi-sources"

#: apps/client/src/pages/dashboard/create/page.tsx:89
#: apps/client/src/pages/dashboard/create/page.tsx:118
msgid "My resume"
msgstr "Mon CV"

#: apps/client/src/pages/builder/_components/header.tsx:34
#: apps/client/src/pages/dashboard/_components/sidebar.tsx:110
#: apps/client/src/pages/dashboard/resumes/page.tsx:56
msgid "My resumes"
msgstr "Mes CV"

#: apps/client/src/pages/auth/register/page.tsx:101
#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:59
#: apps/client/src/pages/builder/sidebars/left/dialogs/interests.tsx:48
#: apps/client/src/pages/builder/sidebars/left/dialogs/languages.tsx:36
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:73
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:39
#: apps/client/src/pages/builder/sidebars/left/dialogs/references.tsx:39
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:49
#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:81
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:153
msgid "Name"
msgstr "Nom"

#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:39
msgctxt "Name of the Certification"
msgid "Name"
msgstr "Nom"

#: apps/client/src/pages/marketing/pricing/page.tsx:325
msgid "Need more AI? Top up anytime."
msgstr "Besoin de plus d'IA ? Rechargez quand vous voulez."

#: apps/client/src/pages/marketing/guides/page.tsx:43
msgid "Negotiate your offer"
msgstr "Négociez votre offre"

#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:40
msgid "Network"
msgstr "Réseau"

#: apps/client/src/pages/dashboard/_components/notifications.tsx:33
msgid "New offers"
msgstr "Nouvelles offres"

#: apps/client/src/pages/dashboard/organizations/page.tsx:953
msgid "New organization"
msgstr "Nouvelle organisation"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:96
msgid "New Password"
msgstr "Nouveau mot de passe"

#: apps/client/src/pages/dashboard/resumes/_components/new-resume.tsx:62
msgid "New resume"
msgstr "Nouveau CV"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:67
msgid "Next renewal on {renewDate}."
msgstr "Prochain renouvellement le {renewDate}."

#: apps/client/src/pages/home/sections/templates/index.tsx:375
msgid "Next template"
msgstr "Modèle suivant"

#: apps/client/src/pages/dashboard/organizations/page.tsx:614
msgid "No active subscription"
msgstr "Aucun abonnement actif"

#: apps/client/src/pages/dashboard/organizations/page.tsx:224
msgid "No analysis run yet."
msgstr "Aucune analyse lancée pour le moment."

#: apps/client/src/pages/dashboard/organizations/page.tsx:188
msgid "No application tracked yet."
msgstr "Aucune candidature suivie pour le moment."

#: apps/client/src/pages/dashboard/organizations/page.tsx:549
msgid "No members to track yet."
msgstr "Aucun membre à suivre pour l'instant."

#: apps/client/src/pages/dashboard/organizations/page.tsx:414
msgid "No members yet. Add seats by email above."
msgstr "Aucun membre. Ajoutez des sièges par e-mail ci-dessus."

#: apps/client/src/pages/dashboard/organizations/page.tsx:84
#~ msgid "No members yet. Add seats by email."
#~ msgstr "Aucun membre pour l'instant. Ajoutez des sièges par e-mail."

#: apps/client/src/pages/dashboard/_components/notifications.tsx:54
msgid "No new offers."
msgstr "Aucune nouvelle offre."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:436
msgid "No offers yet"
msgstr "Aucune offre pour le moment"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:524
#~ msgid "No offers yet. Run a search to pull in fresh listings."
#~ msgstr "Aucune offre pour l'instant. Lancez une recherche pour en récupérer."

#: apps/client/src/pages/dashboard/organizations/page.tsx:190
#~ msgid "No organization yet"
#~ msgstr "Aucune organisation pour le moment"

#: apps/client/src/pages/dashboard/organizations/page.tsx:181
#~ msgid "No organization yet. Create one to grant your members a plan."
#~ msgstr "Aucune organisation. Créez-en une pour offrir un plan à vos membres."

#: apps/client/src/pages/home/sections/faq/index.tsx:108
#~ msgid "No reselling of personal data"
#~ msgstr "Pas de revente des données personnelles"

#: apps/client/src/components/locale-combobox.tsx:45
msgid "No results found"
msgstr "Aucun résultat trouvé"

#: apps/client/src/pages/dashboard/organizations/page.tsx:162
msgid "No resume to edit yet."
msgstr "Aucun CV à modifier pour le moment."

#: apps/client/src/pages/dashboard/resumes/_components/empty-state.tsx:30
msgid "No resumes found"
msgstr "Aucun CV trouvé"

#: apps/client/src/pages/home/sections/features/index.tsx:100
#~ msgid "Not just a resume builder — a full AI job-search platform that finds the right jobs, tailors your application, and follows every step from search to interview."
#~ msgstr "Pas qu'un créateur de CV — une plateforme IA complète qui trouve les bonnes offres, adapte votre candidature et suit chaque étape, de la recherche à l'entretien."

#: apps/client/src/pages/home/sections/features/index.tsx:100
msgid "Not just a resume builder: a full AI job-search platform that finds the right jobs, tailors your application, and follows every step from search to interview."
msgstr "Pas qu'un créateur de CV : une véritable plateforme de recherche d'emploi par IA qui trouve les bonnes offres, adapte votre candidature et suit chaque étape, de la recherche à l'entretien."

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:133
msgid "Note: This will make your account less secure."
msgstr "Remarque : Cela rendra votre compte moins sécurisé."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:137
#: apps/client/src/pages/builder/sidebars/right/sections/notes.tsx:16
#: apps/client/src/pages/builder/sidebars/right/sections/notes.tsx:17
msgid "Notes"
msgstr "Notes"

#: apps/client/src/pages/dashboard/resumes/_components/empty-state.tsx:32
msgid "Nothing matches your search"
msgstr "Rien ne correspond à votre recherche"

#: apps/client/src/pages/dashboard/applications/page.tsx:232
#: apps/client/src/pages/dashboard/organizations/page.tsx:145
msgid "Offer"
msgstr "Offre"

#: apps/client/src/pages/dashboard/applications/page.tsx:172
msgid "Offer rate"
msgstr "Taux d'offre"

#: apps/client/src/pages/dashboard/_components/sidebar.tsx:122
#: apps/client/src/pages/dashboard/opportunities/page.tsx:205
#: apps/client/src/pages/dashboard/opportunities/page.tsx:219
#: apps/client/src/pages/dashboard/organizations/page.tsx:509
msgid "Offers"
msgstr "Offres"

#: apps/client/src/pages/home/sections/hero/index.tsx:126
msgid "Official ATS sources"
msgstr "Sources ATS officielles"

#: apps/client/src/pages/home/sections/faq/index.tsx:77
msgid "Official company boards through Greenhouse, Lever and Ashby"
msgstr "Les sites carrières officiels des entreprises via Greenhouse, Lever et Ashby"

#: apps/client/src/pages/home/sections/faq/index.tsx:105
msgid "On the Autopilot plan, Izicvs keeps working while you do not:"
msgstr "Avec la formule Autopilot, Izicvs continue de travailler pendant que vous ne le faites pas :"

#: apps/client/src/pages/home/page.tsx:44
msgid "On the Autopilot plan, Izicvs re-scans your saved searches around the clock, prepares matching applications automatically and sends a daily digest. Nothing is sent without your approval."
msgstr "Avec le forfait Autopilot, Izicvs réanalyse vos recherches enregistrées en continu, prépare automatiquement les candidatures correspondantes et envoie un résumé quotidien. Rien n'est envoyé sans votre accord."

#: apps/client/src/pages/dashboard/jobs/page.tsx:191
msgid "On the fence"
msgstr "Mitigé"

#: apps/client/src/pages/home/sections/features/index.tsx:49
#: apps/client/src/pages/home/sections/hero/index.tsx:130
msgid "One-click apply"
msgstr "Candidature en 1 clic"

#: apps/client/src/pages/marketing/pricing/page.tsx:75
msgid "One-click apply, pre-filled by AI"
msgstr "Postulez en un clic, avec un formulaire pré-rempli par l'IA"

#: apps/client/src/pages/auth/verify-otp/page.tsx:82
msgid "One-Time Password"
msgstr "Mot de passe à usage unique"

#: apps/client/src/components/ai-actions.tsx:52
#: apps/client/src/libs/axios.ts:39
#: apps/client/src/pages/dashboard/applications/page.tsx:245
#: apps/client/src/pages/dashboard/jobs/page.tsx:230
#: apps/client/src/pages/dashboard/jobs/page.tsx:251
#: apps/client/src/pages/dashboard/jobs/page.tsx:271
#: apps/client/src/pages/dashboard/jobs/page.tsx:291
#: apps/client/src/pages/dashboard/jobs/page.tsx:311
#: apps/client/src/pages/dashboard/jobs/page.tsx:334
#: apps/client/src/pages/dashboard/jobs/page.tsx:354
#: apps/client/src/pages/dashboard/jobs/page.tsx:378
#: apps/client/src/pages/dashboard/opportunities/page.tsx:113
#: apps/client/src/pages/dashboard/opportunities/page.tsx:133
#: apps/client/src/pages/dashboard/opportunities/page.tsx:173
#: apps/client/src/pages/dashboard/opportunities/page.tsx:195
#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:188
#: apps/client/src/services/resume/print.tsx:59
msgid "Oops, the server returned an error."
msgstr "Oups, le serveur a renvoyé une erreur."

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:116
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:87
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:159
msgid "Open"
msgstr "Ouvrir"

#: apps/client/src/pages/dashboard/jobs/page.tsx:733
msgid "Open in the editor"
msgstr "Ouvrir dans l'éditeur"

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:156
msgid "Open offer to apply"
msgstr "Ouvrir l'offre pour postuler"

#: apps/client/src/pages/home/sections/faq/index.tsx:95
#~ msgid "Optimizing keywords for ATS systems"
#~ msgstr "Optimisation des mots-clés pour les systèmes ATS"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:67
#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:182
#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:135
msgid "Options"
msgstr "Options"

#: apps/client/src/pages/auth/layout.tsx:47
msgctxt "The user can either login with email/password, or continue with GitHub or Google."
msgid "or continue with"
msgstr "ou continuer avec"

#: apps/client/src/pages/dashboard/create/page.tsx:218
msgid "Or open a blank editor"
msgstr "Ou ouvrir un éditeur vide"

#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:39
msgid "Organization"
msgstr "Organisation"

#: apps/client/src/pages/dashboard/organizations/page.tsx:821
msgid "Organization created."
msgstr "Organisation créée."

#: apps/client/src/pages/dashboard/organizations/page.tsx:447
#: apps/client/src/pages/dashboard/organizations/page.tsx:958
msgid "Organization name"
msgstr "Nom de l'organisation"

#: apps/client/src/pages/dashboard/_components/sidebar.tsx:134
#: apps/client/src/pages/dashboard/organizations/page.tsx:841
#: apps/client/src/pages/dashboard/organizations/page.tsx:855
msgid "Organizations"
msgstr "Organisations"

#: apps/client/src/pages/marketing/about/page.tsx:22
msgid "Organized applications"
msgstr "Des candidatures organisées"

#: apps/client/src/pages/home/sections/templates/index.tsx:149
msgid "Original and distinctive, suitable for creative industries."
msgstr "Original et distinctif, adapté aux industries créatives."

#: apps/client/src/pages/home/sections/services/index.tsx:28
msgid "Our AI analyzes your background and suggests impactful phrasing that transforms your experience into an impact story."
msgstr "Notre IA analyse votre arrière-plan et suggère une formulation impactante qui transforme votre expérience en une histoire d'impact."

#: apps/client/src/pages/home/sections/faq/index.tsx:90
#~ msgid "Our AI assistant revolutionizes resume writing by:"
#~ msgstr "Notre assistant IA révolutionne l'écriture de CV par:"

#: apps/client/src/pages/home/sections/features/index.tsx:178
msgid "Our commitment: transforming every application into a career opportunity."
msgstr "Notre engagement : transformer chaque candidature en une opportunité de carrière."

#: apps/client/src/pages/marketing/about/page.tsx:49
msgid "Our mission"
msgstr "Notre mission"

#: apps/client/src/pages/home/sections/faq/index.tsx:120
#~ msgid "Our platform is designed for a global professional market:"
#~ msgstr "Notre plateforme est conçue pour un marché professionnel mondial :"

#: apps/client/src/pages/home/sections/faq/index.tsx:74
#~ msgid "Our platform uses a unique combination of technologies to create professional resumes:"
#~ msgstr "Notre plateforme utilise une combinaison unique de technologies pour créer des CV professionnels :"

#: apps/client/src/pages/home/components/footer.tsx:58
msgid "Our resume creation platform uses AI and the latest technologies to help you overcome ATS barriers and secure more interviews."
msgstr "Notre plateforme de création de CV utilise AI et les dernières technologies pour vous aider à surmonter les barrières ATS et à sécuriser davantage d'entrevues."

#: apps/client/src/pages/home/sections/services/index.tsx:14
msgid "Our smart algorithms analyze your resume in real-time to ensure an ATS optimization score above 87%."
msgstr "Nos algorithmes intelligents analysent votre CV en temps réel pour garantir un score d'optimisation ATS supérieur à 87 %."

#: apps/client/src/pages/home/sections/hero/index.tsx:66
#~ msgid "Our smart resumes beat ATS algorithms and captivate recruiters."
#~ msgstr "Nos CV intelligents déjouent les algorithmes ATS et captivent les recruteurs."

#: apps/client/src/pages/marketing/help/page.tsx:73
msgid "Our team is happy to answer your questions and help you get the most out of Izicvs."
msgstr "Notre équipe se fera un plaisir de répondre à vos questions et de vous aider à tirer le meilleur parti d'Izicvs."

#: apps/client/src/pages/home/sections/testimonials/index.tsx:188
msgid "Our users' satisfaction speaks for itself"
msgstr "La satisfaction de nos utilisateurs parle d'elle-même"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:76
msgid "Out of tokens? Buy a pack to keep going. Purchased tokens never expire."
msgstr "Plus de tokens ? Achetez un pack pour continuer. Les tokens achetés n'expirent jamais."

#: apps/client/src/pages/home/sections/testimonials/index.tsx:237
msgid "Over 5000 positive reviews"
msgstr "Plus de 900 avis positifs"

#: apps/client/src/pages/dashboard/organizations/page.tsx:314
msgid "Overview"
msgstr "Aperçu"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:102
#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:25
#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:26
msgid "Page"
msgstr "Page"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:228
msgid "Page {pageNumber}"
msgstr "Page {pageNumber}"

#: apps/client/src/pages/marketing/contact/page.tsx:37
msgid "Partnerships, press, or anything else on your mind. Drop us a line and we will get back to you."
msgstr "Partenariats, presse ou tout autre sujet en tête. Écrivez-nous et nous vous répondrons."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:367
msgid "Pass"
msgstr "Écarté"

#: apps/client/src/pages/home/components/header.tsx:178
msgid "Pass automated filters"
msgstr "Passer les filtres automatisés"

#: apps/client/src/pages/dashboard/jobs/page.tsx:192
msgid "Passed"
msgstr "Écarté"

#: apps/client/src/pages/auth/login/page.tsx:110
#: apps/client/src/pages/auth/register/page.tsx:166
#: apps/client/src/pages/auth/reset-password/page.tsx:83
#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:73
msgid "Password"
msgstr "Mot de passe"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:257
msgid "Paste a job description to score how well this resume matches it and get concrete, ATS-friendly fixes."
msgstr "Collez une offre d'emploi pour évaluer la correspondance de ce CV et obtenir des corrections concrètes et compatibles ATS."

#: apps/client/src/pages/marketing/ats-checker/page.tsx:45
msgid "Paste or pick your resume"
msgstr "Collez ou sélectionnez votre CV"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:81
msgid "Paste the full job description to analyze."
msgstr "Collez l'offre d'emploi complète pour lancer l'analyse."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:263
msgid "Paste the job description here..."
msgstr "Collez l'offre d'emploi ici..."

#: apps/client/src/pages/marketing/ats-checker/page.tsx:50
msgid "Paste the job description you are targeting so we can compare against it."
msgstr "Collez la description du poste que vous visez afin que nous puissions la comparer à votre CV."

#: apps/client/src/pages/home/sections/templates/index.tsx:388
msgid "Pause"
msgstr "Suspendre"

#: apps/client/src/services/billing/index.ts:12
msgid "Payment could not be started"
msgstr "Le paiement n'a pas pu démarrer"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:61
msgid "Payment due"
msgstr "Paiement en retard"

#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:68
msgid "PDF"
msgstr "PDF"

#: apps/client/src/pages/marketing/pricing/page.tsx:64
#: apps/client/src/pages/marketing/pricing/page.tsx:84
msgid "per month"
msgstr "par mois"

#: apps/client/src/pages/dashboard/organizations/page.tsx:743
msgid "Per seat"
msgstr "Par siège"

#: apps/client/src/pages/marketing/pricing/page.tsx:241
msgid "Per-seat billing"
msgstr "Facturation par siège"

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:81
msgid "Phone"
msgstr "Téléphone"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:146
msgid "Phone number detected"
msgstr "Numéro de téléphone détecté"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:99
msgid "Photo of {name}"
msgstr "Photo de {name}"

#: apps/client/src/pages/auth/layout.tsx:76
msgid "Photograph by Patrick Tomasso"
msgstr "Photographie de Patrick Tomasso"

#: apps/client/src/pages/dashboard/organizations/page.tsx:832
msgid "Pick the plan your members should get."
msgstr "Choisissez le plan que vos membres recevront."

#: apps/client/src/pages/dashboard/create/page.tsx:349
msgid "Pick your style"
msgstr "Choisissez votre style"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/section.tsx:69
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:121
msgid "Picture"
msgstr "Photo"

#: apps/client/src/pages/dashboard/organizations/page.tsx:666
#~ msgid "Plan granted"
#~ msgstr "Plan accordé"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/url-input.tsx:29
msgid "Please enter a URL"
msgstr "Veuillez saisir une URL"

#: apps/client/src/pages/auth/verify-email/page.tsx:59
msgid "Please note that this step is completely optional."
msgstr "Veuillez noter que cette étape est totalement optionnelle."

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:225
msgid "Please select a file type"
msgstr "Veuillez sélectionner un type de fichier"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:228
msgid "Please store your backup codes in a secure location. You can use one of these one-time use codes to login in case you lose access to your authenticator app."
msgstr "Veuillez conserver vos codes de sauvegarde dans un endroit sécurisé. Vous pouvez utiliser l'un de ces codes à usage unique pour vous connecter au cas où vous perdriez l'accès à votre application d'authentification."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:66
msgid "Plus {0} purchased tokens available."
msgstr "Plus {0} tokens achetés disponibles."

#: apps/client/src/pages/dashboard/jobs/page.tsx:718
msgid "Points to review before sending"
msgstr "Points à vérifier avant d'envoyer"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:99
msgid "Portrait"
msgstr "Portrait"

#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:54
msgctxt "Position held at a company, for example, Software Engineer"
msgid "Position"
msgstr "Poste"

#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:53
msgid "Position"
msgstr "Poste"

#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:94
msgid "Powered by <0>Simple Icons</0>"
msgstr "Réalisé par <0>Simple Icons</0>"

#: apps/client/src/pages/marketing/guides/page.tsx:61
msgid "Practical, no-nonsense advice on writing your resume, acing interviews, and landing the job you want."
msgstr "Des conseils pratiques et sans détour pour rédiger votre CV, réussir vos entretiens et décrocher le poste que vous voulez."

#: apps/client/src/pages/marketing/guides/page.tsx:52
msgid "Practical, no-nonsense guides on writing your resume, acing interviews and landing the job you want."
msgstr "Des guides pratiques et directs pour rédiger votre CV, réussir vos entretiens et décrocher le poste que vous visez."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:72
#: apps/client/src/pages/dashboard/jobs/page.tsx:182
msgid "Preferred keywords"
msgstr "Mots-clés souhaités"

#: apps/client/src/pages/home/sections/templates/index.tsx:205
msgid "Premium Templates"
msgstr "Modèle Premium"

#: apps/client/src/pages/dashboard/_components/billing-return.tsx:27
msgid "Premium templates are now unlocked."
msgstr "Les modèles premium sont maintenant débloqués."

#: apps/client/src/pages/marketing/pricing/page.tsx:292
msgid "Premium templates pass"
msgstr "Pass templates premium"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:107
msgid "Premium templates pass active until {passDate}."
msgstr "Pass modèles premium actif jusqu'au {passDate}."

#: apps/client/src/pages/dashboard/jobs/page.tsx:674
msgid "Preparation tips"
msgstr "Conseils de préparation"

#: apps/client/src/pages/dashboard/opportunities/_components/job-card.tsx:124
msgid "Prepare application"
msgstr "Préparer la candidature"

#: apps/client/src/pages/marketing/guides/page.tsx:38
msgid "Prepare for the interview"
msgstr "Préparez l'entretien"

#: apps/client/src/pages/marketing/about/page.tsx:23
msgid "Prepare, send, and track your applications in one place. Nothing slips through the cracks, from first draft to final follow up."
msgstr "Préparez, envoyez et suivez vos candidatures au même endroit. Rien ne passe entre les mailles du filet, du premier brouillon à la relance finale."

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:86
msgid "Prepared application"
msgstr "Candidature préparée"

#: apps/client/src/pages/home/sections/templates/index.tsx:319
msgid "Preview PDF"
msgstr "Aperçu PDF"

#: apps/client/src/pages/home/sections/templates/index.tsx:345
msgid "Previous template"
msgstr "Modèle précédent"

#: apps/client/src/pages/marketing/pricing/page.tsx:347
msgid "Prices in euros, taxes included. You can upgrade, downgrade or cancel your plan at any time from your dashboard."
msgstr "Prix en euros, taxes comprises. Vous pouvez faire évoluer, rétrograder ou annuler votre formule à tout moment depuis votre tableau de bord."

#: apps/client/src/pages/home/components/footer.tsx:118
#: apps/client/src/pages/home/components/header.tsx:108
#: apps/client/src/pages/home/components/header.tsx:222
#: apps/client/src/pages/marketing/pricing/page.tsx:105
#: apps/client/src/pages/marketing/pricing/page.tsx:121
#: apps/client/src/pages/marketing/sitemap/page.tsx:29
msgid "Pricing"
msgstr "Tarifs"

#: apps/client/src/pages/marketing/pricing/page.tsx:102
msgid "Pricing, plans that grow with your job search"
msgstr "Tarifs, des forfaits qui évoluent avec votre recherche d'emploi"

#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:43
msgid "Primary Color"
msgstr "Couleur Primaire"

#: apps/client/src/pages/marketing/pricing/page.tsx:94
msgid "Priority support"
msgstr "Assistance prioritaire"

#: apps/client/src/pages/marketing/help/page.tsx:37
msgid "Privacy and data"
msgstr "Confidentialité et données"

#: apps/client/src/pages/home/components/footer.tsx:195
#: apps/client/src/pages/marketing/privacy/page.tsx:10
#: apps/client/src/pages/marketing/sitemap/page.tsx:100
msgid "Privacy Policy"
msgstr "Politique de confidentialité"

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:164
#: apps/client/src/pages/dashboard/create/page.tsx:379
#: apps/client/src/pages/dashboard/organizations/page.tsx:462
#: apps/client/src/pages/dashboard/organizations/page.tsx:902
#: apps/client/src/pages/dashboard/organizations/page.tsx:971
#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:21
#: apps/client/src/pages/home/sections/features/index.tsx:148
#: apps/client/src/pages/marketing/pricing/page.tsx:61
msgid "Pro"
msgstr "Pro"

#: apps/client/src/pages/home/sections/faq/index.tsx:153
msgid "Pro at 9 € per month: the full AI toolkit"
msgstr "Pro à 9 € par mois : la boîte à outils IA complète"

#: apps/client/src/pages/home/sections/faq/index.tsx:138
#~ msgid "Pro features starting at $4.99/month"
#~ msgstr "Fonctionnalités Pro à partir de 4,99 $/mois"

#: apps/client/src/pages/builder/page.tsx:96
#~ msgid "Pro preview"
#~ msgstr "Aperçu Pro"

#: apps/client/src/pages/dashboard/organizations/page.tsx:146
#~ msgid "Pro seats"
#~ msgstr "Sièges Pro"

#: apps/client/src/pages/home/components/footer.tsx:93
#: apps/client/src/pages/marketing/sitemap/page.tsx:25
msgid "Product"
msgstr "Module"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:32
msgid "Product Manager"
msgstr "Responsable de produit"

#: apps/client/src/components/ai-actions.tsx:105
#: apps/client/src/components/ai-actions.tsx:108
#: apps/client/src/pages/home/sections/templates/index.tsx:163
msgid "Professional"
msgstr "Professionnel"

#: apps/client/src/pages/home/sections/hero/index.tsx:126
#~ msgid "Professional Design"
#~ msgstr "Designs professionnels"

#: apps/client/src/pages/home/sections/faq/index.tsx:79
#~ msgid "Professional design created by HR experts"
#~ msgstr "Design professionnel créé par des experts en ressources humaines"

#: apps/client/src/pages/home/sections/features/index.tsx:48
#~ msgid "Professional Network Integration"
#~ msgstr "Intégration de réseau professionnel"

#: apps/client/src/pages/home/sections/hero/index.tsx:48
#~ msgid "professional opportunities"
#~ msgstr "opportunités professionnelles"

#: apps/client/src/pages/home/sections/features/index.tsx:29
#~ msgid "Professional phrasing suggestions tailored to each position"
#~ msgstr "Suggestions de formulation professionnelle adaptées à chaque position"

#: apps/client/src/pages/dashboard/create/page.tsx:313
msgid "Professional title"
msgstr "Titre professionnel"

#: apps/client/src/pages/home/sections/features/index.tsx:55
#~ msgid "Professional Translation"
#~ msgstr "Traduction professionnelle"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:66
msgid "Profile"
msgstr "Profil"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:217
msgid "Profile photo of"
msgstr "Photo de profil de"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:15
msgid "Profiles"
msgstr "Réseaux"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:39
msgid "Projects"
msgstr "Projets"

#: apps/client/src/pages/home/sections/faq/index.tsx:135
msgid "Protecting your data is our absolute priority:"
msgstr "La protection de vos données est notre priorité absolue :"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:64
msgid "Provided by your organization."
msgstr "Fournie par votre organisation."

#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:55
msgid "Public"
msgstr "Public"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:42
msgid "Publications"
msgstr "Publications"

#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:53
msgid "Publisher"
msgstr "Editeur"

#: apps/client/src/pages/dashboard/organizations/page.tsx:698
msgid "Purchased balance"
msgstr "Solde acheté"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:74
#: apps/client/src/pages/dashboard/jobs/page.tsx:184
msgid "Quantified impact"
msgstr "Impact chiffré"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:158
msgid "Quantified results ({0})"
msgstr "Résultats chiffrés ({0})"

#: apps/client/src/pages/builder/sidebars/right/sections/interview-practice.tsx:59
msgid "Question {0} of {1}"
msgstr "Question {0} sur {1}"

#: apps/client/src/pages/marketing/contact/page.tsx:18
msgid "Questions, feedback or partnership? The Izicvs team typically replies within 24 hours on business days."
msgstr "Questions, retours ou partenariat ? L'équipe Izicvs répond généralement sous 24 heures les jours ouvrés."

#: apps/client/src/pages/marketing/contact/page.tsx:26
msgid "Questions, feedback, or just saying hello? The Izicvs team is here for you and typically replies within 24 hours on business days."
msgstr "Des questions, des retours ou simplement envie de dire bonjour ? L'équipe Izicvs est là pour vous et répond généralement sous 24 heures les jours ouvrés."

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:69
msgid "Raise an issue"
msgstr "Signaler un problème"

#: apps/client/src/pages/marketing/pricing/page.tsx:328
msgid "Reached your monthly AI allowance? Buy token packs on any plan, including Free. Purchased tokens never expire, and organizations top up a shared pool for their whole cohort."
msgstr "Vous avez atteint votre allocation IA mensuelle ? Achetez des packs de tokens sur n'importe quel plan, y compris Gratuit. Les tokens achetés n'expirent jamais, et les organisations rechargent une réserve partagée pour toute leur cohorte."

#: apps/client/src/pages/marketing/ats-checker/page.tsx:38
msgid "Readability check"
msgstr "Vérification de la lisibilité"

#: apps/client/src/pages/home/components/footer.tsx:34
msgid "Ready to boost your career?"
msgstr "Prêt à stimuler votre carrière?"

#: apps/client/src/pages/marketing/about/page.tsx:70
msgid "Ready to find your next role?"
msgstr "Prêt à trouver votre prochain poste ?"

#: apps/client/src/pages/marketing/guides/page.tsx:79
msgid "Ready to put these guides into practice?"
msgstr "Prêt à mettre ces guides en pratique ?"

#: apps/client/src/pages/marketing/feedback/page.tsx:57
msgid "Ready to share your thoughts?"
msgstr "Prêt à partager vos idées ?"

#: apps/client/src/pages/home/sections/services/index.tsx:41
msgid "Real-time Performance Analysis"
msgstr "Analyse des performances en temps réel"

#: apps/client/src/pages/dashboard/jobs/page.tsx:886
msgid "Reassuring signs"
msgstr "Signes rassurants"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:54
msgid "Receive an ATS score plus clear, specific suggestions to improve it."
msgstr "Recevez un score ATS accompagné de suggestions claires et précises pour l'améliorer."

#: apps/client/src/pages/dashboard/resumes/page.tsx:110
msgid "Recently updated"
msgstr "Récemment modifiés"

#: apps/client/src/pages/dashboard/jobs/page.tsx:591
msgid "Recruiter"
msgstr "Recruteur"

#: apps/client/src/pages/home/sections/services/index.tsx:20
msgid "Recruiter-approved Templates"
msgstr "Modèles approuvés par le recruteur"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:351
msgid "Recruiter's verdict"
msgstr "Verdict du recruteur"

#: apps/client/src/pages/dashboard/jobs/page.tsx:878
msgid "Red flags"
msgstr "Signaux d'alerte"

#: apps/client/src/services/resume/print.tsx:29
msgid "Redirecting to the PDF..."
msgstr "Redirection vers le PDF..."

#: apps/client/src/pages/builder/_components/toolbar.tsx:85
msgid "Redo"
msgstr "Rétablir"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:48
msgid "References"
msgstr "Références"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:361
msgid "Refresh now"
msgstr "Actualiser maintenant"

#: apps/client/src/pages/dashboard/jobs/page.tsx:788
#: apps/client/src/pages/dashboard/jobs/page.tsx:835
msgid "Regenerate"
msgstr "Régénérer"

#: apps/client/src/pages/dashboard/applications/page.tsx:233
#: apps/client/src/pages/dashboard/organizations/page.tsx:146
msgid "Rejected"
msgstr "Refusé"

#: apps/client/src/pages/dashboard/organizations/page.tsx:702
msgid "Remaining this month"
msgstr "Restant ce mois-ci"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:46
msgid "Remarkable tool! The ATS analysis allowed me to optimize my resume to pass automatic filters."
msgstr "Un outil remarquable ! L'analyse ATS m'a permis d'optimiser mon CV pour passer des filtres automatiques."

#: apps/client/src/pages/dashboard/opportunities/_components/job-card.tsx:65
msgid "Remote"
msgstr "Télétravail"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-list-item.tsx:100
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:157
msgid "Remove"
msgstr "Supprimer"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:231
msgid "Remove Page"
msgstr "Supprimer la Page"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:111
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:120
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:96
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:163
msgid "Rename"
msgstr "Renommer"

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:152
#~ msgid "Renew Pro to export or share it, or pick a free template below."
#~ msgstr "Renouvelez Pro pour l'exporter ou le partager, ou choisissez un template gratuit ci-dessous."

#: apps/client/src/pages/dashboard/organizations/page.tsx:610
msgid "Renews on {renew}"
msgstr "Renouvellement le {renew}"

#: apps/client/src/pages/marketing/feedback/page.tsx:17
msgid "Report a bug"
msgstr "Signaler un bug"

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:113
msgid "required"
msgstr "requis"

#: apps/client/src/pages/dashboard/jobs/page.tsx:181
msgid "Required keywords"
msgstr "Mots-clés requis"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:290
msgid "required keywords matched"
msgstr "mots-clés requis trouvés"

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:199
msgid "Resend email confirmation link"
msgstr "Renvoyer l'e-mail de confirmation"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:152
msgid "Reset"
msgstr "Réinitialiser"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:201
msgid "Reset Layout"
msgstr "Réinitialiser la mise en page"

#: apps/client/src/pages/auth/reset-password/page.tsx:60
#: apps/client/src/pages/auth/reset-password/page.tsx:65
msgid "Reset your password"
msgstr "Réinitialiser votre mot de passe"

#: apps/client/src/pages/builder/_components/toolbar.tsx:120
msgid "Reset Zoom"
msgstr "Réinitialiser le zoom"

#: apps/client/src/pages/home/components/footer.tsx:134
#: apps/client/src/pages/marketing/sitemap/page.tsx:52
msgid "Resources"
msgstr "Documentation"

#: apps/client/src/pages/dashboard/applications/page.tsx:142
#: apps/client/src/pages/dashboard/jobs/page.tsx:467
#: apps/client/src/pages/dashboard/jobs/page.tsx:470
#: apps/client/src/pages/dashboard/opportunities/page.tsx:402
msgid "Resume"
msgstr "CV"

#: apps/client/src/pages/dashboard/jobs/page.tsx:616
msgid "Resume Analyst"
msgstr "Analyste CV"

#: apps/client/src/pages/home/components/header.tsx:89
#: apps/client/src/pages/home/components/header.tsx:202
msgid "Resume Analytics"
msgstr "Reprendre Analytics"

#: apps/client/src/pages/marketing/pricing/page.tsx:51
msgid "Resume builder with every template"
msgstr "Créateur de CV avec tous les modèles"

#: apps/client/src/pages/marketing/privacy/page.tsx:23
msgid "Resume content, including the work history, skills, and other details you add to build or analyze your documents."
msgstr "Le contenu du CV, y compris l'historique professionnel, les compétences et les autres détails que vous ajoutez pour créer ou analyser vos documents."

#: apps/client/src/pages/home/sections/templates/index.tsx:388
msgid "Resume scrolling"
msgstr "Reprendre le défilement"

#: apps/client/src/pages/home/components/footer.tsx:110
msgid "Resume Templates"
msgstr "Reprendre les modèles"

#: apps/client/src/pages/dashboard/organizations/page.tsx:253
#: apps/client/src/pages/dashboard/resumes/page.tsx:44
msgid "Resumes"
msgstr "CVs"

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:101
#~ msgid "Review and edit before applying. Automatic submission is coming next — for now, use these answers on the offer."
#~ msgstr "Relisez et modifiez avant de postuler. L'envoi automatique arrive bientôt — pour l'instant, utilisez ces réponses sur l'offre."

#: apps/client/src/pages/dashboard/opportunities/_components/application-dialog.tsx:101
msgid "Review and edit before applying. Automatic submission is coming next. For now, use these answers on the offer."
msgstr "Relisez et modifiez avant de postuler. L'envoi automatique arrive bientôt. Pour l'instant, utilisez ces réponses sur l'offre."

#: apps/client/src/pages/home/sections/features/index.tsx:94
#~ msgid "Rich in features, not in price."
#~ msgstr "Riche en fonctionnalités, pas en prix."

#: apps/client/src/pages/marketing/about/page.tsx:12
msgid "Roles that fit you"
msgstr "Des postes qui vous correspondent"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:138
msgid "Rounded"
msgstr "Arrondi"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:438
msgid "Run a search above to pull in fresh listings from multiple job boards."
msgstr "Lancez une recherche ci-dessus pour récupérer des offres fraîches de plusieurs sites d'emploi."

#: apps/client/src/pages/home/sections/hero/index.tsx:48
msgid "run by AI"
msgstr "pilotée par l'IA"

#: apps/client/src/pages/dashboard/jobs/page.tsx:493
msgid "Run expert analysis"
msgstr "Lancer l'analyse experte"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:112
msgid "Run your resume through the Izicvs ATS checker and fix what is holding you back."
msgstr "Passez votre CV au crible de l'outil ATS d'Izicvs et corrigez ce qui vous freine."

#: apps/client/src/pages/home/sections/testimonials/index.tsx:163
msgid "Satisfaction rate"
msgstr "Taux de satisfaction"

#: apps/client/src/pages/dashboard/organizations/page.tsx:470
msgid "Save changes"
msgstr "Enregistrer"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:180
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:245
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:217
#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:131
msgid "Save Changes"
msgstr "Enregistrer les modifications"

#: apps/client/src/pages/dashboard/organizations/page.tsx:434
msgid "Saved."
msgstr "Enregistré."

#: apps/client/src/pages/home/sections/features/index.tsx:56
msgid "Scam & ghost-job radar"
msgstr "Radar arnaques & offres fantômes"

#: apps/client/src/pages/marketing/pricing/page.tsx:76
msgid "Scam and ghost-job radar"
msgstr "Radar anti-arnaques et anti-offres fantômes"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:168
msgid "Scan the QR code below with your authenticator app to setup 2FA on your account."
msgstr "Scannez le code QR ci-dessous avec votre application d'authentification pour configurer l'A2F sur votre compte."

#. Score or honors for the degree, for example, CGPA or magna cum laude
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:92
msgid "Score"
msgstr "Score"

#: apps/client/src/pages/builder/sidebars/right/sections/interview-practice.tsx:102
msgid "Score my answer"
msgstr "Noter ma réponse"

#: apps/client/src/pages/builder/sidebars/right/sections/interview-practice.tsx:52
msgid "Scoring failed"
msgstr "Échec de la notation"

#: apps/client/src/pages/builder/sidebars/right/sections/interview-practice.tsx:102
msgid "Scoring..."
msgstr "Notation..."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:327
msgid "scraped automatically every 6 hours"
msgstr "scrapées automatiquement toutes les 6 h"

#: apps/client/src/pages/dashboard/jobs/page.tsx:863
msgid "Screen this posting for scam and ghost-job signals."
msgstr "Analysez cette annonce pour repérer arnaques et offres fantômes."

#: apps/client/src/pages/builder/_components/toolbar.tsx:100
msgid "Scroll to Pan"
msgstr "Défilement vers Pan"

#: apps/client/src/pages/builder/_components/toolbar.tsx:100
msgid "Scroll to Zoom"
msgstr "Défilement vers le zoom"

#: apps/client/src/pages/home/sections/templates/index.tsx:497
#~ msgid "Scrolling paused"
#~ msgstr "Défilement en pause"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:107
msgid "Search complete"
msgstr "Recherche terminée"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:127
msgid "Search followed"
msgstr "Recherche suivie"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:111
msgid "Search for a font family"
msgstr "Rechercher une famille de polices"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:126
msgid "Search for a font subset"
msgstr "Rechercher un sous-ensemble de polices"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:139
msgid "Search for a font variant"
msgstr "Rechercher une variante de police"

#: apps/client/src/components/locale-combobox.tsx:41
msgid "Search for a language"
msgstr "Rechercher une langue"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:222
msgid "Search job offers from multiple sources, then analyze any of them against your resume."
msgstr "Recherchez des offres d'emploi sur plusieurs sources, puis analysez-les face à votre CV."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:303
msgid "Search offers"
msgstr "Rechercher des offres"

#: apps/client/src/pages/dashboard/resumes/page.tsx:91
msgid "Search resumes"
msgstr "Rechercher un CV"

#: apps/client/src/pages/marketing/about/page.tsx:50
msgid "Searching for work should not feel like a second job. We built Izicvs to give every candidate the tools that were once reserved for insiders: clear signal on where to apply, resumes tuned to each role, and a calm way to manage it all. Our goal is simple. Help you spend less time on busywork and more time getting hired."
msgstr "Chercher du travail ne devrait pas ressembler à un second emploi. Nous avons créé Izicvs pour donner à chaque candidat les outils autrefois réservés aux initiés : un signal clair sur les endroits où postuler, des CV adaptés à chaque poste et une façon sereine de tout gérer. Notre objectif est simple : vous aider à passer moins de temps sur les tâches fastidieuses et plus de temps à décrocher un emploi."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:303
msgid "Searching..."
msgstr "Recherche en cours..."

#: apps/client/src/pages/dashboard/organizations/page.tsx:752
msgid "Seats"
msgstr "Sièges"

#: apps/client/src/pages/home/sections/features/index.tsx:63
#~ msgid "Secure storage and complete history of your resumes"
#~ msgstr "Stockage sécurisé et historique complet de vos curriculum vitae"

#: apps/client/src/pages/home/sections/faq/index.tsx:140
msgid "Secure storage and guaranteed confidentiality"
msgstr "Stockage sécurisé et confidentialité garantie"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:65
#: apps/client/src/pages/marketing/privacy/page.tsx:42
msgid "Security"
msgstr "Sécurité"

#: apps/client/src/pages/home/sections/hero/index.tsx:103
msgid "See how it works"
msgstr "Voir comment ça marche"

#: apps/client/src/pages/marketing/ats-checker/page.tsx:111
msgid "See how your resume scores"
msgstr "Découvrez le score de votre CV"

#: apps/client/src/pages/home/sections/hero/index.tsx:103
#~ msgid "See our success rates"
#~ msgstr "Voir nos taux de réussite"

#: apps/client/src/pages/dashboard/opportunities/page.tsx:161
msgid "Select a resume to match against first."
msgstr "Sélectionnez d'abord un CV de référence."

#: apps/client/src/pages/dashboard/organizations/page.tsx:188
#~ msgid "Select an organization to manage its seats."
#~ msgstr "Sélectionnez une organisation pour gérer ses sièges."

#: apps/client/src/pages/auth/forgot-password/page.tsx:104
msgid "Send Email"
msgstr "Envoyer l'e-mail"

#: apps/client/src/pages/marketing/contact/page.tsx:90
msgid "Send feedback"
msgstr "Envoyer un commentaire"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:74
msgid "Send me a message"
msgstr "M'envoyer un message"

#: apps/client/src/pages/marketing/feedback/page.tsx:60
msgid "Send us an email or reach out through our contact page. We read everything."
msgstr "Envoyez-nous un e-mail ou contactez-nous via notre page de contact. Nous lisons tout."

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:97
msgid "Separate Links"
msgstr "Liens séparés"

#: apps/client/src/pages/home/sections/features/index.tsx:72
#~ msgid "Set it once — it works while you sleep."
#~ msgstr "Configurez une fois — ça tourne pendant que vous dormez."

#: apps/client/src/pages/home/sections/features/index.tsx:72
msgid "Set it once. It works while you sleep."
msgstr "Configurez une fois. Ça travaille pendant que vous dormez."

#: apps/client/src/pages/marketing/help/page.tsx:13
msgid "Set up your account and take your first steps with Izicvs."
msgstr "Configurez votre compte et faites vos premiers pas avec Izicvs."

#: apps/client/src/components/user-options.tsx:32
#: apps/client/src/pages/dashboard/_components/sidebar.tsx:140
#: apps/client/src/pages/dashboard/organizations/page.tsx:443
#: apps/client/src/pages/dashboard/organizations/page.tsx:725
#: apps/client/src/pages/dashboard/settings/page.tsx:17
#: apps/client/src/pages/dashboard/settings/page.tsx:27
msgid "Settings"
msgstr "Paramètres"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:159
msgid "Setup two-factor authentication on your account"
msgstr "Configurer l'authentification à deux facteurs sur votre compte"

#: apps/client/src/pages/marketing/contact/page.tsx:83
msgid "Share a suggestion"
msgstr "Partager une suggestion"

#: apps/client/src/pages/marketing/feedback/page.tsx:22
msgid "Share what you love"
msgstr "Partagez ce que vous appréciez"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:109
#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:38
#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:39
msgid "Sharing"
msgstr "Partager"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:364
msgid "Shortlist"
msgstr "Retenu"

#: apps/client/src/pages/dashboard/jobs/page.tsx:190
msgid "Shortlisted"
msgstr "Retenu"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:106
msgid "Show"
msgstr "Afficher"

#: apps/client/src/pages/builder/sidebars/right/sections/interview-practice.tsx:129
msgid "Show a model answer"
msgstr "Voir une réponse modèle"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:78
msgid "Show Break Line"
msgstr "Afficher la ligne de saut"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:91
msgid "Show Page Numbers"
msgstr "Afficher le numéro de page"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:248
msgid "Sidebar"
msgstr "Panneau latéral"

#: apps/client/src/pages/auth/backup-otp/page.tsx:103
#: apps/client/src/pages/auth/login/page.tsx:127
#: apps/client/src/pages/auth/verify-otp/page.tsx:92
msgid "Sign in"
msgstr "Se connecter"

#: apps/client/src/pages/auth/register/page.tsx:77
msgid "Sign in now"
msgstr "Se connecter maintenant"

#: apps/client/src/pages/auth/login/page.tsx:55
#: apps/client/src/pages/auth/login/page.tsx:60
msgid "Sign in to your account"
msgstr "Se connecter à votre compte"

#: apps/client/src/pages/auth/register/page.tsx:182
msgid "Sign up"
msgstr "S'inscrire"

#: apps/client/src/pages/auth/login/page.tsx:74
msgid "Signing in via email is currently disabled by the administrator."
msgstr "La connexion par e-mail est actuellement désactivée par l'administrateur."

#: apps/client/src/pages/auth/register/page.tsx:85
msgid "Signups are currently disabled by the administrator."
msgstr "Les inscriptions sont actuellement désactivées par l'administrateur."

#: apps/client/src/pages/marketing/pricing/page.tsx:123
msgid "Simple pricing that grows with your search"
msgstr "Une tarification simple qui évolue avec votre recherche"

#: apps/client/src/pages/home/components/footer.tsx:268
#: apps/client/src/pages/marketing/sitemap/page.tsx:16
msgid "Sitemap"
msgstr "Plan du site"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:65
msgid "Size (in px)"
msgstr "Taille (en px)"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:24
msgid "Skills"
msgstr "Compétences"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:228
msgid "Slug"
msgstr "Slug"

#: apps/client/src/pages/home/sections/services/index.tsx:34
msgid "Smart Job Offer Adaptability"
msgstr "Adaptabilité de l'offre de Job Intelligent"

#: apps/client/src/pages/home/components/header.tsx:82
#: apps/client/src/pages/home/components/header.tsx:194
msgid "Smart Templates"
msgstr "Modèles intelligents"

#: apps/client/src/pages/marketing/cookies/page.tsx:27
msgid "Some cookies may be set by trusted third party services that we use, for example analytics and authentication providers. These partners process data on our behalf and under agreements that protect your information."
msgstr "Certains cookies peuvent être déposés par des services tiers de confiance que nous utilisons, par exemple des fournisseurs d'analyse et d'authentification. Ces partenaires traitent les données pour notre compte et dans le cadre d'accords qui protègent vos informations."

#: apps/client/src/services/errors/translate-error.ts:55
msgid "Something went wrong while grabbing a preview your resume. Please try again later or raise an issue on GitHub."
msgstr "Une erreur s'est produite lors de la récupération d'un aperçu de votre CV. Veuillez réessayer plus tard ou signaler un problème sur GitHub."

#: apps/client/src/services/errors/translate-error.ts:52
msgid "Something went wrong while printing your resume. Please try again later or raise an issue on GitHub."
msgstr "Une erreur s'est produite lors de la récupération d'un aperçu de votre CV. Veuillez réessayer plus tard ou signaler un problème sur GitHub."

#: apps/client/src/services/errors/translate-error.ts:58
msgid "Something went wrong while processing your request. Please try again later or raise an issue on GitHub."
msgstr "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer plus tard ou signaler un problème sur GitHub."

#: apps/client/src/pages/home/sections/testimonials/index.tsx:36
msgid "Sophia Rodriguez"
msgstr "Sophia Rodriguez"

#: apps/client/src/pages/marketing/feedback/page.tsx:18
msgid "Spotted something off? Let us know so we can fix it fast."
msgstr "Vous avez remarqué un problème ? Faites-le nous savoir pour que nous puissions le corriger rapidement."

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:87
#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:132
msgid "Square"
msgstr "Carré"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:152
msgid "Standard sections present"
msgstr "Sections standard présentes"

#: apps/client/src/pages/marketing/pricing/page.tsx:268
msgid "Start a team"
msgstr "Créer une équipe"

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/create-card.tsx:32
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/create-item.tsx:21
#~ msgid "Start building from scratch"
#~ msgstr "Commencez à partir de zéro"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:185
msgid "Start building your resume by giving it a name."
msgstr "Commencez à créer votre CV en lui donnant un nom."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:165
msgid "Start bullets with verbs like led, built, increased."
msgstr "Commencez vos puces par des verbes comme dirigé, conçu, augmenté."

#: apps/client/src/pages/home/sections/hero/index.tsx:96
#: apps/client/src/pages/home/sections/testimonials/index.tsx:242
#: apps/client/src/pages/marketing/about/page.tsx:72
#: apps/client/src/pages/marketing/pricing/page.tsx:48
msgid "Start for free"
msgstr "Commencer gratuitement"

#: apps/client/src/pages/home/page.tsx:68
msgid "Start free with the resume builder, job search and tracker. Pro is 9 EUR per month for the full AI toolkit and Autopilot is 19 EUR per month for the autonomous agent. Cancel anytime."
msgstr "Commencez gratuitement avec le créateur de CV, la recherche d'offres et le suivi. Le forfait Pro est à 9 EUR par mois pour toute la boîte à outils IA et Autopilot à 19 EUR par mois pour l'agent autonome. Annulez à tout moment."

#: apps/client/src/pages/marketing/pricing/page.tsx:103
msgid "Start free, then upgrade to Pro or Autopilot when you want the AI to do the heavy lifting. Cancel anytime."
msgstr "Commencez gratuitement, puis passez à Pro ou Autopilot quand vous voulez que l'IA fasse le gros du travail. Annulez à tout moment."

#: apps/client/src/pages/home/sections/faq/index.tsx:150
msgid "Start free, upgrade only when you want more:"
msgstr "Commencez gratuitement, passez à une formule supérieure uniquement lorsque vous voulez plus :"

#: apps/client/src/pages/marketing/pricing/page.tsx:124
msgid "Start free. Upgrade when you want the AI to do the heavy lifting. Cancel anytime."
msgstr "Commencez gratuitement. Passez à une formule supérieure lorsque vous voulez que l'IA se charge du plus gros du travail. Annulez à tout moment."

#: apps/client/src/pages/dashboard/create/page.tsx:203
msgid "Start from scratch"
msgstr "Partir de zéro"

#: apps/client/src/pages/dashboard/resumes/_components/empty-state.tsx:16
msgid "Start from scratch, let the AI draft it, or import an existing one."
msgstr "Partez de zéro, laissez l'IA le rédiger, ou importez-en un existant."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:116
#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:22
#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:23
msgid "Statistics"
msgstr "Statistiques"

#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:38
msgid "Statistics are available only for public resumes."
msgstr "Les statistiques ne sont disponibles que pour les CV publics."

#: apps/client/src/pages/marketing/help/page.tsx:72
msgid "Still need help?"
msgstr "Besoin d'aide supplémentaire ?"

#: apps/client/src/pages/home/sections/hero/index.tsx:68
msgid "Stop applying blind. Apply smart."
msgstr "Arrêtez de postuler à l'aveugle. Postulez intelligemment."

#: apps/client/src/pages/home/sections/features/index.tsx:30
#~ msgid "Stop scrolling — see your best matches first."
#~ msgstr "Arrêtez de scroller — vos meilleures offres d'abord."

#: apps/client/src/pages/home/sections/features/index.tsx:30
msgid "Stop scrolling. See your best matches first."
msgstr "Arrêtez de scroller. Vos meilleures offres d'abord."

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:162
msgid "Store your backup codes securely"
msgstr "Stockez vos codes de sauvegarde en toute sécurité"

#: apps/client/src/pages/dashboard/jobs/page.tsx:597
#: apps/client/src/pages/dashboard/jobs/page.tsx:628
msgid "Strengths"
msgstr "Points forts"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:164
msgid "Strong action verbs ({0})"
msgstr "Verbes d'action forts ({0})"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:36
msgid "Subscription"
msgstr "Abonnement"

#: apps/client/src/pages/dashboard/_components/billing-return.tsx:29
msgid "Subscription active"
msgstr "Abonnement activé"

#: apps/client/src/pages/marketing/terms/page.tsx:25
msgid "Subscriptions and billing"
msgstr "Abonnements et facturation"

#: apps/client/src/pages/marketing/feedback/page.tsx:12
msgid "Suggest a feature"
msgstr "Suggérer une fonctionnalité"

#: apps/client/src/pages/dashboard/jobs/page.tsx:640
msgid "Suggested edits"
msgstr "Retouches suggérées"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:382
msgid "Suggested improvements"
msgstr "Améliorations suggérées"

#: apps/client/src/pages/home/sections/faq/index.tsx:92
#~ msgid "Suggesting professional phrasing"
#~ msgstr "Suggestions de formulation professionnelle"

#: apps/client/src/pages/home/components/footer.tsx:233
#: apps/client/src/pages/marketing/feedback/page.tsx:30
#: apps/client/src/pages/marketing/sitemap/page.tsx:88
msgid "Suggestions"
msgstr "Suggestions"

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:101
#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:95
#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:129
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:138
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:114
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:129
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:95
#: apps/client/src/pages/builder/sidebars/left/dialogs/references.tsx:81
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:109
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:12
msgid "Summary"
msgstr "Profil"

#: apps/client/src/pages/home/components/footer.tsx:210
msgid "Support"
msgstr "Support"

#: apps/client/src/pages/home/sections/faq/index.tsx:124
#~ msgid "Support for country-specific resume formats"
#~ msgstr "Prise en charge des formats de CV spécifiques à chaque pays"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:18
msgid "Support the app by donating what you can!"
msgstr "Soutenez l'application en donnant ce que vous pouvez !"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:85
msgid "System"
msgstr "Système"

#: apps/client/src/pages/home/sections/features/index.tsx:22
#~ msgid "Tailor every detail of your resume with a platform built to align with your profile, goals, and market expectations"
#~ msgstr "Personnalisez chaque détail de votre CV grâce à une plateforme pensée pour s'aligner sur votre profil, vos objectifs et les attentes du marché."

#: apps/client/src/pages/marketing/guides/page.tsx:28
msgid "Tailor your resume to each job"
msgstr "Adaptez votre CV à chaque offre"

#: apps/client/src/pages/marketing/about/page.tsx:17
msgid "Tailored in seconds"
msgstr "Adapté en quelques secondes"

#: apps/client/src/pages/home/sections/features/index.tsx:42
msgid "Tailored resume & cover letter"
msgstr "CV adapté & lettre de motivation"

#: apps/client/src/pages/marketing/pricing/page.tsx:74
msgid "Tailored resume and cover letter per job"
msgstr "CV et lettre de motivation adaptés à chaque offre"

#: apps/client/src/pages/dashboard/jobs/page.tsx:372
msgid "Tailored resume created"
msgstr "CV adapté créé"

#: apps/client/src/pages/dashboard/jobs/page.tsx:743
msgid "Tailoring your resume..."
msgstr "Adaptation de votre CV..."

#: apps/client/src/pages/marketing/pricing/page.tsx:233
msgid "Teams & Organizations"
msgstr "Équipes et organisations"

#: apps/client/src/pages/dashboard/create/page.tsx:235
msgid "Tell us about yourself"
msgstr "Parlez-nous de vous"

#: apps/client/src/pages/marketing/feedback/page.tsx:23
msgid "Tell us what works well so we can keep building on it."
msgstr "Dites-nous ce qui fonctionne bien pour que nous puissions continuer à nous appuyer dessus."

#: apps/client/src/pages/marketing/feedback/page.tsx:13
msgid "Tell us what would make Izicvs better for your job search."
msgstr "Dites-nous ce qui rendrait Izicvs meilleur pour votre recherche d'emploi."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:67
#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:119
#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:120
msgid "Template"
msgstr "Modèle"

#: apps/client/src/pages/home/components/header.tsx:101
#: apps/client/src/pages/home/components/header.tsx:213
#: apps/client/src/pages/marketing/sitemap/page.tsx:39
msgid "Templates"
msgstr "Modèles"

#: apps/client/src/pages/home/sections/faq/index.tsx:123
#~ msgid "Templates adapted to international standards"
#~ msgstr "Modèles adaptés aux standards internationaux"

#: apps/client/src/pages/dashboard/_components/billing-return.tsx:27
msgid "Templates pass active"
msgstr "Pass modèles activé"

#: apps/client/src/pages/home/sections/templates/index.tsx:209
msgid "Templates that make you stand out"
msgstr "Modèles qui vous font ressortir"

#: apps/client/src/pages/marketing/terms/page.tsx:40
msgid "Termination"
msgstr "Résiliation"

#: apps/client/src/pages/home/components/footer.tsx:203
#: apps/client/src/pages/marketing/sitemap/page.tsx:105
#: apps/client/src/pages/marketing/terms/page.tsx:10
msgid "Terms of Use"
msgstr "Conditions d’utilisation"

#: apps/client/src/pages/home/components/footer.tsx:127
msgid "Testimonials"
msgstr "Témoignages"

#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:103
msgid "Text Color"
msgstr "Couleur du texte"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:14
msgid "Thanks to this resume builder, I landed 3 interviews in a week. The ATS-friendly format made all the difference."
msgstr "Grâce à ce constructeur de curriculum vitae, j'ai atterri 3 entretiens en une semaine et le format adapté à l'ATS a fait toute la différence."

#: apps/client/src/pages/dashboard/create/page.tsx:296
msgid "The essentials"
msgstr "L'essentiel"

#: apps/client/src/pages/marketing/pricing/page.tsx:65
msgid "The full AI toolkit to apply smarter and stand out."
msgstr "La boîte à outils IA complète pour postuler plus intelligemment et vous démarquer."

#: apps/client/src/pages/public/error.tsx:17
msgid "The page you're looking for doesn't exist."
msgstr "La page que vous cherchez n'existe pas."

#: apps/client/src/pages/home/sections/features/index.tsx:71
msgid "The platform re-scrapes your saved searches around the clock and alerts you to the best new jobs."
msgstr "La plateforme relance vos recherches suivies en continu et vous alerte des meilleures nouvelles offres."

#: apps/client/src/pages/home/sections/features/index.tsx:50
msgid "The real application form, pre-filled by AI and ready to submit in one click."
msgstr "Le vrai formulaire de candidature, pré-rempli par l'IA et prêt à envoyer en un clic."

#: apps/client/src/pages/public/error.tsx:29
msgid "The request was invalid."
msgstr "La requête est invalide."

#: apps/client/src/services/errors/translate-error.ts:49
msgid "The resume you want to update is locked, please unlock if you wish to make any changes to it."
msgstr "Le CV que vous souhaitez mettre à jour est verrouillé, veuillez le déverrouiller si vous souhaitez y apporter des modifications."

#: apps/client/src/pages/marketing/terms/page.tsx:11
msgid "The rules for using Izicvs."
msgstr "Les règles d'utilisation d'Izicvs."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:88
#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:19
#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:20
#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:79
msgid "Theme"
msgstr "Thème"

#: apps/client/src/services/errors/translate-error.ts:40
msgid "There was an error connecting to the browser. Please make sure 'chrome' is running and reachable."
msgstr "Une erreur s'est produite lors de la connexion au navigateur. Veuillez vous assurer que 'chrome' fonctionne et est accessible."

#: apps/client/src/pages/dashboard/organizations/page.tsx:834
msgid "They inherit your plan"
msgstr "Ils héritent de votre plan"

#: apps/client/src/pages/marketing/cookies/page.tsx:26
msgid "Third party cookies"
msgstr "Cookies tiers"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:130
msgid "This action can be reverted by clicking on the undo button in the floating toolbar."
msgstr "Cette action peut être annulée en cliquant sur le bouton Annuler dans la barre d'outils flottante."

#: apps/client/src/components/confirm-delete.tsx:30
msgid "This action cannot be undone."
msgstr "Cette action est irréversible."

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:151
msgid "This action cannot be undone. This will permanently delete your resume and cannot be recovered."
msgstr "Cette action ne peut être annulée. Votre CV sera définitivement supprimé et ne pourra pas être récupéré."

#: apps/client/src/services/errors/translate-error.ts:16
msgid "This email address is associated with an OAuth account. Please sign in with your OAuth provider."
msgstr "Cette adresse e-mail est associée à un compte OAuth. Veuillez vous connecter avec votre fournisseur OAuth."

#: apps/client/src/pages/builder/_components/header.tsx:42
msgid "This resume is locked, please unlock to make further changes."
msgstr "Ce CV est verrouillé, veuillez le déverrouiller pour effectuer d'autres modifications."

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:44
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:48
msgid "This resume is locked."
msgstr "Ce CV est verrouillé."

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:151
#~ msgid "This resume uses a Pro template."
#~ msgstr "Ce CV utilise un template Pro."

#: apps/client/src/pages/builder/sidebars/right/sections/notes.tsx:23
msgid "This section is reserved for your personal notes specific to this resume. The content here remains private and is not shared with anyone else."
msgstr "Cette section est réservée à vos notes personnelles spécifiques à ce CV. Le contenu ici reste privé et n’est partagé avec personne d’autre."

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:126
#~ msgid "This template is part of the Pro plan"
#~ msgstr "Ce modèle fait partie du plan Pro"

#: apps/client/src/pages/dashboard/create/page.tsx:281
#: apps/client/src/pages/dashboard/resumes/_dialogs/ai-generate.tsx:83
msgid "This uses your AI allowance. Pro and Autopilot get more."
msgstr "Cela utilise votre allocation IA. Pro et Autopilot en ont plus."

#: apps/client/src/pages/home/sections/testimonials/index.tsx:28
msgid "Thomas Chen"
msgstr "Thomas Chen"

#: apps/client/src/pages/home/sections/features/index.tsx:22
msgid "Thousands of jobs from Adzuna, Remotive and the official ATS boards (Greenhouse, Lever, Ashby) of top companies."
msgstr "Des milliers d'offres depuis Adzuna, Remotive et les ATS officiels (Greenhouse, Lever, Ashby) des meilleures entreprises."

#: apps/client/src/pages/home/sections/testimonials/index.tsx:192
msgid "Thousands of professionals have transformed their careers with our ATS-optimized resumes. Discover their stories."
msgstr "Des milliers de professionnels ont transformé leur carrière avec nos CV optimisés pour l'ATS."

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:216
msgid "Tip: You can name the resume referring to the position you are applying for."
msgstr "Astuce : Vous pouvez nommer le CV en faisant référence au poste pour lequel vous postulez."

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:39
msgctxt "Name of the Award"
msgid "Title"
msgstr "Titre"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:196
msgid "Title"
msgstr "Titre"

#: apps/client/src/pages/dashboard/applications/page.tsx:229
#: apps/client/src/pages/dashboard/organizations/page.tsx:142
msgid "To apply"
msgstr "À postuler"

#: apps/client/src/pages/marketing/privacy/page.tsx:31
msgid "To generate analyses, suggestions, and job matches, we send relevant resume and job data to trusted AI providers that process it on our behalf. This data is not used to train third party models, and it is never resold. Processing is limited to delivering the features you request."
msgstr "Pour générer des analyses, des suggestions et des correspondances d'emploi, nous transmettons les données pertinentes relatives à votre CV et aux offres à des fournisseurs d'IA de confiance qui les traitent pour notre compte. Ces données ne sont pas utilisées pour entraîner des modèles tiers, et elles ne sont jamais revendues. Le traitement se limite à fournir les fonctionnalités que vous demandez."

#: apps/client/src/pages/marketing/terms/page.tsx:38
msgid "To the maximum extent permitted by law, Izicvs and Nextilabs are not liable for indirect, incidental, or consequential damages arising from your use of the service. Our total liability is limited to the amount you paid us in the twelve months before the claim."
msgstr "Dans toute la mesure permise par la loi, Izicvs et Nextilabs ne sauraient être tenus responsables des dommages indirects, accessoires ou consécutifs découlant de votre utilisation du service. Notre responsabilité totale est limitée au montant que vous nous avez payé au cours des douze mois précédant la réclamation."

#: apps/client/src/pages/home/components/header.tsx:147
msgid "Toggle navigation menu"
msgstr "Afficher/Fermer le menu de navigation"

#: apps/client/src/pages/builder/_components/toolbar.tsx:134
msgid "Toggle Page Break Line"
msgstr "Basculer la ligne de saut de page"

#: apps/client/src/pages/builder/_components/toolbar.tsx:146
msgid "Toggle Page Numbers"
msgstr "Afficher les numéros de page"

#: apps/client/src/pages/dashboard/_components/billing-return.tsx:24
msgid "Tokens added"
msgstr "Tokens ajoutés"

#: apps/client/src/pages/dashboard/organizations/page.tsx:516
msgid "Tokens used across all members"
msgstr "Tokens utilisés par tous les membres"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:174
msgid "Too long: trim toward 1000 words."
msgstr "Trop long : réduisez vers 1000 mots."

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:173
msgid "Too short: aim for 150 to 1000 words."
msgstr "Trop court : visez 150 à 1000 mots."

#: apps/client/src/pages/dashboard/opportunities/_components/job-card.tsx:107
msgid "Track"
msgstr "Suivre"

#: apps/client/src/pages/home/sections/features/index.tsx:37
#~ msgid "Track and optimize your job search strategy"
#~ msgstr "Suivez et optimisez votre stratégie de recherche d'emploi"

#: apps/client/src/pages/dashboard/applications/page.tsx:274
msgid "Track every application through its pipeline, from \"to apply\" to \"offer\"."
msgstr "Suivez chaque candidature dans son pipeline, de « à postuler » à « offre »."

#: apps/client/src/pages/dashboard/jobs/page.tsx:536
msgid "Track this application"
msgstr "Suivre cette candidature"

#: apps/client/src/pages/home/components/header.tsx:203
msgid "Track your performance"
msgstr "Suivez vos performances"

#: apps/client/src/pages/home/sections/services/index.tsx:42
msgid "Track your resume's open rate and receive improvement tips based on job market data."
msgstr "Suivez le taux d’ouverture de votre curriculum vitae et recevez des conseils d’amélioration en fonction des données du marché de l’emploi."

#: apps/client/src/pages/dashboard/jobs/page.tsx:536
#: apps/client/src/pages/dashboard/opportunities/_components/job-card.tsx:96
msgid "Tracked"
msgstr "Suivie"

#: apps/client/src/pages/home/sections/hero/index.tsx:46
#~ msgid "Transform your applications into"
#~ msgstr "Transformez vos candidatures en"

#: apps/client/src/pages/home/sections/features/index.tsx:56
#~ msgid "Translations respecting business context and cultural nuances"
#~ msgstr "Traductions respectant le contexte des affaires et les nuances culturelles"

#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:60
msgid "Trial"
msgstr "Essai"

#: apps/client/src/pages/marketing/contact/page.tsx:54
msgid "Trouble with your account, billing, or a feature? Our support team will help you sort it out quickly."
msgstr "Un problème avec votre compte, votre facturation ou une fonctionnalité ? Notre équipe d'assistance vous aidera à le résoudre rapidement."

#: apps/client/src/pages/marketing/guides/page.tsx:24
msgid "Turn flat job duties into results-driven achievements that show your impact and grab a hiring manager's attention."
msgstr "Transformez des tâches banales en réalisations axées sur les résultats qui montrent votre impact et attirent l'attention d'un recruteur."

#: apps/client/src/pages/marketing/about/page.tsx:28
msgid "Turn on the optional autonomous agent and let Izicvs search, tailor, and apply on your behalf while you stay in control."
msgstr "Activez l'agent autonome optionnel et laissez Izicvs rechercher, adapter et postuler pour vous tout en gardant le contrôle."

#: apps/client/src/pages/auth/verify-otp/page.tsx:52
#: apps/client/src/pages/auth/verify-otp/page.tsx:57
#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:129
msgid "Two-Factor Authentication"
msgstr "Authentification à deux facteurs"

#: apps/client/src/services/errors/translate-error.ts:31
msgid "Two-factor authentication is already enabled for this account."
msgstr "L'authentification à deux facteurs est déjà activée pour ce compte."

#: apps/client/src/services/errors/translate-error.ts:28
msgid "Two-factor authentication is not enabled for this account."
msgstr "L'authentification à deux facteurs n'est pas activée pour ce compte."

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:84
msgid "Type <0>delete</0> to confirm deleting your account."
msgstr "Tapez <0>supprimer</0> pour confirmer la suppression de votre compte."

#. For example, Bachelor's Degree or Master's Degree
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:54
msgid "Type of Study"
msgstr "Type d'étude"

#: apps/client/src/pages/builder/sidebars/right/sections/interview-practice.tsx:89
msgid "Type your answer (STAR: situation, task, action, result)..."
msgstr "Tapez votre réponse (STAR : situation, tâche, action, résultat)..."

#: apps/client/src/pages/marketing/cookies/page.tsx:19
msgid "Types we use"
msgstr "Les types que nous utilisons"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:81
#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:76
#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:77
msgid "Typography"
msgstr "Typographie"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:203
msgid "Underline Links"
msgstr "Souligner les liens"

#: apps/client/src/pages/marketing/help/page.tsx:38
msgid "Understand how we protect and handle your information."
msgstr "Comprenez comment nous protégeons et traitons vos informations."

#: apps/client/src/pages/marketing/guides/page.tsx:44
msgid "Understand your worth and use clear, professional tactics to negotiate salary, benefits, and terms with ease."
msgstr "Prenez conscience de votre valeur et utilisez des tactiques claires et professionnelles pour négocier salaire, avantages et conditions en toute aisance."

#: apps/client/src/pages/builder/_components/toolbar.tsx:72
msgid "Undo"
msgstr "Annuler"

#: apps/client/src/pages/dashboard/organizations/page.tsx:197
msgid "Unknown company"
msgstr "Entreprise inconnue"

#: apps/client/src/pages/marketing/pricing/page.tsx:52
#~ msgid "Unlimited AI actions"
#~ msgstr "Actions IA illimitées"

#: apps/client/src/pages/marketing/pricing/page.tsx:52
msgid "Unlimited PDF exports"
msgstr "Exports PDF illimités"

#: apps/client/src/pages/marketing/pricing/page.tsx:77
msgid "Unlimited resumes"
msgstr "CV illimités"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:52
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:133
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:115
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:172
msgid "Unlock"
msgstr "Déverrouiller"

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:74
msgid "Unlock for 2,99 € / week"
msgstr "Débloquer pour 2,99 € / semaine"

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:45
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:49
msgid "Unlock it to make changes."
msgstr "Déverrouillez-le pour le modifier."

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:45
msgid "Unlock premium templates"
msgstr "Débloquez les templates premium"

#: apps/client/src/pages/marketing/pricing/page.tsx:308
msgid "Unlock templates"
msgstr "Débloquer les templates"

#: apps/client/src/pages/dashboard/jobs/page.tsx:441
msgid "Unlock the full expert panel and AI-tailored resumes."
msgstr "Débloquez le panel d'experts complet et les CV adaptés par l'IA."

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:44
msgid "Unlocking a resume will allow you to make changes to it again."
msgstr "Le déverrouillage d'un CV vous permettra de le modifier à nouveau."

#: apps/client/src/pages/dashboard/organizations/page.tsx:196
msgid "Untitled role"
msgstr "Poste sans titre"

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:192
msgid "Unverified"
msgstr "Non vérifié"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:164
msgid "Update an existing item"
msgstr "Mettre à jour un élément existant"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:179
msgid "Update an existing resume"
msgstr "Mettre à jour un CV existant"

#: apps/client/src/pages/home/sections/features/index.tsx:50
#~ msgid "Update your resume with one click"
#~ msgstr "Mettez à jour votre CV en un seul clic"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:251
#: apps/client/src/pages/dashboard/settings/_sections/subscription.tsx:90
msgid "Upgrade to Pro"
msgstr "Passer au plan Pro"

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:127
#~ msgid "Upgrade to Pro to use it on your resume."
#~ msgstr "Passez au plan Pro pour l'utiliser sur votre CV."

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:212
msgid "Upload a file from one of the accepted sources to parse existing data and import it into Izicvs for easier editing."
msgstr "Téléchargez un fichier à partir de l'une des sources acceptées pour analyser les données existantes et importez-le dans My Live CV pour une édition plus facile."

#: apps/client/src/pages/marketing/ats-checker/page.tsx:46
msgid "Upload a file or select a resume you already built in Izicvs."
msgstr "Téléversez un fichier ou sélectionnez un CV que vous avez déjà créé dans Izicvs."

#: apps/client/src/pages/dashboard/organizations/page.tsx:106
msgid "Upload failed"
msgstr "Échec de l'envoi"

#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:73
msgid "URL"
msgstr "URL"

#: apps/client/src/pages/marketing/privacy/page.tsx:24
msgid "Usage data, such as pages viewed, features used, device information, and general analytics about how you interact with the product."
msgstr "Les données d'utilisation, telles que les pages consultées, les fonctionnalités utilisées, les informations sur l'appareil et les analyses générales sur la façon dont vous interagissez avec le produit."

#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:48
msgid "Use every premium design on your resume, export and share it freely."
msgstr "Utilisez tous les designs premium sur votre CV, exportez-le et partagez-le librement."

#: apps/client/src/pages/dashboard/create/page.tsx:264
msgid "Use this example"
msgstr "Utiliser cet exemple"

#: apps/client/src/pages/auth/backup-otp/page.tsx:52
#: apps/client/src/pages/auth/backup-otp/page.tsx:57
msgid "Use your backup code"
msgstr "Utilisez votre code de secours"

#: apps/client/src/services/errors/translate-error.ts:13
msgid "User does not have an associated 'secrets' record. Please report this issue on GitHub."
msgstr "L'utilisateur n'a pas d'enregistrement de « secrets » associé. Veuillez signaler ce problème sur GitHub."

#: apps/client/src/pages/auth/register/page.tsx:122
#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:55
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:167
msgid "Username"
msgstr "Nom d’utilisateur"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:24
msgid "UX Designer"
msgstr "Concepteur UX"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:292
msgid "Validate"
msgstr "Valider"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:310
msgid "Validated"
msgstr "Validé"

#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:90
msgid "Value"
msgstr "Valeur"

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:192
msgid "Verified"
msgstr "Vérifié"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:184
msgid "Verified testimonials"
msgstr "Témoignages vérifiés"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:161
msgid "Verify that two-factor authentication has been setup correctly"
msgstr "Vérifiez que l'authentification à deux facteurs a été correctement configurée"

#: apps/client/src/pages/auth/verify-email/page.tsx:43
#: apps/client/src/pages/auth/verify-email/page.tsx:48
msgid "Verify your email address"
msgstr "Vérifier votre adresse e-mail"

#: apps/client/src/pages/dashboard/opportunities/_components/job-card.tsx:130
msgid "View offer"
msgstr "Voir l'offre"

#: apps/client/src/pages/dashboard/organizations/page.tsx:135
#~ msgid "View resumes"
#~ msgstr "Voir les CV"

#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:51
msgid "Views"
msgstr "Vues"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-list-item.tsx:87
msgid "Visible"
msgstr "Visible"

#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:63
msgid "Visit <0>Phosphor Icons</0> for a list of available icons"
msgstr "Visitez le site <0>Phosphor Icons</0> pour obtenir une liste des icônes disponibles."

#: apps/client/src/pages/marketing/contact/page.tsx:75
msgid "Visit the Help Center"
msgstr "Consulter le centre d'aide"

#: apps/client/src/pages/marketing/pricing/page.tsx:264
msgid "Volume pricing for bootcamps and universities."
msgstr "Tarifs volume pour bootcamps et universités."

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-label.ts:45
msgid "Volunteering"
msgstr "Bénévolat"

#: apps/client/src/pages/marketing/pricing/page.tsx:295
msgid "Want a premium design without the full plan? Unlock every premium template for 2,99 € / week. Cancel anytime. Pro and Autopilot already include them."
msgstr "Envie d'un design premium sans le plan complet ? Débloquez tous les templates premium pour 2,99 € / semaine. Résiliable à tout moment. Pro et Autopilot les incluent déjà."

#: apps/client/src/pages/marketing/privacy/page.tsx:43
msgid "We apply technical and organizational measures, including encryption in transit, access controls, and regular reviews, to protect your data. No system is perfectly secure, but we work continuously to keep your information safe."
msgstr "Nous appliquons des mesures techniques et organisationnelles, notamment le chiffrement en transit, des contrôles d'accès et des vérifications régulières, pour protéger vos données. Aucun système n'est parfaitement sûr, mais nous travaillons en continu pour assurer la sécurité de vos informations."

#: apps/client/src/pages/home/sections/faq/index.tsx:135
#~ msgid "We believe in pricing transparency:"
#~ msgstr "Nous croyons à la transparence des prix :"

#: apps/client/src/pages/marketing/privacy/page.tsx:20
msgid "We collect the following categories of information so that we can provide and improve our services:"
msgstr "Nous collectons les catégories d'informations suivantes afin de fournir et d'améliorer nos services :"

#: apps/client/src/pages/marketing/privacy/page.tsx:34
msgid "We do not sell your personal data. We share information only with service providers and processors who help us operate Izicvs, such as hosting, analytics, and AI processing partners, and only under agreements that protect your data. We may also disclose information where required by law."
msgstr "Nous ne vendons pas vos données personnelles. Nous ne partageons vos informations qu'avec des prestataires de services et des sous-traitants qui nous aident à exploiter Izicvs, tels que des partenaires d'hébergement, d'analyse et de traitement par l'IA, et uniquement dans le cadre d'accords qui protègent vos données. Nous pouvons également divulguer des informations lorsque la loi l'exige."

#: apps/client/src/pages/marketing/ats-checker/page.tsx:24
msgid "We flag columns, tables, images, and fonts that trip up parsers so your resume stays machine readable."
msgstr "Nous signalons les colonnes, tableaux, images et polices qui perturbent les analyseurs afin que votre CV reste lisible par les machines."

#: apps/client/src/pages/marketing/about/page.tsx:43
msgid "We help you land the job, not just build a resume"
msgstr "Nous vous aidons à décrocher le poste, pas seulement à créer un CV"

#: apps/client/src/pages/marketing/privacy/page.tsx:37
msgid "We keep your information for as long as your account is active or as needed to provide the service. When you delete your account, we remove or anonymize your personal data within a reasonable period, unless we are required to retain it for legal or security reasons."
msgstr "Nous conservons vos informations tant que votre compte est actif ou aussi longtemps que nécessaire pour fournir le service. Lorsque vous supprimez votre compte, nous supprimons ou anonymisons vos données personnelles dans un délai raisonnable, sauf si nous sommes tenus de les conserver pour des raisons légales ou de sécurité."

#: apps/client/src/pages/marketing/terms/page.tsx:44
msgid "We may update these Terms of Use as the service and legal requirements evolve. When we make significant changes, we will update this page so you can review the current version."
msgstr "Nous pouvons mettre à jour ces Conditions d'utilisation à mesure que le service et les exigences légales évoluent. Lorsque nous apportons des modifications importantes, nous mettons à jour cette page afin que vous puissiez consulter la version actuelle."

#: apps/client/src/pages/marketing/cookies/page.tsx:33
msgid "We may update this Cookie Policy as our practices evolve. When we make changes, we will update this page so you can review the current version."
msgstr "Nous pouvons mettre à jour cette Politique relative aux cookies à mesure que nos pratiques évoluent. Lorsque nous apportons des modifications, nous mettons à jour cette page afin que vous puissiez consulter la version actuelle."

#: apps/client/src/pages/marketing/privacy/page.tsx:28
msgid "We use your information to create and manage your account, generate resume analyses and job matches, provide customer support, secure the platform, and improve our features. We may also use it to communicate service updates and, where you have consented, product news."
msgstr "Nous utilisons vos informations pour créer et gérer votre compte, générer des analyses de CV et des correspondances d'emploi, fournir une assistance client, sécuriser la plateforme et améliorer nos fonctionnalités. Nous pouvons également les utiliser pour communiquer des mises à jour du service et, lorsque vous y avez consenti, des actualités sur le produit."

#: apps/client/src/pages/auth/verify-email/page.tsx:61
msgid "We verify your email address only to ensure that we can send you a password reset link in case you forget your password."
msgstr "Nous vérifions votre adresse électronique uniquement pour nous assurer que nous pouvons vous envoyer un lien de réinitialisation du mot de passe au cas où vous l'oublieriez."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:128
msgid "We'll scrape it automatically and alert you to new offers."
msgstr "Nous la scraperons automatiquement et vous alerterons des nouvelles offres."

#: apps/client/src/pages/dashboard/jobs/page.tsx:634
msgid "Weaknesses"
msgstr "Points faibles"

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:87
#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:81
#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:115
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:124
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:100
#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:69
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:115
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:81
#: apps/client/src/pages/builder/sidebars/left/dialogs/references.tsx:67
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:95
#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:69
msgid "Website"
msgstr "Site Web"

#: apps/client/src/pages/dashboard/jobs/page.tsx:123
#~ msgid "Welcome to Pro!"
#~ msgstr "Bienvenue dans le Pro !"

#: apps/client/src/pages/marketing/cookies/page.tsx:16
msgid "What are cookies"
msgstr "Que sont les cookies"

#: apps/client/src/pages/home/sections/faq/index.tsx:87
#~ msgid "What are the benefits of AI in resume creation?"
#~ msgstr "Quels sont les avantages de l’AI en création de curriculum vitae ?"

#: apps/client/src/pages/home/sections/faq/index.tsx:132
#~ msgid "What are the prices?"
#~ msgstr "Quels sont les tarifs ?"

#: apps/client/src/pages/dashboard/jobs/page.tsx:704
msgid "What changed"
msgstr "Ce qui a changé"

#: apps/client/src/pages/home/page.tsx:65
#: apps/client/src/pages/home/sections/faq/index.tsx:147
msgid "What does it cost?"
msgstr "Combien ça coûte ?"

#: apps/client/src/pages/home/page.tsx:41
#: apps/client/src/pages/home/sections/faq/index.tsx:102
msgid "What does the autonomous agent do?"
msgstr "Que fait l'agent autonome ?"

#: apps/client/src/pages/marketing/about/page.tsx:55
msgid "What makes Izicvs different"
msgstr "Ce qui distingue Izicvs"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:227
msgid "What the ATS reads"
msgstr "Ce que lit l'ATS"

#: apps/client/src/pages/dashboard/jobs/page.tsx:197
msgid "Worth checking"
msgstr "À vérifier"

#: apps/client/src/pages/builder/sidebars/right/sections/interview-practice.tsx:38
msgid "Write a fuller answer before scoring."
msgstr "Rédigez une réponse plus complète avant de noter."

#: apps/client/src/pages/marketing/guides/page.tsx:23
msgid "Write bullet points that get interviews"
msgstr "Rédigez des puces qui décrochent des entretiens"

#: apps/client/src/pages/dashboard/jobs/page.tsx:799
msgid "Writing your letter..."
msgstr "Rédaction de votre lettre..."

#: apps/client/src/pages/home/sections/faq/index.tsx:120
msgid "Yes, every application lives on a simple board:"
msgstr "Oui, chaque candidature figure sur un tableau simple :"

#: apps/client/src/pages/home/page.tsx:52
msgid "Yes. Every application lives on a Kanban board from \"to apply\" to \"offer\", with drag and drop, duplicate detection, and a link back to each job and its analysis."
msgstr "Oui. Chaque candidature vit sur un tableau Kanban, de « à postuler » à « offre », avec glisser-déposer, détection des doublons et un lien vers chaque offre et son analyse."

#: apps/client/src/pages/marketing/terms/page.tsx:29
msgid "You agree not to misuse Izicvs, including by attempting to disrupt the service, access it without authorization, submit unlawful or infringing content, or use it in a way that violates the rights of others or applicable laws."
msgstr "Vous acceptez de ne pas faire un usage abusif d'Izicvs, notamment en tentant de perturber le service, d'y accéder sans autorisation, de soumettre un contenu illégal ou contrefaisant, ou de l'utiliser d'une manière qui viole les droits d'autrui ou les lois applicables."

#: apps/client/src/pages/dashboard/organizations/page.tsx:192
#~ msgid "You are a member of this organization."
#~ msgstr "Vous êtes membre de cette organisation."

#: apps/client/src/pages/dashboard/organizations/page.tsx:797
msgid "You are a member of this organization. Only admins manage seats and settings."
msgstr "Vous êtes membre de cette organisation. Seuls les admins gèrent les sièges et les réglages."

#: apps/client/src/pages/dashboard/organizations/page.tsx:235
#~ msgid "You are a member of this organization. Only admins manage seats."
#~ msgstr "Vous êtes membre de cette organisation. Seuls les admins gèrent les sièges."

#: apps/client/src/pages/dashboard/_components/impersonation-banner.tsx:26
#~ msgid "You are managing {0}'s account."
#~ msgstr "Vous gérez le compte de {0}."

#: apps/client/src/pages/dashboard/_components/impersonation-banner.tsx:32
msgid "You are managing {memberName}'s account."
msgstr "Vous gérez le compte de {memberName}."

#: apps/client/src/pages/public/error.tsx:26
msgid "You are not authorized to access this page."
msgstr "Vous n'êtes pas autorisé à accéder à cette page."

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:164
#: apps/client/src/pages/builder/sidebars/left/dialogs/interests.tsx:68
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:164
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:114
msgid "You can add multiple keywords by separating them with a comma or pressing enter."
msgstr "Vous pouvez ajouter plusieurs mots-clés en les séparant par une virgule ou en appuyant sur la touche Entrée."

#: apps/client/src/pages/auth/login/page.tsx:99
msgid "You can also enter your username."
msgstr "Vous pouvez également saisir votre nom d'utilisateur."

#: apps/client/src/pages/marketing/cookies/page.tsx:30
msgid "You can control and delete cookies through your browser settings, and you can adjust your choices using the preference controls we provide. Please note that blocking essential cookies may prevent parts of Izicvs from working correctly."
msgstr "Vous pouvez contrôler et supprimer les cookies via les paramètres de votre navigateur, et vous pouvez ajuster vos choix à l'aide des commandes de préférences que nous mettons à votre disposition. Veuillez noter que le blocage des cookies essentiels peut empêcher certaines parties d'Izicvs de fonctionner correctement."

#: apps/client/src/pages/dashboard/jobs/page.tsx:373
msgid "You can find it in My Resumes."
msgstr "Vous le retrouverez dans Mes CV."

#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:40
msgid "You can track the number of views your resume has received, or how many people have downloaded the resume by enabling public sharing."
msgstr "Vous pouvez suivre le nombre de vues que votre CV a reçues ou le nombre de personnes qui ont téléchargé le CV en activant le partage public."

#: apps/client/src/pages/public/error.tsx:20
msgid "You don't have permission to access this page."
msgstr "Vous n'avez pas l'autorisation d'accéder à cette page."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:52
msgid "You have unlimited AI actions."
msgstr "Vous avez des actions IA illimitées."

#: apps/client/src/pages/marketing/terms/page.tsx:41
msgid "You may stop using Izicvs and delete your account at any time. We may suspend or terminate access if you violate these terms or if we need to protect the service and its users."
msgstr "Vous pouvez cesser d'utiliser Izicvs et supprimer votre compte à tout moment. Nous pouvons suspendre ou résilier l'accès si vous enfreignez ces conditions ou si nous devons protéger le service et ses utilisateurs."

#: apps/client/src/pages/marketing/terms/page.tsx:23
msgid "You must provide accurate information when creating an account and keep your credentials secure. You are responsible for activity that occurs under your account. You must be of legal age to form a binding contract in your jurisdiction to use Izicvs."
msgstr "Vous devez fournir des informations exactes lors de la création d'un compte et garder vos identifiants en sécurité. Vous êtes responsable de l'activité qui a lieu sous votre compte. Vous devez avoir l'âge légal pour conclure un contrat contraignant dans votre juridiction afin d'utiliser Izicvs."

#: apps/client/src/pages/marketing/terms/page.tsx:32
msgid "You own the resume content and personal information you provide. Izicvs and Nextilabs own the platform, software, design, and brand. We grant you a limited, non exclusive right to use the service, and you grant us the permissions needed to process your content in order to deliver the features you request."
msgstr "Vous êtes propriétaire du contenu de votre CV et des informations personnelles que vous fournissez. Izicvs et Nextilabs sont propriétaires de la plateforme, du logiciel, du design et de la marque. Nous vous accordons un droit limité et non exclusif d'utiliser le service, et vous nous accordez les autorisations nécessaires pour traiter votre contenu afin de fournir les fonctionnalités que vous demandez."

#: apps/client/src/pages/home/sections/faq/index.tsx:110
msgid "You review and approve everything in one batch, nothing is sent without you"
msgstr "Vous vérifiez et approuvez tout en un seul lot, rien n'est envoyé sans vous"

#: apps/client/src/pages/auth/verify-email/page.tsx:50
msgid "You should have received an email from <0>Izicvs</0> with a link to verify your account."
msgstr "Vous devriez avoir reçu un e-mail de <0>My Live CV</0> avec un lien pour vérifier votre compte."

#: apps/client/src/pages/auth/forgot-password/page.tsx:49
#: apps/client/src/pages/auth/forgot-password/page.tsx:54
msgid "You've got mail!"
msgstr "Vous avez un message !"

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:52
msgid "Your account and all your data has been deleted successfully. Goodbye!"
msgstr "Votre compte et toutes vos données ont été supprimés avec succès. Au revoir!"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:71
msgid "Your AI usage is covered by your organization's shared token pool."
msgstr "Votre usage de l'IA est couvert par la réserve de tokens partagée de votre organisation."

#: apps/client/src/pages/marketing/pricing/page.tsx:243
msgid "Your branding and logo"
msgstr "Votre marque et votre logo"

#: apps/client/src/components/copyright.tsx:24
msgid "Your career, powered by AI."
msgstr "Votre carrière, propulsée par l'IA."

#: apps/client/src/pages/home/sections/faq/index.tsx:137
msgid "Your data is never sold"
msgstr "Vos données ne sont jamais vendues"

#: apps/client/src/pages/home/page.tsx:60
msgid "Your data is never sold. AI providers process your content only to generate your results, storage is secure, and you can export or delete your data on request under the GDPR."
msgstr "Vos données ne sont jamais vendues. Les fournisseurs d'IA traitent votre contenu uniquement pour générer vos résultats, le stockage est sécurisé, et vous pouvez exporter ou supprimer vos données sur demande, conformément au RGPD."

#: apps/client/src/pages/auth/verify-email/page.tsx:28
msgid "Your email address has been verified successfully."
msgstr "Votre adresse e-mail a été vérifiée avec succès."

#: apps/client/src/pages/home/sections/hero/index.tsx:46
msgid "Your entire job search,"
msgstr "Toute votre recherche d'emploi,"

#: apps/client/src/pages/marketing/feedback/page.tsx:32
msgid "Your ideas guide what we build next. Share them and help us make Izicvs better."
msgstr "Vos idées guident ce que nous construisons ensuite. Partagez-les et aidez-nous à améliorer Izicvs."

#: apps/client/src/pages/dashboard/organizations/page.tsx:922
msgid "Your organizations"
msgstr "Vos organisations"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:56
msgid "Your password has been updated successfully."
msgstr "Votre mot de passe a été mis à jour."

#: apps/client/src/pages/dashboard/jobs/page.tsx:1005
msgid "Your past analyses"
msgstr "Vos analyses passées"

#: apps/client/src/pages/dashboard/_components/billing-return.tsx:29
msgid "Your plan has been updated."
msgstr "Votre formule a été mise à jour."

#: apps/client/src/pages/home/sections/features/index.tsx:70
#~ msgid "Your privacy, your peace of mind"
#~ msgstr "Votre intimité, votre tranquillité d'esprit"

#: apps/client/src/pages/builder/sidebars/right/sections/ats.tsx:231
msgid "Your resume is empty."
msgstr "Votre CV est vide."

#: apps/client/src/pages/dashboard/create/page.tsx:417
msgid "Your resume preview will appear here."
msgstr "L'aperçu de votre CV apparaîtra ici."

#: apps/client/src/pages/marketing/privacy/page.tsx:39
msgid "Your rights"
msgstr "Vos droits"

#: apps/client/src/pages/dashboard/organizations/page.tsx:667
#~ msgid "Your role"
#~ msgstr "Votre rôle"

#: apps/client/src/pages/dashboard/jobs/page.tsx:124
#~ msgid "Your subscription is now active."
#~ msgstr "Votre abonnement est désormais actif."

#: apps/client/src/pages/dashboard/_components/billing-return.tsx:24
msgid "Your token balance has been updated."
msgstr "Votre solde de tokens a été mis à jour."

#: apps/client/src/pages/dashboard/opportunities/page.tsx:240
msgid "Your top matches today"
msgstr "Vos meilleures offres du jour"

#: apps/client/src/pages/home/sections/features/index.tsx:65
msgid "Your whole search, at a glance."
msgstr "Toute votre recherche, en un coup d'œil."

#: apps/client/src/pages/builder/_components/toolbar.tsx:108
msgid "Zoom In"
msgstr "Zoomer"

#: apps/client/src/pages/builder/_components/toolbar.tsx:114
msgid "Zoom Out"
msgstr "Dézoomer"
